webpackJsonp([1],{

/***/ "+PnG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Action__ = __webpack_require__("kG4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__graphql_shopping_list__ = __webpack_require__("C1JH");








/* eslint-disable no-underscore-dangle */

var UpdateNameAction = function (_UndoAction) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(UpdateNameAction, _UndoAction);

  function UpdateNameAction(options) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, UpdateNameAction);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UpdateNameAction.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(UpdateNameAction)).call(this, options));

    _this.value = options.value;
    _this.origName = _this.component.shoppingList.name.slice();
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(UpdateNameAction, [{
    key: '_executeImpl',
    value: function _executeImpl() {
      var self = this;

      return this.component.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_6__graphql_shopping_list__["n" /* UPDATE_NAME */],
        variables: {
          id: this.component.shoppingList.id,
          name: this.value
        },
        update: function update(store, _ref) {
          var shoppingListUpdateName = _ref.data.shoppingListUpdateName;

          self._updateCache(store, shoppingListUpdateName);
        },
        optimisticResponse: function optimisticResponse() {
          var shoppingListUpdateName = {
            __typename: 'ShoppingListUpdateName',
            id: self.component.shoppingList.id,
            name: self.value,
            modifiedAt: null
          };

          return { shoppingListUpdateName: shoppingListUpdateName };
        }
      });
    }

    // eslint-disable-next-line

  }, {
    key: 'updateQuery',
    value: function updateQuery(cachedShoppingList, shoppingListUpdateName) {
      cachedShoppingList.name = shoppingListUpdateName.name;
      return cachedShoppingList;
    }
  }, {
    key: 'undo',
    value: function undo() {
      return this.component.triggerAction(UpdateNameAction, {
        value: this.origName,
        undoAction: this
      });
    }

    // eslint-disable-next-line

  }, {
    key: 'undoTooltip',
    value: function undoTooltip() {
      return 'Undo change name';
    }

    // eslint-disable-next-line

  }, {
    key: 'redoTooltip',
    value: function redoTooltip() {
      return 'Redo change name';
    }
  }], [{
    key: 'name',
    get: function get() {
      return 'UpdateNameAction';
    }
  }]);

  return UpdateNameAction;
}(__WEBPACK_IMPORTED_MODULE_5__Action__["b" /* UndoAction */]);

/* harmony default export */ __webpack_exports__["a"] = (UpdateNameAction);

/***/ }),

/***/ "/9As":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShoppingListItem__ = __webpack_require__("6hpZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'shoppingListItemList',
  props: ['name', 'checked', 'value'],
  data: function data() {
    return {};
  },

  computed: {
    itemListProxy: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  },
  components: {
    ShoppingListItem: __WEBPACK_IMPORTED_MODULE_1__ShoppingListItem__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default.a
  }
});

/***/ }),

/***/ "/KV2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/Uby":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchBar_vue__ = __webpack_require__("cZxk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36140b62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchBar_vue__ = __webpack_require__("6IuE");
function injectStyle (ssrContext) {
  __webpack_require__("jKf8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36140b62"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36140b62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/paj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Action__ = __webpack_require__("kG4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DeleteItemAction__ = __webpack_require__("Ibu+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_ShoppingListItem__ = __webpack_require__("AIPu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_ShoppingListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__shared_ShoppingListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__graphql_shopping_list__ = __webpack_require__("C1JH");












/* eslint-disable no-underscore-dangle */
var dummyId = 0;
function getDummyId() {
  dummyId -= 1;
  return dummyId;
}

var AddItemAction = function (_UndoAction) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(AddItemAction, _UndoAction);

  function AddItemAction(options) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AddItemAction);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AddItemAction.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(AddItemAction)).call(this, options));

    _this.index = options.index;
    _this.item = options.item;
    _this.itemListName = options.itemListName || 'unchecked';
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AddItemAction, [{
    key: '_executeImpl',
    value: function _executeImpl() {
      var _this2 = this;

      // An undo/redo item will have __typename in it, which makes
      // it not a ShoppingListItemInput
      var newItem = new __WEBPACK_IMPORTED_MODULE_9__shared_ShoppingListItem___default.a(this.item);
      var self = this;

      return this.component.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_10__graphql_shopping_list__["a" /* ADD_ITEM */],
        variables: {
          id: this.component.shoppingList.id,
          index: this.index,
          item: newItem,
          itemListName: this.itemListName
        },
        update: function update(store, _ref) {
          var shoppingListAddItem = _ref.data.shoppingListAddItem;

          self._updateCache(store, shoppingListAddItem);
        },
        optimisticResponse: function optimisticResponse() {
          var shoppingListAddItem = {
            __typename: 'ShoppingListAddItemResult',
            item: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, newItem, { id: getDummyId() }),
            modifiedAt: null
          };

          shoppingListAddItem.item.__typename = 'ShoppingListItem';
          return { shoppingListAddItem: shoppingListAddItem };
        }
      }).then(function (result) {
        if (_this2.item.id) {
          // id already set on this item, which means this action
          // was actually the 'redo' of a previous add, so we need
          // to update any other redo actions on this item with the
          // new id
          _this2.component.updateUndoRedoItem({
            oldItem: _this2.item,
            newItem: result.data.shoppingListAddItem.item
          });
        }

        _this2.item = result.data.shoppingListAddItem.item;
        return result;
      });
    }
  }, {
    key: 'updateQuery',
    value: function updateQuery(cachedShoppingList, shoppingListAddItem) {
      if (Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["isNumber"])(this.index)) {
        cachedShoppingList.items[this.itemListName].splice(this.index, 0, shoppingListAddItem.item);
      } else {
        cachedShoppingList.items[this.itemListName].push(shoppingListAddItem.item);
      }

      return cachedShoppingList;
    }
  }, {
    key: 'undo',
    value: function undo() {
      return this.component.triggerAction(__WEBPACK_IMPORTED_MODULE_8__DeleteItemAction__["a" /* default */], {
        index: Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["isNumber"])(this.index) ? this.index : this.component.shoppingList.items[this.itemListName].length - 1,
        itemListName: this.itemListName,
        undoAction: this
      });
    }
  }, {
    key: 'updateItem',
    value: function updateItem(oldItem, newItem) {
      if (this.item.id === oldItem.id) {
        this.item = newItem;
      }
    }

    // eslint-disable-next-line

  }, {
    key: 'undoTooltip',
    value: function undoTooltip() {
      return 'Undo add item';
    }

    // eslint-disable-next-line

  }, {
    key: 'redoTooltip',
    value: function redoTooltip() {
      return 'Redo add item';
    }
  }], [{
    key: 'name',
    get: function get() {
      return 'AddItemAction';
    }
  }]);

  return AddItemAction;
}(__WEBPACK_IMPORTED_MODULE_7__Action__["b" /* UndoAction */]);

/* harmony default export */ __webpack_exports__["a"] = (AddItemAction);

/***/ }),

/***/ "0KBQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__("2R8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__("tlQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_fetch__ = __webpack_require__("Vo7i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__foodItem_types__ = __webpack_require__("rt35");



var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['query FoodItems($types: [TYPE!], $categories: [String!], $sort: SortType) {\n        foodItems(types: $types, categories: $categories, sort: $sort) {\n          id\n          name\n          access\n          type\n          description\n          categories\n          link\n          ... on Restaurant {\n            addrSortValue\n            address {\n              street\n              city\n              state\n              country\n            }\n          }\n        }\n      }'], ['query FoodItems($types: [TYPE!], $categories: [String!], $sort: SortType) {\n        foodItems(types: $types, categories: $categories, sort: $sort) {\n          id\n          name\n          access\n          type\n          description\n          categories\n          link\n          ... on Restaurant {\n            addrSortValue\n            address {\n              street\n              city\n              state\n              country\n            }\n          }\n        }\n      }']);

// Browse view state





var hasLocalStorage = typeof Storage !== 'undefined';

function localStorageKey(key) {
  return 'browse-' + key;
}

function saveToLocalStorage(key, value) {
  if (hasLocalStorage) {
    localStorage[localStorageKey(key)] = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isObject(value) ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(value) : value;
  }
}

function getFromLocalStorage(key, defValue, isObject) {
  if (hasLocalStorage) {
    var val = localStorage[localStorageKey(key)];
    if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isUndefined(val) || __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNull(val)) {
      return defValue;
    } else if (isObject) {
      try {
        return JSON.parse(val);
      } catch (e) {
        return null;
      }
    }

    return val;
  }

  return defValue;
}

function toggleSortOrder(o) {
  if (o === 'asc') {
    return 'desc';
  }

  return 'asc';
}

var state = {
  // Food items to display
  foodItems: [],

  // Sort order
  sort: getFromLocalStorage('sort', {
    field: 'name',
    order: 'asc'
  }, true),

  // Selected categories
  // TODO - put in localstorage
  categories: null,

  // Selected types
  // TODO - put in localstorage
  types: __WEBPACK_IMPORTED_MODULE_5__foodItem_types__["a" /* default */].getTypeIds(),

  // Mode (table or tiles)
  mode: getFromLocalStorage('mode', 'table')
};

var getters = {
  foodItems: function foodItems(s) {
    return s.foodItems;
  },
  sort: function sort(s) {
    return s.sort;
  },
  categories: function categories(s, g, rootState, rootGetters) {
    return s.categories === null ? rootGetters.categoryNames : s.categories;
  },
  types: function types(s) {
    return s.types;
  },
  mode: function mode(s) {
    return s.mode;
  }
};

var mutations = {
  foodItems: function foodItems(s, _foodItems) {
    s.foodItems = _foodItems;
  },
  categories: function categories(s, names) {
    s.categories = names.slice();
  },
  types: function types(s, _types) {
    s.types = _types;
  },
  toggleSort: function toggleSort(s, field) {
    s.sort = {
      field: field,
      order: s.sort.field === field ? toggleSortOrder(s.sort.order) : 'asc'
    };
    saveToLocalStorage('sort', s.sort);
  },
  mode: function mode(s, m) {
    saveToLocalStorage('mode', m);
    s.mode = m;
  }
};

var actions = {
  // eslint-disable-next-line no-shadow
  fetchFoodItems: function fetchFoodItems(_ref) {
    var commit = _ref.commit,
        state = _ref.state;

    return __WEBPACK_IMPORTED_MODULE_4__utils_fetch__["a" /* graphql */].query({
      query: __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default()(_templateObject),
      variables: {
        types: state.types,
        categories: state.categories,
        sort: state.sort
      }
    }).then(function (response) {
      commit('foodItems', response.data.foodItems);
      return response.data.foodItems;
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ "0fFW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.getNotifyMessage().then(function (notify) {
        if (notify) {
          _this.$toast.open(notify);
        }
      });
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['getNotifyMessage']))
});

/***/ }),

/***/ "12wK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[(_vm.id)?_c('h1',{staticClass:"title"},[_vm._v("Edit Restaurant")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.access),expression:"form.access"}],attrs:{"type":"radio","value":"private"},domProps:{"checked":_vm._q(_vm.form.access,"private")},on:{"change":function($event){_vm.$set(_vm.form, "access", "private")}}}),_vm._v("\n      "+_vm._s(_vm.$t('private'))+"\n    ")]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.access),expression:"form.access"}],attrs:{"type":"radio","value":"public"},domProps:{"checked":_vm._q(_vm.form.access,"public")},on:{"change":function($event){_vm.$set(_vm.form, "access", "public")}}}),_vm._v("\n      "+_vm._s(_vm.$t('public'))+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],ref:"name",staticClass:"input",attrs:{"type":"text"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Link")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.link),expression:"form.link"}],ref:"link",staticClass:"input",attrs:{"type":"url"},domProps:{"value":(_vm.form.link)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "link", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Description")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.description),expression:"form.description"}],ref:"description",staticClass:"textarea",domProps:{"value":(_vm.form.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "description", $event.target.value)}}})])]),_vm._v(" "),_c('new-categories',{attrs:{"available":_vm.categoryNames},model:{value:(_vm.form.categories),callback:function ($$v) {_vm.$set(_vm.form, "categories", $$v)},expression:"form.categories"}}),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Address")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.address.street),expression:"form.address.street"}],staticClass:"input",attrs:{"type":"text","placeholder":"Street"},domProps:{"value":(_vm.form.address.street)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.address, "street", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-half"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.address.city),expression:"form.address.city"}],staticClass:"input",attrs:{"type":"text","placeholder":"City"},domProps:{"value":(_vm.form.address.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.address, "city", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.address.state),expression:"form.address.state"}],staticClass:"input",attrs:{"type":"text","placeholder":"State"},domProps:{"value":(_vm.form.address.state)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.address, "state", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.address.country),expression:"form.address.country"}],staticClass:"input",attrs:{"type":"text","placeholder":"Country"},domProps:{"value":(_vm.form.address.country)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.address, "country", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"field is-grouped is-grouped-centered"},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"control"},[_c('a',{staticClass:"button is-warning",on:{"click":_vm.confirmReset}},[_vm._v("\n        Reset\n      ")])]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('a',{staticClass:"button is-light",on:{"click":_vm.goBack}},[_vm._v("\n        Back\n      ")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"control"},[_c('button',{staticClass:"button is-primary",attrs:{"type":"submit"}},[_vm._v("\n        Submit\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1VKL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal",class:{ 'is-active' : _vm.show }},[_c('div',{staticClass:"modal-background",on:{"click":function($event){_vm.$emit('close')}}}),_vm._v(" "),_c('div',{staticClass:"modal-card"},[_c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title truncate"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('button',{staticClass:"delete",attrs:{"aria-label":"close"},on:{"click":function($event){_vm.$emit('close')}}})]),_vm._v(" "),_c('section',{staticClass:"modal-card-body"},[_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.description))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1Z1v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"subtitle is-4"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('draggable',{attrs:{"options":{handle: '.drag-handle'},"move":function (evt) { return _vm.$emit('drag-move', evt); }},on:{"start":function($event){_vm.$emit('drag-start')},"end":function($event){_vm.$emit('drag-end')}},model:{value:(_vm.itemListProxy),callback:function ($$v) {_vm.itemListProxy=$$v},expression:"itemListProxy"}},[_c('transition-group',{attrs:{"name":"items","tag":"div"}},_vm._l((_vm.itemListProxy),function(item,index){return _c('p',{key:item.externalId},[_c('shopping-list-item',{attrs:{"item":item,"checked":_vm.checked,"drag-handle-class":"drag-handle"},on:{"checkbox":function($event){_vm.$emit('checkbox', { index: index, item: item })},"change":function (value) { return _vm.$emit('change', index, item, value); },"delete":function($event){_vm.$emit('delete', index, item)}}})],1)}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2CA7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterSelector_vue__ = __webpack_require__("4S1R");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_654dcd36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterSelector_vue__ = __webpack_require__("JW5F");
function injectStyle (ssrContext) {
  __webpack_require__("o8QF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-654dcd36"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_654dcd36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("9qcu")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2hfY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return toMinutes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fromMinutes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return minsToString; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


function toMinutes(_ref) {
  var days = _ref.days,
      hours = _ref.hours,
      mins = _ref.mins;

  var d = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isString(days) ? parseInt(days, 10) : days;
  var h = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isString(hours) ? parseInt(hours, 10) : hours;
  var m = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isString(mins) ? parseInt(mins, 10) : mins;

  if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNumber(d) || __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNumber(h) || __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNumber(m)) {
    return (d || 0) * 24 * 60 + (h || 0) * 60 + (m || 0);
  }

  return null;
}

function fromMinutes(minutes) {
  if (!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNumber(minutes)) {
    return {
      days: null,
      hours: null,
      mins: null
    };
  }

  var days = 0;
  var hours = 0;
  var mins = minutes;

  if (mins > 59) {
    hours = Math.floor(mins / 60);
    mins -= hours * 60;

    if (hours > 23) {
      days = Math.floor(hours / 24);
      hours -= days * 24;
    }
  }

  return { days: days, hours: hours, mins: mins };
}

function pluralize(val, str) {
  if (val > 1) {
    return str + 's';
  }

  return str;
}

function minsToString(mins) {
  if (!mins) {
    return '';
  }

  var d = 0;
  var h = 0;
  var m = 0;
  var str = '';

  if (mins > 59) {
    h = Math.floor(mins / 60);
    m = mins % 60;

    if (h > 23) {
      d = Math.floor(h / 24);
      h %= 24;
      str = d + ' ' + pluralize(d, 'day') + ' ';

      if (h > 0) {
        str += h + ' ' + pluralize(h, 'hour') + ' ';
      }
    } else {
      str = h + ' ' + pluralize(h, 'hour') + ' ';
    }
  } else {
    m = mins;
  }

  if (m > 0) {
    str += m + ' ' + pluralize(m, 'minute');
  }

  return str;
}



/***/ }),

/***/ "2zmm":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"shoppingList":"Shopping List","lastModified":"Last Modified","clearAll":"Clear All","items":"Items","purchased":"Purchased","newItem":"New Item","clearShoppingList":"Clear Shopping List","confirmClearAll":"Are you sure? You cannot undo this.","receivedUpdate":"Received Update","createNewTitle":"Create New","name":"Name","openTitle":"Open Shopping List","modifiedAt":"Modified","makeDefault":"Make this the default shopping list"},"es":{"shoppingList":"Lista de compras","lastModified":"Última Modificación","clearAll":"Borrar Todo","items":"Artículos","purchased":"Comprado","newItem":"Nuevo Artículo","clearShoppingList":"Borrar Todo","confirmClearAll":"¿Está seguro? Este cambio será permanente.","receivedUpdate":"Actualización recibida","createNewTitle":"Create New","name":"Nombre","openTitle":"Abrir lista de compras","modifiedAt":"Modified","makeDefault":"Make this the default shopping list"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "3+IJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'new-categories',
  props: {
    available: {
      type: Array
    },
    value: { // selected tags
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      newTags: null,
      availTags: this.available.slice(0),
      tagsMeta: this.available.reduce(function (obj, tag) {
        obj[tag] = { orig: true, flash: false };
        return obj;
      }, {}),
      preventChanges: false
    };
  },

  computed: {
    selectedTags: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    selectTag: function selectTag(index, force) {
      if (force || !this.preventChanges) {
        var _selectedTags;

        var selected = this.availTags.splice(index, 1);
        (_selectedTags = this.selectedTags).push.apply(_selectedTags, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(selected));
        this.setFocusOnInput();
      }
    },
    unselectTag: function unselectTag(index) {
      if (!this.preventChanges) {
        var unselected = this.selectedTags.splice(index, 1);
        if (this.tagsMeta[unselected[0]].orig) {
          var _availTags;

          (_availTags = this.availTags).push.apply(_availTags, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(unselected));
        }
        this.setFocusOnInput();
      }
    },
    onNewTags: function onNewTags() {
      var _this = this;

      if (this.preventChanges) {
        return;
      }

      var newTags = this.newTags.toLowerCase().split(/\s+/);
      var newTagsTracker = {};
      var clearText = false;

      newTags.forEach(function (newTagTemp) {
        var newTag = newTagTemp.trim();

        if (newTag && !newTagsTracker[newTag]) {
          newTagsTracker[newTag] = 1;
          var index = _this.availTags.indexOf(newTag);
          if (index >= 0) {
            _this.selectTag(index, true);
            clearText = true;
          } else {
            index = _this.selectedTags.indexOf(newTag);
            if (index < 0) {
              _this.selectedTags.push(newTag);
              __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(_this.tagsMeta, newTag, { orig: false, flash: false });
              clearText = true;
            } else {
              _this.flashTag(_this.selectedTags[index]);
            }
          }
        }
      });

      if (clearText) {
        this.newTags = '';
      } else {
        this.setFocusOnInput();
      }
    },
    setFocusOnInput: function setFocusOnInput() {
      if (!this.isMobile()) {
        var bInput = this.$refs.newTags;
        bInput.focus(); // buefy input supports focus, but not select
        bInput.$el.querySelector('input').select();
      }
    },
    flashTag: function flashTag(tag) {
      var _this2 = this;

      this.preventChanges = true;
      var self = this;

      setTimeout(function () {
        var count = 5;
        var ms = 200;
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(_this2.tagsMeta[tag], 'flash', true);

        var flashTagHelper = function flashTagHelper() {
          __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(_this2.tagsMeta[tag], 'flash', !_this2.tagsMeta[tag].flash);
          count -= 1;
          if (count) {
            setTimeout(flashTagHelper, ms);
          } else {
            self.preventChanges = false;
          }
        };

        setTimeout(flashTagHelper, ms);
      }, 0);
    }
  }
});

/***/ }),

/***/ "3KRB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero"},[_c('div',{staticClass:"hero-body"},[(_vm.restaurant)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-narrow"},[_c('h1',{staticClass:"title"},[_vm._v("\n            "+_vm._s(_vm.restaurant.name)+"\n            "),(_vm.restaurant.link)?_c('a',{staticClass:"mwf-link",attrs:{"href":_vm.restaurant.link,"target":"_blank"}},[_c('span',{staticClass:"icon"},[_c('font-awesome-icon',{attrs:{"icon":"external-link-alt"}})],1)]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"button is-white",on:{"click":function($event){_vm.routeEditFoodItem({ type: 'Restaurant', id: _vm.id })}}},[_c('b-icon',{attrs:{"pack":"fas","icon":"pencil-alt","size":"is-small"}})],1),_vm._v(" "),_c('button',{staticClass:"button is-white",on:{"click":_vm.deleteRestaurant}},[_c('b-icon',{attrs:{"pack":"fas","icon":"trash-alt","size":"is-small"}})],1)]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("Restaurant")]),_vm._v(" "),_c('div',{staticClass:"tags"},_vm._l((_vm.restaurant.categories),function(cat){return _c('span',{key:cat,staticClass:"tag is-info"},[_vm._v("\n              "+_vm._s(cat)+"\n            ")])})),_vm._v(" "),_c('div',[(_vm.restaurant.address && _vm.restaurant.address.city)?_c('a',{attrs:{"href":_vm.addrHref(_vm.restaurant),"target":"_blank"}},[_vm._v(_vm._s(_vm.addrString(_vm.restaurant.address)))]):[_vm._v(_vm._s(_vm.addrString(_vm.restaurant.address)))]],2)]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('div',{staticStyle:{"white-space":"pre-line"}},[_vm._v("\n            "+_vm._s(_vm.restaurant.description)+"\n          ")])])]),_vm._v(" "),_c('hr')]):(_vm.error)?_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v("Invalid restaurant id")])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3iax":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Restaurant_vue__ = __webpack_require__("sLiY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_daa3f6fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Restaurant_vue__ = __webpack_require__("3KRB");
function injectStyle (ssrContext) {
  __webpack_require__("dChq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-daa3f6fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Restaurant_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_daa3f6fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Restaurant_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4S1R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome__ = __webpack_require__("U0v6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_i18n__ = __webpack_require__("i94f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__foodItem_types__ = __webpack_require__("rt35");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'filter-selector',
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__["mixin"], __WEBPACK_IMPORTED_MODULE_2__mixins_i18n__["a" /* default */]],
  props: {
    selectedTypes: {
      default: []
    },
    selectedCategories: {
      default: []
    }
  },
  data: function data() {
    return {
      isOpen: false,
      newSelectedTypes: this.selectedTypes,
      newSelectedCategories: this.selectedCategories,
      selectAll: false
    };
  },

  methods: {
    toggleIsOpen: function toggleIsOpen() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.newSelectedTypes = this.selectedTypes;
        this.newSelectedCategories = this.selectedCategories;
        this.updateSelectAll();
      }
    },
    ok: function ok() {
      this.$emit('ok', this.newSelectedTypes, this.newSelectedCategories);
      this.isOpen = false;
    },
    cancel: function cancel() {
      this.newSelectedTypes = this.selectedTypes.slice(0);
      this.newSelectedCategories = this.selectedCategories.slice(0);
      this.isOpen = false;
    },
    selectAllChanged: function selectAllChanged() {
      if (this.selectAll) {
        this.newSelectedCategories = this.categoryNames.slice(0);
      } else {
        this.newSelectedCategories = [];
      }
    },
    categoryClicked: function categoryClicked() {
      this.updateSelectAll();
    },
    updateSelectAll: function updateSelectAll() {
      this.selectAll = this.newSelectedCategories.length === this.categoryNames.length;
    }
  },
  computed: {
    categoryNames: function categoryNames() {
      return this.$store.getters.categoryNames;
    },
    types: function types() {
      return __WEBPACK_IMPORTED_MODULE_3__foodItem_types__["a" /* default */];
    }
  },
  components: {
    'font-awesome-icon': __WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome___default.a
  }
});

/***/ }),

/***/ "4wna":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('nav',{staticClass:"navbar has-shadow"},[(_vm.user)?[_c('div',{staticClass:"navbar-brand"},[_c('router-link',{staticClass:"navbar-item",attrs:{"to":"/"}},[_c('img',{staticClass:"is-hidden-mobile",attrs:{"src":__webpack_require__("TrFT"),"alt":"Me Want Food"}}),_vm._v(" "),_c('img',{staticClass:"is-hidden-tablet",attrs:{"width":"85px","src":__webpack_require__("TrFT"),"alt":"Me Want Food"}})]),_vm._v(" "),_c('div',{staticClass:"navbar-item search-size"},[_c('search-bar',{attrs:{"matchesFound":_vm.typeaheadResults,"placeholder":_vm.$t('search')},on:{"getMatches":_vm.onGetMatches,"match":_vm.onSearchMatch}})],1),_vm._v(" "),_c('div',{staticClass:"navbar-burger burger",class:{ 'is-active': _vm.burgerIsActive },on:{"click":_vm.toggleNav}},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])],1),_vm._v(" "),_c('div',{staticClass:"navbar-menu",class:{ 'is-active': _vm.burgerIsActive },attrs:{"id":"appNavBar"}},[_c('div',{staticClass:"navbar-start"},[_c('div',{staticClass:"navbar-item has-dropdown is-hoverable is-hidden-desktop"},[_c('p',{staticClass:"navbar-link"},[_vm._v(_vm._s(_vm.$t('welcome'))+" "),_c('strong',[_vm._v(_vm._s(_vm.user.firstName))])]),_vm._v(" "),_c('div',{staticClass:"navbar-dropdown"},[(_vm.locale !== 'en')?_c('a',{staticClass:"navbar-item",attrs:{"role":"button"},on:{"click":function($event){_vm.setLocale('en')}}},[_vm._m(0),_vm._v("\n                  English\n                ")]):_vm._e(),_vm._v(" "),(_vm.locale !== 'es')?_c('a',{staticClass:"navbar-item",attrs:{"role":"button"},on:{"click":function($event){_vm.setLocale('es')}}},[_vm._m(1),_vm._v("\n                  Español\n                ")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"navbar-item",on:{"click":_vm.onLogout}},[_c('b-icon',{staticClass:"menu-icon",attrs:{"icon":"sign-out-alt"}}),_vm._v("\n                  "+_vm._s(_vm.$t('logout'))+"\n                ")],1)])]),_vm._v(" "),_c('hr',{staticClass:"dropdown-divider is-hidden-desktop"}),_vm._v(" "),(_vm.$route.name === 'browse')?[_c('browse-app-toolbar')]:(_vm.$route.name === 'shoppingList')?[_c('shopping-list-app-toolbar')]:[_c('new-app-toolbar')]],2),_vm._v(" "),_c('div',{staticClass:"navbar-end is-hidden-touch"},[_c('div',{staticClass:"navbar-item has-dropdown is-hoverable"},[_c('p',{staticClass:"navbar-link"},[_vm._v(_vm._s(_vm.$t('welcome'))+" "),_c('strong',[_vm._v(_vm._s(_vm.user.firstName))])]),_vm._v(" "),_c('div',{staticClass:"navbar-dropdown"},[(_vm.locale !== 'en')?_c('a',{staticClass:"navbar-item",attrs:{"role":"button"},on:{"click":function($event){_vm.setLocale('en')}}},[_vm._m(2),_vm._v("\n                  English\n                ")]):_vm._e(),_vm._v(" "),(_vm.locale !== 'es')?_c('a',{staticClass:"navbar-item",attrs:{"role":"button"},on:{"click":function($event){_vm.setLocale('es')}}},[_vm._m(3),_vm._v("\n                  Español\n                ")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"navbar-item",on:{"click":_vm.onLogout}},[_c('b-icon',{staticClass:"menu-icon",attrs:{"icon":"sign-out-alt"}}),_vm._v("\n                  "+_vm._s(_vm.$t('logout'))+"\n                ")],1)])])])])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"section"},[_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[_c('router-view')],1)],1),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"is-hidden-tablet",attrs:{"id":"mwfIsMobile"}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"menu-flag-icon"},[_c('span',{staticClass:"flag-icon flag-icon-us"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"menu-flag-icon"},[_c('span',{staticClass:"flag-icon flag-icon-ec"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"menu-flag-icon"},[_c('span',{staticClass:"flag-icon flag-icon-us"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"menu-flag-icon"},[_c('span',{staticClass:"flag-icon flag-icon-ec"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer is-primary"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content has-text-centered"},[_c('p',[_c('strong',[_vm._v("Me Want Food")]),_vm._v(" by David Goldbaum.")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "56Vt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns is-gapless is-mobile"},[(!_vm.editMode)?[_c('div',{staticClass:"column is-narrow scoped-drag-handle",class:_vm.dragHandleClass},[_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"column is-narrow"},[_c('b-checkbox',{model:{value:(_vm.checkedProxy),callback:function ($$v) {_vm.checkedProxy=$$v},expression:"checkedProxy"}})],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('span',{staticClass:"item-description",attrs:{"aria-role":"button"},on:{"click":function($event){$event.preventDefault();return _vm.descriptionClicked($event)}}},[_vm._v(_vm._s(_vm.item.description))]),_vm._v(" "),(_vm.foodItemName)?[_c('div',[_c('a',{staticClass:"is-size-7",attrs:{"role":"button"},on:{"click":function($event){$event.preventDefault();_vm.routeFoodItem({ type: 'Recipe', id: _vm.item.foodItemId })}}},[_vm._v("\n              "+_vm._s(_vm.foodItemName)+"\n            ")])])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"column is-narrow"},[_c('span',{staticClass:"is-pulled-right"},[_c('button',{staticClass:"button is-white",on:{"click":_vm.enterEdit}},[_c('b-icon',{attrs:{"pack":"fas","icon":"pencil-alt","size":"is-small"}})],1),_vm._v(" "),_c('button',{staticClass:"button is-white",on:{"click":function($event){_vm.$emit('delete')}}},[_c('b-icon',{attrs:{"pack":"fas","icon":"trash-alt","size":"is-small"}})],1)])])]:[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newDescription),expression:"newDescription"}],ref:"input",staticClass:"input",attrs:{"type":"text","placeholder":_vm.item.description},domProps:{"value":(_vm.newDescription)},on:{"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.completeEdit($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }return _vm.cancelEdit($event)}],"input":function($event){if($event.target.composing){ return; }_vm.newDescription=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"column is-narrow"},[_c('span',{staticClass:"is-pulled-right"},[_c('button',{staticClass:"button is-white",on:{"click":_vm.completeEdit}},[_c('b-icon',{attrs:{"pack":"fas","icon":"check","size":"is-small"}})],1),_vm._v(" "),_c('button',{staticClass:"button is-white",attrs:{"type":"reset"},on:{"click":function($event){_vm.editMode = false}}},[_c('b-icon',{attrs:{"pack":"fas","icon":"times","size":"is-small"}})],1)])])]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"handle-padding"},[_c('i',{staticClass:"fas fa-ellipsis-v fa-lg"}),_vm._v(" "),_c('i',{staticClass:"fas fa-ellipsis-v fa-lg"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-narrow"},[_c('span',{staticClass:"handle-padding"},[_c('i',{staticClass:"fas fa-ellipsis-v fa-lg"}),_vm._v(" "),_c('i',{staticClass:"fas fa-ellipsis-v fa-lg"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5m/v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    routeFoodItem: function routeFoodItem(_ref) {
      var type = _ref.type,
          id = _ref.id,
          _ref$noBack = _ref.noBack,
          noBack = _ref$noBack === undefined ? false : _ref$noBack;

      var rte = { name: type, params: { id: id } };
      if (noBack) {
        this.$router.replace(rte);
      } else {
        this.$router.push(rte);
      }
    },
    routeEditFoodItem: function routeEditFoodItem(_ref2) {
      var type = _ref2.type,
          id = _ref2.id;

      var name = 'edit-' + type;
      this.$router.push({ name: name, params: { id: id } });
    },
    routeBrowse: function routeBrowse(_ref3) {
      var categories = _ref3.categories,
          component = _ref3.component,
          _ref3$noBack = _ref3.noBack,
          noBack = _ref3$noBack === undefined ? false : _ref3$noBack;

      // TODO don't need component to get to store
      if (categories && component) {
        var cats = typeof categories === 'string' ? [categories] : categories;
        component.$store.commit('browse/categories', cats);
      }

      if (noBack) {
        this.$router.replace({ name: 'browse' });
      } else {
        this.$router.push({ name: 'browse' });
      }
    },
    routeShoppingList: function routeShoppingList(_ref4) {
      var id = _ref4.id,
          _ref4$noBack = _ref4.noBack,
          noBack = _ref4$noBack === undefined ? false : _ref4$noBack;

      var rte = { name: 'shoppingList', params: { id: id } };
      if (noBack) {
        this.$router.replace(rte);
      } else {
        this.$router.push(rte);
      }
    },
    goBack: function goBack() {
      if (this.$store.state.routed) {
        this.$router.back();
      } else {
        this.$router.push({ name: 'browse' });
      }
    }
  }
});

/***/ }),

/***/ "5p5t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5qOA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inherit"}},[(this.$route.name !== 'browse')?_c('router-link',{staticClass:"navbar-item",attrs:{"to":{ name: 'browse' }}},[_c('b-icon',{staticClass:"is-hidden-desktop menu-icon",attrs:{"icon":"table"}}),_vm._v("\n    "+_vm._s(_vm.$t('browse'))+"\n  ")],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5wvU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"action":""}},[_c('div',{staticClass:"modal-card",staticStyle:{"width":"auto"}},[_c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title"},[_vm._v(_vm._s(_vm.$t('createNewTitle')))])]),_vm._v(" "),_c('section',{staticClass:"modal-card-body"},[_c('b-field',{attrs:{"label":_vm.$t('name')}},[_c('b-input',{ref:"listName",attrs:{"type":"text","maxlength":"50","required":""},model:{value:(_vm.listName),callback:function ($$v) {_vm.listName=$$v},expression:"listName"}})],1)],1),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot fix-footer"},[_c('button',{staticClass:"button",attrs:{"type":"button"},on:{"click":function($event){_vm.$parent.close()}}},[_vm._v(_vm._s(_vm.$t('cancelButton')))]),_vm._v(" "),_c('button',{staticClass:"button is-primary",attrs:{"disabled":_vm.listName.trim() === ''},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t('createButton'))+"\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6Ezy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LargeCheckbox_vue__ = __webpack_require__("BgX9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d60db6bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LargeCheckbox_vue__ = __webpack_require__("AarF");
function injectStyle (ssrContext) {
  __webpack_require__("vpeh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d60db6bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LargeCheckbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d60db6bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LargeCheckbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6IuE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vbta"},[_c('input',{ref:"inputBox",staticClass:"input vbta-input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.query},on:{"input":function($event){_vm.query = $event.target.value},"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"delete",[8,46],$event.key,["Backspace","Delete"])){ return null; }_vm.handleDelete($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();_vm.onMatch()},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }$event.preventDefault();return _vm.handleEsc($event)}],"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();_vm.handleKeyDown($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.handleKeyUp($event)}],"blur":_vm.handleBlur}}),_vm._v(" "),_c('div',{class:['vbta-menu', { visible: (_vm.foodItemMatches.length || _vm.categoryMatches.length) && _vm.query }]},[_c('ul',[_vm._l((_vm.foodItemMatches),function(match){return _c('li',{key:match.id,staticClass:"vbta-suggestion",on:{"click":function($event){_vm.onMatch(match)},"mousedown":function($event){$event.preventDefault()},"mouseover":function($event){_vm.handleMouseOver($event)}}},[_c('span',{staticClass:"icon is-size-7"},[_c('font-awesome-icon',{attrs:{"icon":_vm.typeIcon(match.type)}})],1),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(match.match)}})])}),_vm._v(" "),(_vm.foodItemMatches.length && _vm.categoryMatches.length)?_c('hr',{staticClass:"divider",attrs:{"data-divider":"1"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.categoryMatches),function(match){return _c('li',{key:match.id,staticClass:"vbta-suggestion",on:{"click":function($event){_vm.onMatch(match)},"mousedown":function($event){$event.preventDefault()},"mouseover":function($event){_vm.handleMouseOver($event)}}},[_c('span',{staticClass:"icon is-size-7"},[_c('font-awesome-icon',{attrs:{"icon":"filter"}})],1),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(match.match)}})])})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6hpZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingListItem_vue__ = __webpack_require__("vHpf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90098f56_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingListItem_vue__ = __webpack_require__("56Vt");
function injectStyle (ssrContext) {
  __webpack_require__("d1qY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-90098f56"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90098f56_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6nDT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7mLH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8taH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome__ = __webpack_require__("U0v6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'loading',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: 'Loading...'
    }
  },
  components: {
    'font-awesome-icon': __WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome___default.a
  }
});

/***/ }),

/***/ "9SJH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile is-ancestor"},_vm._l((_vm.foodItems),function(fi,fiIndex){return _c('div',{key:fi.id,staticClass:"tile is-parent"},[_c('div',{staticClass:"tile is-child article notification",class:_vm.tileColor(fiIndex)},[_c('p',{staticClass:"title"},[_c('a',{staticClass:"is-size-4-mobile",staticStyle:{"text-decoration":"none"},attrs:{"role":"button"},on:{"click":function($event){_vm.routeFoodItem(fi)}}},[_vm._v(_vm._s(fi.name))]),_vm._v(" "),(fi.link)?_c('a',{attrs:{"href":fi.link,"target":"_blank"}},[_c('span',{staticClass:"icon"},[(_vm.youTubeLink(fi.link))?_c('font-awesome-icon',{attrs:{"icon":['fab', 'youtube']}}):_c('font-awesome-icon',{attrs:{"icon":"external-link-alt"}})],1)]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"subtitle"},[(fi.address && fi.address.city)?_c('a',{attrs:{"href":_vm.addrHref(fi),"target":"_blank"}},[_vm._v(_vm._s(fi.address.city))]):(fi.address)?[_vm._v(_vm._s(_vm.addrString(fi.address)))]:[_vm._v(" ")]],2),_vm._v(" "),_c('p',[_c('span',{staticClass:"icon"},[_c('b-icon',{attrs:{"size":"is-small","icon":_vm.typeIcon(fi.type)}})],1),_vm._v(" "),_c('span',{staticClass:"icon"},[_c('b-icon',{attrs:{"size":"is-small","icon":_vm.accessIcon(fi.access)}})],1)]),_vm._v(" "),(fi.categories)?_c('div',{staticClass:"tags tag-list"},_vm._l((fi.categories),function(c){return _c('span',{key:c,staticClass:"tag tag-border",class:_vm.tileColor(fiIndex)},[_vm._v(_vm._s(c)+"\n        ")])})):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(fi.description))])])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9qcu":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Recipe":"Recipe","Restaurant":"Restaurant"},"es":{"Recipe":"Receta","Restaurant":"Restaurante"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "AIPu":
/***/ (function(module, exports, __webpack_require__) {

var stringHash = __webpack_require__("lOcz");

// Function constructor works for sharing with front-end and back-end,
// ES6 class doesn't without extra build work
function ShoppingListItem(_ref) {
  var id = _ref.id,
      _ref$foodItemId = _ref.foodItemId,
      foodItemId = _ref$foodItemId === undefined ? null : _ref$foodItemId,
      description = _ref.description,
      externalId = _ref.externalId;

  this.id = id;
  this.foodItemId = foodItemId;
  this.description = description;
  this.externalId = externalId;

  if (!description) {
    throw new Error('New shopping list item must have description');
  }

  if (!externalId) {
    var s = description;
    if (foodItemId) {
      s += foodItemId;
    }

    this.externalId = stringHash(s).toString();
  }
}

module.exports = ShoppingListItem;

/***/ }),

/***/ "AarF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.checkboxSide !== 'right')?_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checked),expression:"checked"}],attrs:{"type":"checkbox"},domProps:{"value":_vm.val,"checked":Array.isArray(_vm.checked)?_vm._i(_vm.checked,_vm.val)>-1:(_vm.checked)},on:{"change":[function($event){var $$a=_vm.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.val,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checked=$$c}},_vm.onChange]}}),_vm._v(" "),_c('span',{staticClass:"checkbox-left"}),_vm._v(" "),_c('div',{staticClass:"content-right"},[_vm._t("default")],2)]):_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checked),expression:"checked"}],attrs:{"type":"checkbox"},domProps:{"value":_vm.val,"checked":Array.isArray(_vm.checked)?_vm._i(_vm.checked,_vm.val)>-1:(_vm.checked)},on:{"change":[function($event){var $$a=_vm.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.val,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checked=$$c}},_vm.onChange]}}),_vm._v(" "),_c('span',{staticClass:"checkbox-right"}),_vm._v(" "),_c('div',{staticClass:"content-left"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Aruq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Recipe_vue__ = __webpack_require__("mROJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38dc63c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Recipe_vue__ = __webpack_require__("cKKu");
function injectStyle (ssrContext) {
  __webpack_require__("GtbI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-38dc63c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Recipe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38dc63c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Recipe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "At/H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingListModalNew_vue__ = __webpack_require__("DDCV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01542982_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingListModalNew_vue__ = __webpack_require__("5wvU");
function injectStyle (ssrContext) {
  __webpack_require__("u7lY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01542982"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingListModalNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01542982_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingListModalNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("2zmm")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AwED":
/***/ (function(module, exports) {

module.exports = {"en":{"new":"New","areYouSure":"Are you sure?","clearButton":"Clear","cancelButton":"Cancel","saveButton":"Save","createButton":"Create","openButton":"Open","undo":"Undo","redo":"Redo","browse":"Browse","delete":"Delete","shoppingList":"Shopping List"},"es":{"new":"Nuevo","areYouSure":"¿Está seguro?","clearButton":"Borrar","cancelButton":"Cancelar","saveButton":"Salvar","createButton":"Crear","openButton":"Abrir","undo":"Deshacer","redo":"Rehacer","browse":"Inicio","delete":"Borrar","shoppingList":"Lista de compras"}}

/***/ }),

/***/ "BgX9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'large-checkbox',
  props: {
    checkboxSide: {
      type: String,
      default: 'left'
    },
    value: {},
    val: {}
  },
  data: function data() {
    return {
      checkedProxy: false
    };
  },

  computed: {
    checked: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.checkedProxy = val;
      }
    }
  },
  methods: {
    onChange: function onChange() {
      this.$emit('input', this.checkedProxy);
    }
  }
});

/***/ }),

/***/ "C1JH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ITEM_FRAGMENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LIST_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LISTS_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHECK_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return UNCHECK_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHANGE_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DELETE_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return MOVE_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CLEAR_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return NEW_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DELETE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return UPDATE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGED; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__("2R8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__("tlQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['query ShoppingList($id: ID!) {\n    shoppingList(id: $id) {\n      ...shoppingListFields\n    }\n  }\n  ', ''], ['query ShoppingList($id: ID!) {\n    shoppingList(id: $id) {\n      ...shoppingListFields\n    }\n  }\n  ', '']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['mutation ShoppingListCheckItem($id: ID!, $itemId: ID!, $newIndex: Int) {\n    shoppingListCheckItem(id: $id, itemId: $itemId, newIndex: $newIndex) {\n      item {\n        ...itemFields\n      }\n      modifiedAt\n    }\n  }\n  ', ''], ['mutation ShoppingListCheckItem($id: ID!, $itemId: ID!, $newIndex: Int) {\n    shoppingListCheckItem(id: $id, itemId: $itemId, newIndex: $newIndex) {\n      item {\n        ...itemFields\n      }\n      modifiedAt\n    }\n  }\n  ', '']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['mutation ShoppingListUncheckItem($id: ID!, $itemId: ID!, $newIndex: Int) {\n    shoppingListUncheckItem(id: $id, itemId: $itemId, newIndex: $newIndex) {\n      item {\n        ...itemFields\n      }\n      modifiedAt\n    }\n  }\n  ', ''], ['mutation ShoppingListUncheckItem($id: ID!, $itemId: ID!, $newIndex: Int) {\n    shoppingListUncheckItem(id: $id, itemId: $itemId, newIndex: $newIndex) {\n      item {\n        ...itemFields\n      }\n      modifiedAt\n    }\n  }\n  ', '']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['mutation ShoppingListChangeItem($id: ID!, $itemId: ID!, $newDescription: String!, $itemListName: SHOPPING_ITEM_LIST) {\n    shoppingListChangeItem(id: $id, itemId: $itemId, newDescription: $newDescription, itemListName: $itemListName) {\n      item {\n        ...itemFields\n      }\n      modifiedAt\n    }\n  }\n  ', ''], ['mutation ShoppingListChangeItem($id: ID!, $itemId: ID!, $newDescription: String!, $itemListName: SHOPPING_ITEM_LIST) {\n    shoppingListChangeItem(id: $id, itemId: $itemId, newDescription: $newDescription, itemListName: $itemListName) {\n      item {\n        ...itemFields\n      }\n      modifiedAt\n    }\n  }\n  ', '']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['mutation ShoppingListDeleteItem($id: ID!, $itemId: ID!, $itemListName: String!) {\n    shoppingListDeleteItem(id: $id, itemId: $itemId, itemListName: $itemListName) {\n      itemId\n      modifiedAt\n    }\n  }'], ['mutation ShoppingListDeleteItem($id: ID!, $itemId: ID!, $itemListName: String!) {\n    shoppingListDeleteItem(id: $id, itemId: $itemId, itemListName: $itemListName) {\n      itemId\n      modifiedAt\n    }\n  }']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['mutation ShoppingListAddItem($id: ID!, $item: ShoppingListItemInput!, $index: Int, $itemListName : SHOPPING_ITEM_LIST) {\n    shoppingListAddItem(id: $id, item: $item, index: $index, itemListName: $itemListName) {\n      item {\n        ...itemFields\n      }\n      modifiedAt\n    }\n  }\n  ', ''], ['mutation ShoppingListAddItem($id: ID!, $item: ShoppingListItemInput!, $index: Int, $itemListName : SHOPPING_ITEM_LIST) {\n    shoppingListAddItem(id: $id, item: $item, index: $index, itemListName: $itemListName) {\n      item {\n        ...itemFields\n      }\n      modifiedAt\n    }\n  }\n  ', '']),
    _templateObject7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['mutation ShoppingListAddItems($items: [ShoppingListItemInput!]!) {\n    shoppingListAddItems(items: $items) {\n      list {\n        ...itemFields\n      }\n      modifiedAt\n    }\n  }\n  ', ''], ['mutation ShoppingListAddItems($items: [ShoppingListItemInput!]!) {\n    shoppingListAddItems(items: $items) {\n      list {\n        ...itemFields\n      }\n      modifiedAt\n    }\n  }\n  ', '']),
    _templateObject8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['mutation ShoppingListMoveItem($id: ID!, $itemId: ID!, $newIndex: Int!, $itemListName: SHOPPING_ITEM_LIST!) {\n    shoppingListMoveItem(id: $id, itemId: $itemId, newIndex: $newIndex, itemListName: $itemListName) {\n      list {\n        ...itemFields\n      }\n      modifiedAt\n    }\n  }\n  ', ''], ['mutation ShoppingListMoveItem($id: ID!, $itemId: ID!, $newIndex: Int!, $itemListName: SHOPPING_ITEM_LIST!) {\n    shoppingListMoveItem(id: $id, itemId: $itemId, newIndex: $newIndex, itemListName: $itemListName) {\n      list {\n        ...itemFields\n      }\n      modifiedAt\n    }\n  }\n  ', '']),
    _templateObject9 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['mutation ShoppingListClearAll($id: ID!) {\n    shoppingListClearAll(id: $id) {\n      id\n      modifiedAt\n    }\n  }'], ['mutation ShoppingListClearAll($id: ID!) {\n    shoppingListClearAll(id: $id) {\n      id\n      modifiedAt\n    }\n  }']),
    _templateObject10 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['mutation ShoppingListCreateNew($name: String!) {\n    shoppingListCreateNew(name: $name) {\n      id\n    }\n  }'], ['mutation ShoppingListCreateNew($name: String!) {\n    shoppingListCreateNew(name: $name) {\n      id\n    }\n  }']),
    _templateObject11 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['mutation ShoppingListDelete($id: ID!) {\n    shoppingListDelete(id: $id) {\n      deletedList {\n        name\n      }\n      defaultList {\n        id\n      }\n    }\n  }'], ['mutation ShoppingListDelete($id: ID!) {\n    shoppingListDelete(id: $id) {\n      deletedList {\n        name\n      }\n      defaultList {\n        id\n      }\n    }\n  }']),
    _templateObject12 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['mutation ShoppingListUpdateName($id: ID!, $name: String!) {\n    shoppingListUpdateName(id: $id, name: $name) {\n      id\n      name\n      modifiedAt\n    }\n  }'], ['mutation ShoppingListUpdateName($id: ID!, $name: String!) {\n    shoppingListUpdateName(id: $id, name: $name) {\n      id\n      name\n      modifiedAt\n    }\n  }']),
    _templateObject13 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['{\n    shoppingLists {\n      id\n      name\n      modifiedAt\n    }\n  }'], ['{\n    shoppingLists {\n      id\n      name\n      modifiedAt\n    }\n  }']),
    _templateObject14 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['subscription ShoppingListChanged($id: ID!) {\n    shoppingListChanged(id: $id) {\n      __typename\n      ...checkItemResultFields,\n      ...uncheckItemResultFields,\n      ...addItemsResultFields,\n      ...addItemResultFields,\n      ...changeItemResultFields,\n      ...deleteItemResultFields,\n      ...clearAllResultFields,\n      ...moveItemResultFields,\n      ...updateNameResultFields,\n    }\n  }\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', ''], ['subscription ShoppingListChanged($id: ID!) {\n    shoppingListChanged(id: $id) {\n      __typename\n      ...checkItemResultFields,\n      ...uncheckItemResultFields,\n      ...addItemsResultFields,\n      ...addItemResultFields,\n      ...changeItemResultFields,\n      ...deleteItemResultFields,\n      ...clearAllResultFields,\n      ...moveItemResultFields,\n      ...updateNameResultFields,\n    }\n  }\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '']);



var ITEM_FRAGMENT = ' fragment itemFields on ShoppingListItem {\n      id\n      foodItemId\n      description\n      externalId\n    }\n  ';

var CHECK_ITEM_RESULT_FRAGMENT = ' fragment checkItemResultFields on ShoppingListCheckItemResult {\n      id\n      item {\n        ...itemFields\n      }\n      modifiedAt\n      newIndex\n    }\n    ' + ITEM_FRAGMENT;

var UNCHECK_ITEM_RESULT_FRAGMENT = ' fragment uncheckItemResultFields on ShoppingListUncheckItemResult {\n      id\n      item {\n        ...itemFields\n      }\n      modifiedAt\n      newIndex\n    }\n    ' + ITEM_FRAGMENT;

var ADD_ITEMS_RESULT_FRAGMENT = ' fragment addItemsResultFields on ShoppingListAddItemsResult {\n      id\n      list {\n        ...itemFields\n      }\n      modifiedAt\n    }\n    ' + ITEM_FRAGMENT;

var ADD_ITEM_RESULT_FRAGMENT = ' fragment addItemResultFields on ShoppingListAddItemResult {\n      id\n      item {\n        ...itemFields\n      }\n      index\n      modifiedAt\n    }\n    ' + ITEM_FRAGMENT;

var CHANGE_ITEM_RESULT_FRAGMENT = ' fragment changeItemResultFields on ShoppingListChangeItemResult {\n      id\n      item {\n        ...itemFields\n      }\n      modifiedAt\n      itemListName\n    }\n    ' + ITEM_FRAGMENT;

var DELETE_ITEM_RESULT_FRAGMENT = ' fragment deleteItemResultFields on ShoppingListDeleteItemResult {\n      id\n      itemId\n      modifiedAt\n      itemListName\n    }';

var CLEAR_ALL_RESULT_FRAGMENT = ' fragment clearAllResultFields on ShoppingListClearAllResult {\n      id\n      modifiedAt\n    }';

var MOVE_ITEM_RESULT_FRAGMENT = ' fragment moveItemResultFields on ShoppingListMoveItemResult {\n      id\n      list {\n        ...itemFields\n      }\n      modifiedAt\n      itemListName\n    }\n    ' + ITEM_FRAGMENT;

var UPDATE_NAME_RESULT_FRAGMENT = ' fragment updateNameResultFields on ShoppingListUpdateNameResult {\n      id\n      name\n      modifiedAt\n    }';

var SHOPPING_LIST_FRAGMENT = ' fragment shoppingListFields on ShoppingList {\n      id\n      name\n      access\n      modifiedAt\n      items {\n        checked {\n          ...itemFields\n        }\n        unchecked {\n          ...itemFields\n        }\n      }\n    }\n    ' + ITEM_FRAGMENT;

var LIST_QUERY = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject, SHOPPING_LIST_FRAGMENT);

var CHECK_ITEM = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject2, ITEM_FRAGMENT);

var UNCHECK_ITEM = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject3, ITEM_FRAGMENT);

var CHANGE_ITEM = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject4, ITEM_FRAGMENT);

var DELETE_ITEM = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject5);

var ADD_ITEM = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject6, ITEM_FRAGMENT);

var ADD_ITEMS = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject7, ITEM_FRAGMENT);

var MOVE_ITEM = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject8, ITEM_FRAGMENT);

var CLEAR_ALL = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject9);

var NEW_LIST = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject10);

var DELETE_LIST = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject11);

var UPDATE_NAME = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject12);

var LISTS_QUERY = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject13);

var CHANGED = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject14, CHECK_ITEM_RESULT_FRAGMENT, UNCHECK_ITEM_RESULT_FRAGMENT, ADD_ITEMS_RESULT_FRAGMENT, ADD_ITEM_RESULT_FRAGMENT, CHANGE_ITEM_RESULT_FRAGMENT, DELETE_ITEM_RESULT_FRAGMENT, CLEAR_ALL_RESULT_FRAGMENT, MOVE_ITEM_RESULT_FRAGMENT, UPDATE_NAME_RESULT_FRAGMENT);



/***/ }),

/***/ "DDCV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_i18n__ = __webpack_require__("i94f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_routing__ = __webpack_require__("5m/v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graphql_shopping_list__ = __webpack_require__("C1JH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_errors__ = __webpack_require__("pvCZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'shoppingListModalNew',
  data: function data() {
    return {
      listName: ''
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_i18n__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_routing__["a" /* default */]],
  mounted: function mounted() {
    this.$refs.listName.focus();
  },

  methods: {
    save: function save() {
      var _this = this;

      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_2__graphql_shopping_list__["l" /* NEW_LIST */],
        variables: {
          name: this.listName.trim()
        },
        refetchQueries: [{
          query: __WEBPACK_IMPORTED_MODULE_2__graphql_shopping_list__["i" /* LISTS_QUERY */]
        }]
      }).then(function (_ref) {
        var shoppingListCreateNew = _ref.data.shoppingListCreateNew;

        _this.$emit('ok', shoppingListCreateNew);
        _this.$parent.close();
      }).catch(function (err) {
        _this.$toast.open({
          message: Object(__WEBPACK_IMPORTED_MODULE_3__utils_errors__["c" /* getErrorMessage */])(err),
          type: 'is-danger'
        });

        _this.$parent.close();
      });
    }
  }
});

/***/ }),

/***/ "DEnp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingListAppToolbar_vue__ = __webpack_require__("nvz7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a1401d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingListAppToolbar_vue__ = __webpack_require__("Mosw");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingListAppToolbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a1401d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingListAppToolbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("vqcF")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DMtD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"browse"},[_c('description-modal',{attrs:{"show":_vm.descModalActive,"name":_vm.clickedItem.name,"description":_vm.clickedItem.description},on:{"close":_vm.closeDesc}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('browse-toolbar'),_vm._v(" "),(_vm.mode === 'table')?_c('browse-table',{on:{"descClicked":_vm.descClicked}}):_c('browse-tiles')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E5xn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrowseTable_vue__ = __webpack_require__("j+ab");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70234a55_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrowseTable_vue__ = __webpack_require__("qsKw");
function injectStyle (ssrContext) {
  __webpack_require__("7mLH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70234a55"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrowseTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70234a55_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrowseTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EFs7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var PIC_WIDTH = 320;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'image-capture',
  data: function data() {
    return {
      captureMode: true,
      videoIsUp: false,
      imageTaken: false,
      flash: null,

      picWidth: 1,
      picHeight: 1,

      photoSrc: null,
      mediaTrack: null,

      devices: [],
      currentDevice: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    navigator.mediaDevices.enumerateDevices().then(function (devices) {
      devices.forEach(function (device) {
        // console.log(`${device.kind}: ${device.label} id=${device.deviceId}`);
        if (device.kind.match(/video/i)) {
          _this.devices.push(device);
        }
      });

      if (_this.devices.length) {
        _this.currentDevice = 0;
        _this.startVideo();
      }
    });
  },

  methods: {
    startVideo: function startVideo() {
      var _this2 = this;

      navigator.mediaDevices.getUserMedia({
        audio: false,
        video: {
          deviceId: this.devices[this.currentDevice].deviceId
        }
      }).then(function (stream) {
        _this2.$refs.video.srcObject = stream;
        _this2.$refs.video.play();
        _this2.mediaTrack = stream.getTracks()[0];
        _this2.captureMode = true;
      }).catch(function (err) {
        _this2.flash = 'Error: ' + err.message;
      });
    },
    capture: function capture() {
      var canvas = this.$refs.canvas;
      var context = canvas.getContext('2d');
      context.drawImage(this.$refs.video, 0, 0, this.picWidth, this.picHeight);

      var data = canvas.toDataURL('image/png');
      this.photoSrc = data;

      this.mediaTrack.stop();
      this.imageTaken = true;
    },
    save: function save() {
      this.$emit('save', {
        data: this.photoSrc,
        width: this.picWidth,
        height: this.picHeight
      });
      this.reset();
    },
    switchCamera: function switchCamera() {
      this.currentDevice = (this.currentDevice + 1) % this.devices.length;
      this.mediaTrack.stop();
      this.startVideo();
    },
    reset: function reset() {
      this.videoIsUp = false;
      this.clearPhoto();
      this.startVideo();
    },
    cancel: function cancel() {
      this.clearPhoto();
      this.captureMode = false;
      this.videoIsUp = false;
      this.mediaTrack.stop();
      this.$emit('cancel');
    },
    canPlay: function canPlay() {
      if (this.captureMode) {
        var video = this.$refs.video;
        this.picHeight = video.videoHeight / (video.videoWidth / PIC_WIDTH);
        this.picWidth = PIC_WIDTH;
        this.videoIsUp = true;
      }
    },
    clearPhoto: function clearPhoto() {
      // Clear the canvas - set to grey box
      var canvas = this.$refs.canvas;
      var context = canvas.getContext('2d');
      context.fillStyle = '#AAA';
      context.fillRect(0, 0, canvas.width, canvas.height);

      // If we had a separate box on the screen for the captured image,
      // then this would clear it, but we don't
      // const data = canvas.toDataURL('image/png');
      // this.photoSrc = data;  <-- this would be the other image capture window

      this.photoSrc = null;
      this.imageTaken = false;
    }
  }
});

/***/ }),

/***/ "FzK3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var googleMapsUrlPrefix = 'https://www.google.com/maps/search/?api=1&query=';

function appendComma(s, more) {
  if (s) {
    if (more) {
      return s + ', ' + more;
    }

    return s;
  }

  return more;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    addrHref: function addrHref(fi) {
      var addr = fi.address;
      if (addr.street && addr.city && addr.state) {
        var s = this.addrString(addr);
        return '' + googleMapsUrlPrefix + encodeURIComponent(s);
      } else if (addr.city) {
        var _s = fi.name + ' in ' + addr.city;
        _s += addr.state ? ', ' + addr.state : '';
        return '' + googleMapsUrlPrefix + encodeURIComponent(_s);
      }

      return '';
    },
    addrString: function addrString(addr) {
      if (!addr) {
        return '';
      }

      var s = appendComma('', addr.street);
      s = appendComma(s, addr.city);
      s = appendComma(s, addr.state);
      return appendComma(s, addr.country);
    },
    youTubeLink: function youTubeLink(link) {
      if (!link) {
        return null;
      }

      var url = void 0;
      try {
        url = new URL(link);
      } catch (err) {
        return null;
      }

      if (url.hostname.match(/youtube\.com/) && url.search) {
        // searchParams is not getting populated for some reason, so have to parse search
        var videoId = url.search.match(/[?&]v=(.+)&?/);
        if (videoId.length > 1) {
          return 'https://www.youtube-nocookie.com/embed/' + videoId[1] + '?rel=0';
        }
      }

      return null;
    }
  }
});

/***/ }),

/***/ "Gfls":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_i18n__ = __webpack_require__("i94f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__foodItem_types__ = __webpack_require__("rt35");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'new',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_i18n__["a" /* default */]],
  data: function data() {
    return {
      flash: '',
      typeSelected: this.initTypeSelected()
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      return _this.$refs.new.focus();
    });
  },

  watch: {
    $route: function $route() {
      this.typeSelected = this.initTypeSelected();
    }
  },
  methods: {
    initTypeSelected: function initTypeSelected() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_2__foodItem_types__["a" /* default */].types, function (t) {
        return t.newRoute === _this2.$router.currentRoute.name;
      });
    },
    onFlash: function onFlash(f) {
      this.flash = f;
      window.scrollTo(0, 0);
    }
  },
  computed: {
    types: function types() {
      return __WEBPACK_IMPORTED_MODULE_2__foodItem_types__["a" /* default */].types;
    }
  }
});

/***/ }),

/***/ "GgZJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowseMixin__ = __webpack_require__("XDap");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var tileColors = ['is-info', 'is-primary', 'is-warning', 'is-danger', 'is-link', 'is-success'];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'browse-tiles',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__BrowseMixin__["a" /* default */]],
  methods: {
    tileColor: function tileColor(index) {
      return tileColors[Math.floor(index % tileColors.length)];
    }
  }
});

/***/ }),

/***/ "GtbI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H/Kn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrowseTiles_vue__ = __webpack_require__("GgZJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cfc7f7f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrowseTiles_vue__ = __webpack_require__("9SJH");
function injectStyle (ssrContext) {
  __webpack_require__("Y2Nu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrowseTiles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cfc7f7f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrowseTiles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HzJv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Browse_vue__ = __webpack_require__("pQxd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_007f2b79_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Browse_vue__ = __webpack_require__("DMtD");
function injectStyle (ssrContext) {
  __webpack_require__("6nDT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-007f2b79"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Browse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_007f2b79_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Browse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ibu+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Action__ = __webpack_require__("kG4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AddItemAction__ = __webpack_require__("/paj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__graphql_shopping_list__ = __webpack_require__("C1JH");











/* eslint-disable no-underscore-dangle */

var DeleteItemAction = function (_UndoAction) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(DeleteItemAction, _UndoAction);

  function DeleteItemAction(options) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, DeleteItemAction);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DeleteItemAction.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(DeleteItemAction)).call(this, options));

    _this.index = options.index;
    _this.itemListName = options.itemListName;
    _this.item = Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["clone"])(_this.component.shoppingList.items[_this.itemListName][_this.index]);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(DeleteItemAction, [{
    key: '_executeImpl',
    value: function _executeImpl() {
      var self = this;

      return this.component.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_9__graphql_shopping_list__["g" /* DELETE_ITEM */],
        variables: {
          id: this.component.shoppingList.id,
          itemId: this.item.id,
          itemListName: this.itemListName
        },
        update: function update(store, _ref) {
          var shoppingListDeleteItem = _ref.data.shoppingListDeleteItem;

          self._updateCache(store, shoppingListDeleteItem);
        },

        optimisticResponse: {
          shoppingListDeleteItem: {
            /* eslint-disable no-underscore-dangle */
            __typename: 'ShoppingListDeleteItemResult',
            itemId: this.item.id,
            modifiedAt: null
          }
        }
      });
    }
  }, {
    key: 'updateQuery',
    value: function updateQuery(cachedShoppingList) {
      var itemList = cachedShoppingList.items[this.itemListName];
      var newItemList = itemList.slice(0, this.index);
      newItemList.push.apply(newItemList, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(itemList.slice(this.index + 1)));
      cachedShoppingList.items[this.itemListName] = newItemList;

      return cachedShoppingList;
    }
  }, {
    key: 'undo',
    value: function undo() {
      var _this2 = this;

      return this.component.triggerAction(__WEBPACK_IMPORTED_MODULE_8__AddItemAction__["a" /* default */], {
        item: this.item,
        index: this.index,
        itemListName: this.itemListName,
        undoAction: this
      }).then(function (result) {
        _this2.item = result.data.shoppingListAddItem.item;
        return result;
      });
    }
  }, {
    key: 'updateItem',
    value: function updateItem(oldItem, newItem) {
      if (this.item.id === oldItem.id) {
        this.item = Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["clone"])(newItem);
      }
    }

    // eslint-disable-next-line

  }, {
    key: 'undoTooltip',
    value: function undoTooltip() {
      return 'Undo delete item';
    }

    // eslint-disable-next-line

  }, {
    key: 'redoTooltip',
    value: function redoTooltip() {
      return 'Redo delete item';
    }
  }], [{
    key: 'name',
    get: function get() {
      return 'DeleteItemAction';
    }
  }]);

  return DeleteItemAction;
}(__WEBPACK_IMPORTED_MODULE_7__Action__["b" /* UndoAction */]);

/* harmony default export */ __webpack_exports__["a"] = (DeleteItemAction);

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__("lwq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__("ukYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_browse__ = __webpack_require__("0KBQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_recipe__ = __webpack_require__("VUIP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_restaurant__ = __webpack_require__("t5qc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_shoppingList__ = __webpack_require__("J2NY");











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_5__actions__["a" /* default */],

  modules: {
    browse: __WEBPACK_IMPORTED_MODULE_6__modules_browse__["a" /* default */],
    recipe: __WEBPACK_IMPORTED_MODULE_7__modules_recipe__["a" /* default */],
    restaurant: __WEBPACK_IMPORTED_MODULE_8__modules_restaurant__["a" /* default */],
    shoppingList: __WEBPACK_IMPORTED_MODULE_9__modules_shoppingList__["a" /* default */]
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "IuM5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_routing__ = __webpack_require__("5m/v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_i18n__ = __webpack_require__("i94f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NewCategories__ = __webpack_require__("qEt2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ImageCapture__ = __webpack_require__("peQO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FileUpload__ = __webpack_require__("w32Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_time__ = __webpack_require__("2hfY");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











function copyString(src) {
  var defValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return src ? src.slice() : defValue;
}

function copyArray(src) {
  var defValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  // shallow
  return src ? src.slice() : defValue;
}

var FormData = function FormData() {
  var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormData);

  this.name = copyString(o.name);
  this.link = copyString(o.link);
  this.access = copyString(o.access, 'private');
  this.description = copyString(o.description);
  this.categories = copyArray(o.categories);
  this.ingredients = copyArray(o.ingredients);
  this.directions = copyArray(o.directions);
  this.servings = o.servings;
  this.prepTimeMin = o.prepTimeMin;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'recipe-form',
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_routing__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_i18n__["a" /* default */]],
  props: {
    id: {
      // Edit mode if this is set!
      type: String,
      required: false
    }
  },
  data: function data() {
    return {
      form: new FormData(),

      images: [],

      ingredientsString: '',
      directionsString: '',
      prepTime: {
        days: null,
        hours: null,
        mins: null
      },

      captureMode: false,
      capturedImage: null,

      uploadMode: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      return _this.resetForm();
    });
  },

  methods: {
    submit: function submit() {
      var _this2 = this;

      this.form.ingredients = this.ingredientsString.split(/\n+/);
      this.form.directions = this.directionsString.split(/\n+/);
      this.form.prepTimeMin = Object(__WEBPACK_IMPORTED_MODULE_11__utils_time__["c" /* toMinutes */])(this.prepTime);

      // TODO add validation!
      // TODO add validation!

      if (this.id) {
        this.$store.dispatch('recipe/updateRecipe', { id: this.id, recipe: this.form }).then(function (returnedRecipe) {
          _this2.routeFoodItem({ type: 'Recipe', id: returnedRecipe.id, noBack: true });
        }).catch(function (err) {
          return _this2.$emit('flash', err.message);
        });
      } else {
        this.$store.dispatch('recipe/saveRecipe', this.form).then(function (id) {
          _this2.routeFoodItem({ type: 'Recipe', id: id, noBack: true });
        }).catch(function (err) {
          return _this2.$emit('flash', err.message);
        });
      }
    },
    confirmReset: function confirmReset() {
      var self = this;
      this.$dialog.confirm({
        title: 'Reset Form',
        message: 'Are you sure?',
        confirmText: 'Reset',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: function onConfirm() {
          self.resetForm();
        }
      });
    },
    resetForm: function resetForm() {
      this.captureMode = false;
      this.uploadMode = false;
      this.capturedImage = null;

      var self = this;
      var promise = void 0;
      if (this.id) {
        var loading = this.$loading.open();
        promise = this.$store.dispatch('recipe/fetchRecipe', this.id).then(function () {
          // recipe is frozen, because it's in the graphql store
          self.form = new FormData(self.recipe);
          self.ingredientsString = self.form.ingredients.join('\n');
          self.directionsString = self.form.directions.join('\n');
          self.prepTime = Object(__WEBPACK_IMPORTED_MODULE_11__utils_time__["a" /* fromMinutes */])(self.form.prepTimeMin);
          loading.close();
        }).catch(function (err) {
          self.error = err.message;
        });
      } else {
        this.form = new FormData();
        promise = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      }

      return promise.then(function () {
        return self.$refs.name.focus();
      });
    },
    saveCapturedImage: function saveCapturedImage(image) {
      if (image.data) {
        var height = image.height / (image.width / 128);
        this.images.push(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.extend({
          id: __WEBPACK_IMPORTED_MODULE_5_uuid_v4___default()(),
          style: {
            height: height + 'px',
            width: '128px'
          }
        }, image));
      } else {
        this.$toast.open({
          message: 'Got image save with NO data',
          type: 'is-warning'
        });
      }
    },
    deleteImage: function deleteImage(image) {
      var _this3 = this;

      this.$dialog.confirm({
        title: 'Delete image',
        message: 'Are you sure?',
        confirmText: 'Delete',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: function onConfirm() {
          var index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(_this3.images, { id: image.id });
          if (index >= 0) {
            _this3.images.splice(index, 1);
          }
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['categoryNames']), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])('recipe', ['recipe'])),
  components: {
    NewCategories: __WEBPACK_IMPORTED_MODULE_8__NewCategories__["a" /* default */],
    ImageCapture: __WEBPACK_IMPORTED_MODULE_9__ImageCapture__["a" /* default */],
    FileUpload: __WEBPACK_IMPORTED_MODULE_10__FileUpload__["a" /* default */]
  }
});

/***/ }),

/***/ "J2NY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__("2R8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__("tlQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_fetch__ = __webpack_require__("Vo7i");



var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['query FoodITems($ids: [ID!]!) {\n        foodItems(ids: $ids) {\n          id\n          name\n        }\n      }'], ['query FoodITems($ids: [ID!]!) {\n        foodItems(ids: $ids) {\n          id\n          name\n        }\n      }']);




var MAX_UNDO_STACK_SIZE = 10;
var LIST_KEY = 'shopping_list_id';

var state = {
  // Map of items by id for shopping list items to resolve
  // associated foodItem names
  foodItems: {},

  undoStack: [],
  redoStack: [],

  defaultShoppingListId: localStorage.getItem(LIST_KEY),
  currentShoppingList: null
};

var getters = {
  defaultShoppingListId: function defaultShoppingListId(s) {
    return s.defaultShoppingListId;
  },
  currentShoppingList: function currentShoppingList(s) {
    return s.currentShoppingList;
  },

  foodItemName: function foodItemName(s) {
    return function (id) {
      if (!id || !s.foodItems) {
        return '';
      }

      var item = s.foodItems[id];
      if (item && item.name) {
        return item.name;
      }

      return '';
    };
  }
};

var mutations = {
  pushUndo: function pushUndo(s, _ref) {
    var undoAction = _ref.undoAction,
        isRedoAction = _ref.isRedoAction;

    s.undoStack.push(undoAction);
    if (s.undoStack.length > MAX_UNDO_STACK_SIZE) {
      s.undoStack.shift();
    }

    if (!isRedoAction) {
      s.redoStack = [];
    }
  },
  pushRedo: function pushRedo(s, undoAction) {
    s.redoStack.push(undoAction);
  },
  updateUndoRedoItem: function updateUndoRedoItem(s, _ref2) {
    var oldItem = _ref2.oldItem,
        newItem = _ref2.newItem;

    var updateItemFunc = function updateItemFunc(action) {
      if (typeof action.updateItem === 'function') {
        action.updateItem(oldItem, newItem);
      }
    };

    s.undoStack.forEach(updateItemFunc);
    s.redoStack.forEach(updateItemFunc);
  },
  clearUndoRedo: function clearUndoRedo(s) {
    s.undoStack = [];
    s.redoStack = [];
  },
  defaultShoppingListId: function defaultShoppingListId(s, id) {
    s.defaultShoppingListId = id;
    localStorage.setItem(LIST_KEY, id);
  },
  currentShoppingList: function currentShoppingList(s, shoppingList) {
    s.currentShoppingList = shoppingList;
  }
};

var actions = {
  popUndo: function popUndo(context) {
    if (context.state.undoStack.length === 0) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject({ message: 'Nothing to undo' });
    }

    var itemAction = context.state.undoStack.pop();
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(itemAction);
  },
  popRedo: function popRedo(context) {
    if (context.state.redoStack.length === 0) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject({ message: 'Nothing to redo' });
    }

    var itemAction = context.state.redoStack.pop();
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(itemAction);
  },
  fetchFoodItems: function fetchFoodItems(context, ids) {
    return __WEBPACK_IMPORTED_MODULE_3__utils_fetch__["a" /* graphql */].query({
      query: __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default()(_templateObject),
      variables: {
        ids: ids
      }
    }).then(function (_ref3) {
      var foodItems = _ref3.data.foodItems;

      var foodItemsMap = {};
      foodItems.forEach(function (foodItem) {
        foodItemsMap[foodItem.id] = foodItem;
      });

      context.state.foodItems = foodItemsMap;
      return foodItemsMap;
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ "J5OW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"field is-grouped is-grouped-centered"},[(_vm.videoIsUp && !_vm.imageTaken)?_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-success",on:{"click":function($event){$event.preventDefault();return _vm.capture($event)}}},[_vm._v("\n        Capture\n      ")])]):_vm._e(),_vm._v(" "),(_vm.videoIsUp && _vm.imageTaken)?_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-success",on:{"click":function($event){$event.preventDefault();return _vm.save($event)}}},[_vm._v("\n        Save\n      ")])]):_vm._e(),_vm._v(" "),(_vm.videoIsUp && !_vm.imageTaken && _vm.devices.length > 1)?_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-light",on:{"click":function($event){$event.preventDefault();return _vm.switchCamera($event)}}},[_vm._v("\n        Switch\n      ")])]):_vm._e(),_vm._v(" "),(_vm.videoIsUp && _vm.imageTaken)?_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-link",on:{"click":function($event){$event.preventDefault();return _vm.reset($event)}}},[_vm._v("\n        Reset\n      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"control"},[_c('button',{staticClass:"button",on:{"click":function($event){$event.preventDefault();return _vm.cancel($event)}}},[_vm._v("\n        Cancel\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"level"},[(_vm.captureMode && !_vm.imageTaken)?_c('div',{staticClass:"level-item has-text-centered"},[_c('video',{ref:"video",attrs:{"width":_vm.picWidth,"height":_vm.picHeight},on:{"~canplay":function($event){return _vm.canPlay($event)}}})]):_vm._e(),_vm._v(" "),(_vm.captureMode && _vm.imageTaken)?_c('div',{ref:"output",staticClass:"level-item has-text-centered"},[_c('img',{ref:"photo",attrs:{"src":_vm.photoSrc}})]):_vm._e()]),_vm._v(" "),_c('canvas',{ref:"canvas",staticClass:"canvas",attrs:{"width":_vm.picWidth,"height":_vm.picHeight}}),_vm._v(" "),(_vm.flash)?_c('div',{staticClass:"notification is-danger"},[_vm._v(_vm._s(_vm.flash))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JJT7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_auth__ = __webpack_require__("TIfe");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  data: function data() {
    return {
      form: {
        firstName: null,
        lastName: null,
        email: null,
        password: null
      },
      flash: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      return _this.$refs.firstName.focus();
    });
  },

  methods: {
    clear: function clear() {
      this.form.firstName = null;
      this.form.lastName = null;
      this.form.email = null;
      this.form.password = null;
      this.flash = null;
    },
    submit: function submit() {
      var _this2 = this;

      var form = {
        firstName: this.form.firstName.slice(0),
        lastName: this.form.lastName.slice(0),
        username: this.form.email.slice(0),
        password: this.form.password.slice(0)
      };

      Object(__WEBPACK_IMPORTED_MODULE_0__utils_auth__["f" /* register */])(form).then(function () {
        _this2.clear();
        _this2.$router.push({ name: 'browse' });
      }).catch(function (error) {
        _this2.flash = error.message;
      });
    },
    cancel: function cancel() {
      this.clear();
      this.$router.push({ name: 'login' });
    }
  }
});

/***/ }),

/***/ "JK6E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'description-modal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    name: {
      type: String
    },
    description: {
      type: String,
      required: true
    }
  }
});

/***/ }),

/***/ "JSS4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"form",attrs:{"action":""}},[_c('div',{staticClass:"modal-card",staticStyle:{"width":"auto"}},[_c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title"},[_vm._v(_vm._s(_vm.$t('openTitle')))])]),_vm._v(" "),_c('section',{staticClass:"modal-card-body"},[_c('div',{staticClass:"box is-hidden-mobile",staticStyle:{"min-width":"30rem"}},[_c('div',{staticClass:"columns is-gapless header-row has-text-weight-bold"},[_c('div',{staticClass:"column is-6 header-col"},[_vm._v(_vm._s(_vm.$t('name')))]),_vm._v(" "),_c('div',{staticClass:"column header-col"},[_vm._v(_vm._s(_vm.$t('modifiedAt')))])]),_vm._v(" "),_c('div',{staticClass:"columns is-gapless list-box"},[_c('div',{staticClass:"column is-6 list-col"},[_c('ul',_vm._l((_vm.shoppingLists),function(list,index){return _c('li',{key:list.id,class:[{ selected: _vm.selectedIndex === index }, 'truncate', ("list-item-" + index)],on:{"click":function($event){_vm.select(index)}}},[_vm._v("\n                "+_vm._s(list.name)+"\n              ")])}))]),_vm._v(" "),_c('div',{staticClass:"column list-col"},[_c('ul',_vm._l((_vm.shoppingLists),function(list,index){return _c('li',{key:list.id,class:[{ selected: _vm.selectedIndex === index }, 'truncate', ("list-item-" + index)],on:{"click":function($event){_vm.select(index)}}},[_vm._v("\n                "+_vm._s(_vm.formatDate(list.modifiedAt))+"\n               ")])}))])])]),_vm._v(" "),_c('div',{staticClass:"is-hidden-tablet"},[_c('b-dropdown',{model:{value:(_vm.selectedIndex),callback:function ($$v) {_vm.selectedIndex=$$v},expression:"selectedIndex"}},[_c('button',{staticClass:"button is-primary",attrs:{"slot":"trigger","type":"button"},slot:"trigger"},[(_vm.selectedIndex === null)?[_c('span',[_vm._v("Choose Shopping List")])]:_vm._e(),_vm._v(" "),(_vm.selectedIndex !== null)?[_c('span',{staticClass:"truncate"},[_vm._v(_vm._s(_vm.shoppingLists[_vm.selectedIndex].name))])]:_vm._e(),_vm._v(" "),_c('b-icon',{attrs:{"icon":"caret-down"}})],2),_vm._v(" "),_vm._l((_vm.shoppingLists),function(list,index){return _c('b-dropdown-item',{key:list.id,attrs:{"value":index}},[_c('p',{staticClass:"truncate",attrs:{"aria-role":"button"}},[_vm._v(_vm._s(list.name))]),_vm._v(" "),_c('p',{staticClass:"is-size-7",attrs:{"aria-role":"button"}},[_vm._v(_vm._s(_vm.formatDate(list.modifiedAt)))])])})],2)],1)]),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot fix-footer"},[_c('button',{staticClass:"button",attrs:{"type":"button"},on:{"click":function($event){_vm.$parent.close()}}},[_vm._v(_vm._s(_vm.$t('cancelButton')))]),_vm._v(" "),_c('button',{staticClass:"button is-primary",attrs:{"disabled":_vm.selectedIndex === null},on:{"click":_vm.openList}},[_vm._v(_vm._s(_vm.$t('openButton'))+"\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JW5F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.cancel),expression:"cancel"}],staticClass:"dropdown",class:{ 'is-active' : _vm.isOpen }},[_c('div',{staticClass:"dropdown-trigger",on:{"click":_vm.toggleIsOpen}},[_c('button',{staticClass:"button",attrs:{"aria-haspopup":"true","aria-controls":"dropdown-menu"}},[_c('span',{staticClass:"icon"},[_c('font-awesome-icon',{attrs:{"icon":"filter"}})],1),_vm._v(" "),_c('span',{staticClass:"icon is-small"},[_c('font-awesome-icon',{attrs:{"icon":"angle-down"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"id":"dropdown-menu","role":"menu"}},[_c('div',{staticClass:"dropdown-content"},[_vm._l((_vm.types.types),function(type){return _c('label',{key:type.id,staticClass:"checkbox dropdown-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newSelectedTypes),expression:"newSelectedTypes"}],attrs:{"id":type.id,"type":"checkbox"},domProps:{"value":type.id,"checked":Array.isArray(_vm.newSelectedTypes)?_vm._i(_vm.newSelectedTypes,type.id)>-1:(_vm.newSelectedTypes)},on:{"change":[function($event){var $$a=_vm.newSelectedTypes,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=type.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.newSelectedTypes=$$a.concat([$$v]))}else{$$i>-1&&(_vm.newSelectedTypes=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.newSelectedTypes=$$c}},_vm.categoryClicked]}}),_vm._v("\n        "+_vm._s(_vm.$t(type.id))+"\n      ")])}),_vm._v(" "),_c('hr',{staticClass:"dropdown-divider-top"}),_vm._v(" "),_c('div',{staticClass:"category-selection"},[(_vm.categoryNames.length)?_c('label',{staticClass:"checkbox dropdown-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectAll),expression:"selectAll"}],attrs:{"id":"selectAll","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectAll)?_vm._i(_vm.selectAll,null)>-1:(_vm.selectAll)},on:{"change":[function($event){var $$a=_vm.selectAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectAll=$$c}},_vm.selectAllChanged]}}),_vm._v("\n          (Select All)\n        ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.categoryNames),function(cat){return _c('label',{key:cat,staticClass:"checkbox dropdown-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newSelectedCategories),expression:"newSelectedCategories"}],attrs:{"id":cat,"type":"checkbox"},domProps:{"value":cat,"checked":Array.isArray(_vm.newSelectedCategories)?_vm._i(_vm.newSelectedCategories,cat)>-1:(_vm.newSelectedCategories)},on:{"change":[function($event){var $$a=_vm.newSelectedCategories,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=cat,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.newSelectedCategories=$$a.concat([$$v]))}else{$$i>-1&&(_vm.newSelectedCategories=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.newSelectedCategories=$$c}},_vm.categoryClicked]}}),_vm._v("\n          "+_vm._s(cat)+"\n        ")])})],2),_vm._v(" "),_c('hr',{staticClass:"dropdown-divider-bottom"}),_vm._v(" "),_c('div',{staticClass:"dropdown-item"},[_c('div',{staticClass:"field is-grouped",staticStyle:{"justify-content":"center"}},[_c('p',{staticClass:"control"},[_c('button',{staticClass:"button",on:{"click":_vm.ok}},[_vm._v("OK")])]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('button',{staticClass:"button",on:{"click":_vm.cancel}},[_vm._v("Cancel")])])])])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kc5y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RecipeForm__ = __webpack_require__("TVss");
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'edit-Recipe',
  props: ['id'],
  components: {
    RecipeForm: __WEBPACK_IMPORTED_MODULE_0__RecipeForm__["a" /* default */]
  }
});

/***/ }),

/***/ "LvjE":
/***/ (function(module, exports) {

module.exports = {"version":"2017c","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldWV.E 2xonV.E|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT WAST|-1u -20 -30 -20 -10 -20|01213454545454545454545454545454545454545454545454543|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|012342525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 XQp0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.b 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.N 2HHBQ.N 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.b 50 40|0121212121212121212121|-2l1uQ.N 2uM1Q.N 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BOST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|MMT -0330 -03 -02 -0230|3I.I 3u 30 20 2u|012121212121212121212121213232323232324242423243232323232323232323232323232323232323232|-20UIf.g 8jzJ.g 1cLu 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1qMu WLu 1qMu 11zu 1o0u 11zu NAu 11bu 2iMu zWu Dq10 19X0 pd0 jz0 cm10 19X0 1fB0 1on0 11d0 1oL0 1nB0 1fzu 1aou 1fzu 1aou 1fzu 3nAu Jb0 3MN0 1SLu 4jzu 2PB0 Lb0 3Dd0 1pb0 ixd0 An0 1MN0 An0 1wp0 On0 1wp0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212|-2q00 1DjS0 T90 40P0 KL0 blz0|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST CDT|-7y.k -80 -90|012121212121212121212121212121212121212121|-2le7y.k 1XO34.k 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|+08 +09|-80 -90|010101010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|01231|-2um8n 97XR 1lTzu 2Onc0|29e5","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJH0 QL0 1lB0 13X0 1zB0 NX0 1zB0 NX0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW5.s aPX5.s Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2xomp.U 1qOMp.U 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldWQ.o aPWQ.o Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Etc/GMT+0|GMT|0|0|","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/GMT-1|+01|-10|0|","Pacific/Port_Moresby|+10|-a0|0||25e4","Pacific/Pohnpei|+11|-b0|0||34e3","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0|","Pacific/Palau|+09|-90|0||21e3","Etc/UCT|UCT|0|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 16M0 1lc0 1tA0 17A0 11c0 1io0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ldXn.f aPWn.f Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 -12 +12|-b0 c0 -c0|012|-AX0 W9X0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B8n0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4","Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B8nk|51e2","Pacific/Kosrae|+11 +12|-b0 -c0|010|-AX0 1bdz0|66e2","Pacific/Majuro|+11 +12|-b0 -c0|01|-AX0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Sao_Tome","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT+0|Etc/GMT","Etc/GMT+0|Etc/GMT-0","Etc/GMT+0|Etc/GMT0","Etc/GMT+0|Etc/Greenwich","Etc/GMT+0|GMT","Etc/GMT+0|GMT+0","Etc/GMT+0|GMT-0","Etc/GMT+0|GMT0","Etc/GMT+0|Greenwich","Etc/UCT|UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Etc/GMT-11","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Port_Moresby|Pacific/Chuuk","Pacific/Port_Moresby|Pacific/Truk","Pacific/Port_Moresby|Pacific/Yap","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"]}

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b06df31_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("4wna");
function injectStyle (ssrContext) {
  __webpack_require__("ts75")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b06df31_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("hM8s")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MAht":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_i18n__ = __webpack_require__("i94f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'browseAppToolbar',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_i18n__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('shoppingList', ['defaultShoppingListId']))
});

/***/ }),

/***/ "Mosw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inherit"}},[_c('a',{staticClass:"navbar-item router-link-exact-active router-link-active",on:{"click":_vm.showNewDialog}},[_c('b-icon',{staticClass:"is-hidden-desktop menu-icon",attrs:{"icon":"shopping-cart"}}),_vm._v("\n    "+_vm._s(_vm.$t('new'))+"\n  ")],1),_vm._v(" "),_c('a',{staticClass:"navbar-item router-link-exact-active router-link-active",on:{"click":_vm.showOpenDialog}},[_c('b-icon',{staticClass:"is-hidden-desktop menu-icon",attrs:{"icon":"folder-open"}}),_vm._v("\n    "+_vm._s(_vm.$t('openButton'))+"\n  ")],1),_vm._v(" "),(_vm.currentShoppingList)?_c('a',{staticClass:"navbar-item router-link-exact-active router-link-active",on:{"click":_vm.showConfirmDelete}},[_c('b-icon',{staticClass:"is-hidden-desktop menu-icon",attrs:{"icon":"trash"}}),_vm._v("\n    "+_vm._s(_vm.$t('delete'))+"\n  ")],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apollo__ = __webpack_require__("69U5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_buefy__ = __webpack_require__("O3Oo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_buefy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_buefy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_buefy_dist_buefy_css__ = __webpack_require__("/KV2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_buefy_dist_buefy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_buefy_dist_buefy_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fa_config__ = __webpack_require__("OXI+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_global_i18n_json__ = __webpack_require__("AwED");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_global_i18n_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__i18n_global_i18n_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_auth__ = __webpack_require__("TIfe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_fetch__ = __webpack_require__("Vo7i");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_apollo__["a" /* default */]);

var apolloProvider = new __WEBPACK_IMPORTED_MODULE_1_vue_apollo__["a" /* default */]({
  defaultClient: __WEBPACK_IMPORTED_MODULE_11__utils_fetch__["a" /* graphql */]
});

var i18n = new __WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]({
  locale: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].state.locale,
  messages: __WEBPACK_IMPORTED_MODULE_9__i18n_global_i18n_json___default.a
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_buefy___default.a, {
  defaultIconPack: 'fas',
  defaultToastDuration: 3000
});

Object(__WEBPACK_IMPORTED_MODULE_8__fa_config__["a" /* default */])();
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

Object(__WEBPACK_IMPORTED_MODULE_10__utils_auth__["a" /* checkAuthenticated */])();

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('focus', {
  inserted: function inserted(el) {
    el.focus();
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  i18n: i18n,
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */] },
  provide: apolloProvider.provide()
});

/***/ }),

/***/ "NxGh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__ = __webpack_require__("8taH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56a05814_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__("PDFi");
function injectStyle (ssrContext) {
  __webpack_require__("dA8h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56a05814"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56a05814_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OEby":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"box"},[_c('recipe-form',{attrs:{"id":_vm.id}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OGRp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OK+/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Action__ = __webpack_require__("kG4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__graphql_shopping_list__ = __webpack_require__("C1JH");










/* eslint-disable no-underscore-dangle */

var ChangeItemAction = function (_UndoAction) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ChangeItemAction, _UndoAction);

  function ChangeItemAction(options) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ChangeItemAction);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ChangeItemAction.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ChangeItemAction)).call(this, options));

    _this.itemListName = options.itemListName;
    _this.index = options.index;
    _this.item = options.item;
    _this.value = options.value;
    _this.origDescription = _this.item.description.slice();
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ChangeItemAction, [{
    key: '_executeImpl',
    value: function _executeImpl() {
      var self = this;

      return this.component.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_8__graphql_shopping_list__["d" /* CHANGE_ITEM */],
        variables: {
          id: this.component.shoppingList.id,
          itemId: this.item.id,
          newDescription: this.value,
          itemListName: this.itemListName
        },
        update: function update(store, _ref) {
          var shoppingListChangeItem = _ref.data.shoppingListChangeItem;

          self._updateCache(store, shoppingListChangeItem);
        },
        optimisticResponse: function optimisticResponse() {
          var shoppingListChangeItem = {
            __typename: 'ShoppingListChangeItemResult',
            item: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, self.item),
            modifiedAt: null
          };

          shoppingListChangeItem.item.description = self.value;
          return { shoppingListChangeItem: shoppingListChangeItem };
        }
      });
    }
  }, {
    key: 'updateQuery',
    value: function updateQuery(cachedShoppingList, shoppingListChangeItem) {
      cachedShoppingList.items[this.itemListName][this.index] = shoppingListChangeItem.item;
      return cachedShoppingList;
    }
  }, {
    key: 'undo',
    value: function undo() {
      var currentList = this.component.shoppingList.items[this.itemListName];
      var index = Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["findIndex"])(currentList, { id: this.item.id });
      if (index < 0) {
        throw new Error('Change item undo failed, item not found.');
      }

      return this.component.triggerAction(ChangeItemAction, {
        itemListName: this.itemListName,
        index: index,
        item: currentList[index],
        value: this.origDescription,
        undoAction: this
      });
    }
  }, {
    key: 'updateItem',
    value: function updateItem(oldItem, newItem) {
      if (this.item.id === oldItem.id) {
        this.item = newItem;
      }
    }

    // eslint-disable-next-line

  }, {
    key: 'undoTooltip',
    value: function undoTooltip() {
      return 'Undo change item';
    }

    // eslint-disable-next-line

  }, {
    key: 'redoTooltip',
    value: function redoTooltip() {
      return 'Redo change item';
    }
  }], [{
    key: 'name',
    get: function get() {
      return 'ChangeItemAction';
    }
  }]);

  return ChangeItemAction;
}(__WEBPACK_IMPORTED_MODULE_7__Action__["b" /* UndoAction */]);

/* harmony default export */ __webpack_exports__["a"] = (ChangeItemAction);

/***/ }),

/***/ "OXI+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome__ = __webpack_require__("QxPg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid__ = __webpack_require__("1P+R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_free_brands__ = __webpack_require__("h17U");






function config() {
  __WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome__["default"].library.add(__WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid__["r" /* faSortUp */], __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid__["q" /* faSortDown */], __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid__["x" /* faUtensils */], __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid__["k" /* faListAlt */], __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid__["g" /* faExternalLinkAlt */], __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid__["j" /* faInfoCircle */], __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid__["h" /* faFilter */], __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid__["a" /* faAngleDown */], __WEBPACK_IMPORTED_MODULE_2__fortawesome_fontawesome_free_brands__["a" /* faYoutube */], __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid__["u" /* faTimesCircle */], __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid__["l" /* faLock */], __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid__["m" /* faLockOpen */], __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid__["p" /* faShareAlt */], __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid__["s" /* faSpinner */], __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid__["f" /* faEllipsisV */], __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid__["n" /* faPencilAlt */], __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid__["v" /* faTrashAlt */], __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid__["d" /* faCheck */], __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid__["t" /* faTimes */], __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid__["b" /* faCamera */], __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid__["e" /* faCloudUploadAlt */], __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid__["w" /* faUndoAlt */], __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid__["o" /* faRedoAlt */], __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid__["i" /* faFolderOpen */], __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid__["c" /* faCaretDown */]);
}

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),

/***/ "PDFi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"modal",class:{ 'is-active': _vm.isActive }},[_c('div',{staticClass:"modal-background"}),_vm._v(" "),_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"notification is-primary has-text-centered"},[_c('span',[_c('font-awesome-icon',{attrs:{"icon":_vm.spinner,"size":"3x","pulse":"","fixed-width":""}})],1),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.message))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "POZE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mixin; });
/* unused harmony export UndoCheckItem */
/* unused harmony export UndoUncheckItem */
/* unused harmony export UndoMoveItem */
/* unused harmony export UndoDeleteItem */
/* unused harmony export UndoAddItem */
/* unused harmony export UndoChangeItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);









var UndoAction = function () {
  function UndoAction(component, itemId, meta) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, UndoAction);

    this.component = component;
    this.itemId = itemId;
    this.meta = meta;
  }

  // eslint-disable-next-line


  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(UndoAction, [{
    key: 'undo',
    value: function undo() {
      throw new Error('Undo Not Implemented');
    }

    // eslint-disable-next-line

  }, {
    key: 'redo',
    value: function redo() {
      throw new Error('Redo Not Implemented');
    }

    // eslint-disable-next-line

  }, {
    key: 'undoTooltip',
    value: function undoTooltip() {
      throw new Error('Undo tooltip Not Implemented');
    }

    // eslint-disable-next-line

  }, {
    key: 'redoTooltip',
    value: function redoTooltip() {
      throw new Error('Redo tooltip Not Implemented');
    }
  }]);

  return UndoAction;
}();

var UndoCheckItem = function (_UndoAction) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(UndoCheckItem, _UndoAction);

  function UndoCheckItem() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, UndoCheckItem);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UndoCheckItem.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(UndoCheckItem)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(UndoCheckItem, [{
    key: 'undo',
    value: function undo() {
      var index = Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["findIndex"])(this.component.shoppingList.items.checked, { id: this.itemId });
      if (index < 0) {
        this.component.error = 'Check item undo failed, item not found.';
        return;
      }

      this.component.uncheckItem(index, this.component.shoppingList.items.checked[index], { undoAction: this });
    }
  }, {
    key: 'redo',
    value: function redo() {
      var index = Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["findIndex"])(this.component.shoppingList.items.unchecked, { id: this.itemId });
      if (index < 0) {
        this.component.error = 'Check item redo failed, item not found.';
        return;
      }

      this.component.checkItem(index, this.component.shoppingList.items.unchecked[index], { redoAction: true });
    }

    // eslint-disable-next-line

  }, {
    key: 'undoTooltip',
    value: function undoTooltip() {
      return 'Undo check item';
    }

    // eslint-disable-next-line

  }, {
    key: 'redoTooltip',
    value: function redoTooltip() {
      return 'Redo check item';
    }
  }]);

  return UndoCheckItem;
}(UndoAction);

var UndoUncheckItem = function (_UndoAction2) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(UndoUncheckItem, _UndoAction2);

  function UndoUncheckItem() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, UndoUncheckItem);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UndoUncheckItem.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(UndoUncheckItem)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(UndoUncheckItem, [{
    key: 'undo',
    value: function undo() {
      var index = Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["findIndex"])(this.component.shoppingList.items.unchecked, { id: this.itemId });
      if (index < 0) {
        this.component.error = 'Uncheck item undo failed, item not found.';
        return;
      }

      this.component.checkItem(index, this.component.shoppingList.items.unchecked[index], { undoAction: this });
    }
  }, {
    key: 'redo',
    value: function redo() {
      var index = Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["findIndex"])(this.component.shoppingList.items.checked, { id: this.itemId });
      if (index < 0) {
        this.component.error = 'Uncheck item redo failed, item not found.';
        return;
      }

      this.component.uncheckItem(index, this.component.shoppingList.items.checked[index], { redoAction: true });
    }

    // eslint-disable-next-line

  }, {
    key: 'undoTooltip',
    value: function undoTooltip() {
      return 'Undo uncheck item';
    }

    // eslint-disable-next-line

  }, {
    key: 'redoTooltip',
    value: function redoTooltip() {
      return 'Redo uncheck item';
    }
  }]);

  return UndoUncheckItem;
}(UndoAction);

var UndoMoveItem = function (_UndoAction3) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(UndoMoveItem, _UndoAction3);

  function UndoMoveItem() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, UndoMoveItem);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UndoMoveItem.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(UndoMoveItem)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(UndoMoveItem, [{
    key: 'undo',
    value: function undo() {
      var _this4 = this;

      var currentList = this.component.shoppingList.items[this.meta.itemListName];
      var index = Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["findIndex"])(currentList, { id: this.itemId });
      if (index < 0) {
        this.error = 'Undo move item failed, item not found.';
        return;
      }

      if (index !== this.meta.newIndex) {
        /* eslint-disable no-console */
        console.error('Not good, item found at index ' + index + ', expected ' + this.meta.newIndex);
      }

      var optRespList = [];
      currentList.forEach(function (item, itrIndex) {
        if (itrIndex === _this4.meta.index) {
          optRespList.push(Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["clone"])(currentList[_this4.meta.newIndex]));
        } else if (itrIndex !== _this4.meta.newIndex) {
          optRespList.push(Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["clone"])(item));
        }
      });

      var drag = {
        active: this.meta.itemListName,
        evt: {
          draggedContext: {
            element: {
              id: this.itemId
            },
            futureIndex: this.meta.index,
            index: this.meta.newIndex
          }
        }
      };

      this.component.moveItem(this.meta.itemListName, optRespList, drag, { undoAction: this });
    }
  }, {
    key: 'redo',
    value: function redo() {
      var _this5 = this;

      var currentList = this.component.shoppingList.items[this.meta.itemListName];
      var index = Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["findIndex"])(currentList, { id: this.itemId });
      if (index < 0) {
        this.error = 'Undo move item failed, item not found.';
        return;
      }

      if (index !== this.meta.index) {
        /* eslint-disable no-console */
        console.error('Not good, item found at index ' + index + ', expected ' + this.meta.newIndex);
      }

      var optRespList = [];
      currentList.forEach(function (item, itrIndex) {
        if (itrIndex === _this5.meta.newIndex) {
          optRespList.push(Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["clone"])(currentList[_this5.meta.index]));
        } else if (itrIndex !== _this5.meta.index) {
          optRespList.push(Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["clone"])(item));
        }
      });

      var drag = {
        active: this.meta.itemListName,
        evt: {
          draggedContext: {
            element: {
              id: this.itemId
            },
            futureIndex: this.meta.newIndex,
            index: this.meta.index
          }
        }
      };

      this.component.moveItem(this.meta.itemListName, optRespList, drag, { redoAction: true });
    }

    // eslint-disable-next-line

  }, {
    key: 'undoTooltip',
    value: function undoTooltip() {
      return 'Undo move item';
    }

    // eslint-disable-next-line

  }, {
    key: 'redoTooltip',
    value: function redoTooltip() {
      return 'Redo move item';
    }
  }]);

  return UndoMoveItem;
}(UndoAction);

var UndoDeleteItem = function (_UndoAction4) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(UndoDeleteItem, _UndoAction4);

  function UndoDeleteItem() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, UndoDeleteItem);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UndoDeleteItem.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(UndoDeleteItem)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(UndoDeleteItem, [{
    key: 'undo',
    value: function undo() {
      var _this7 = this;

      this.component.addItem(this.meta.item, this.meta.index, this.meta.itemListName, { undoAction: this }).then(function (_ref) {
        var item = _ref.item;

        // Item id has changed, go through an update any updo/redo items
        _this7.component.updateUndoRedoItem({
          oldItemId: _this7.itemId,
          newItemId: item.id
        });
      });
    }
  }, {
    key: 'redo',
    value: function redo() {
      this.component.deleteItem(this.meta.index, this.meta.itemListName, { redoAction: true });
    }

    // eslint-disable-next-line

  }, {
    key: 'undoTooltip',
    value: function undoTooltip() {
      return 'Undo delete item';
    }

    // eslint-disable-next-line

  }, {
    key: 'redoTooltip',
    value: function redoTooltip() {
      return 'Redo delete item';
    }
  }]);

  return UndoDeleteItem;
}(UndoAction);

var UndoAddItem = function (_UndoAction5) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(UndoAddItem, _UndoAction5);

  function UndoAddItem() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, UndoAddItem);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UndoAddItem.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(UndoAddItem)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(UndoAddItem, [{
    key: 'undo',
    value: function undo() {
      this.component.deleteItem(this.meta.index, this.meta.itemListName, { undoAction: this });
    }
  }, {
    key: 'redo',
    value: function redo() {
      var _this9 = this;

      this.component.addItem(this.meta.item, this.meta.index, this.meta.itemListName, { redoAction: true }).then(function (_ref2) {
        var item = _ref2.item;

        // Item id has changed, go through an update any updo/redo items
        _this9.component.updateUndoRedoItem({
          oldItemId: _this9.itemId,
          newItemId: item.id
        });
      });
    }

    // eslint-disable-next-line

  }, {
    key: 'undoTooltip',
    value: function undoTooltip() {
      return 'Undo add item';
    }

    // eslint-disable-next-line

  }, {
    key: 'redoTooltip',
    value: function redoTooltip() {
      return 'Redo add item';
    }
  }]);

  return UndoAddItem;
}(UndoAction);

var UndoChangeItem = function (_UndoAction6) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(UndoChangeItem, _UndoAction6);

  function UndoChangeItem() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, UndoChangeItem);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UndoChangeItem.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(UndoChangeItem)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(UndoChangeItem, [{
    key: 'undo',
    value: function undo() {
      var currentList = this.component.shoppingList.items[this.meta.listName];
      var index = Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["findIndex"])(currentList, { id: this.itemId });
      if (index < 0) {
        this.component.error = 'Change item undo failed, item not found.';
        return;
      }

      this.component.changeItem(this.meta.listName, index, currentList[index], this.meta.origDescription, { undoAction: this });
    }
  }, {
    key: 'redo',
    value: function redo() {
      var currentList = this.component.shoppingList.items[this.meta.listName];
      var index = Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["findIndex"])(currentList, { id: this.itemId });
      if (index < 0) {
        this.component.error = 'Change item redo failed, item not found.';
        return;
      }

      this.component.changeItem(this.meta.listName, index, currentList[index], this.meta.newDescription, { redoAction: true });
    }

    // eslint-disable-next-line

  }, {
    key: 'undoTooltip',
    value: function undoTooltip() {
      return 'Undo change item';
    }

    // eslint-disable-next-line

  }, {
    key: 'redoTooltip',
    value: function redoTooltip() {
      return 'Redo change item';
    }
  }]);

  return UndoChangeItem;
}(UndoAction);

var mixin = {
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["e" /* mapState */])('shoppingList', ['undoStack', 'redoStack']), {
    undoTooltip: function undoTooltip() {
      if (this.undoStack.length) {
        var undoAction = this.undoStack[this.undoStack.length - 1];
        return undoAction.undoTooltip();
      }

      return 'Undo';
    },
    redoTooltip: function redoTooltip() {
      if (this.redoStack.length) {
        var undoAction = this.redoStack[this.redoStack.length - 1];
        return undoAction.redoTooltip();
      }

      return 'Redo';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('shoppingList', ['pushUndo', 'pushRedo', 'updateUndoRedoItem', 'clearUndoRedo']), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])('shoppingList', ['popUndo', 'popRedo']), {
    undo: function undo() {
      var _this11 = this;

      return this.$store.dispatch('shoppingList/popUndo').then(function (undoAction) {
        undoAction.undo();
      }).catch(function (err) {
        _this11.error = err.message;
      });
    },
    redo: function redo() {
      var _this12 = this;

      return this.$store.dispatch('shoppingList/popRedo').then(function (undoAction) {
        undoAction.redo();
      }).catch(function (err) {
        _this12.error = err.message;
      });
    }
  })
};



/***/ }),

/***/ "PSA9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PbhX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewAppToolbar_vue__ = __webpack_require__("toOT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_051a8d91_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewAppToolbar_vue__ = __webpack_require__("5qOA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewAppToolbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_051a8d91_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewAppToolbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("vqcF")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PkDk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_routing__ = __webpack_require__("5m/v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_i18n__ = __webpack_require__("i94f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NewCategories__ = __webpack_require__("qEt2");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// TODO these are in RecipeForm too
function copyString(src) {
  var defValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return src ? src.slice() : defValue;
}

function copyArray(src) {
  var defValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  // shallow
  return src ? src.slice() : defValue;
}

var FormData = function FormData() {
  var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormData);

  this.name = copyString(o.name);
  this.link = copyString(o.link);
  this.description = copyString(o.description);
  this.categories = copyArray(o.categories);
  this.access = copyString(o.access, 'private');
  this.address = {
    street: copyString(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(o, 'address.street')),
    city: copyString(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(o, 'address.city')),
    state: copyString(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(o, 'address.state')),
    country: copyString(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(o, 'address.country'))
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'restaurant-form',
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_routing__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_i18n__["a" /* default */]],
  props: {
    id: {
      // Edit mode if this is set
      type: String,
      required: false
    }
  },
  data: function data() {
    return {
      form: new FormData()
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      return _this.resetForm();
    });
  },

  methods: {
    submit: function submit() {
      var _this2 = this;

      // TODO add validation!
      // TODO add validation!

      if (this.id) {
        this.$store.dispatch('restaurant/updateRestaurant', { id: this.id, restaurant: this.form }).then(function (returnedRestaurant) {
          _this2.routeFoodItem({ type: 'Restaurant', id: returnedRestaurant.id, noBack: true });
        }).catch(function (err) {
          return _this2.$emit('flash', err.message);
        });
      } else {
        this.$store.dispatch('restaurant/saveRestaurant', this.form).then(function (id) {
          _this2.routeFoodItem({ type: 'Restaurant', id: id, noBack: true });
        }).catch(function (err) {
          return _this2.$emit('flash', err.message);
        });
      }
    },
    confirmReset: function confirmReset() {
      var self = this;
      this.$dialog.confirm({
        title: 'Reset Form',
        message: 'Are you sure?',
        confirmText: 'Reset',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: function onConfirm() {
          self.resetForm();
        }
      });
    },
    resetForm: function resetForm() {
      var self = this;
      var promise = void 0;
      if (this.id) {
        var loading = this.$loading.open();
        promise = this.$store.dispatch('restaurant/fetchRestaurant', this.id).then(function () {
          // restaurant is frozen, because it's in the graphql store
          self.form = new FormData(self.restaurant);
          loading.close();
        }).catch(function (err) {
          self.error = err.message;
        });
      } else {
        this.form = new FormData();
        promise = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      }

      return promise.then(function () {
        return self.$refs.name.focus();
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['categoryNames']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('restaurant', ['restaurant'])),
  components: {
    NewCategories: __WEBPACK_IMPORTED_MODULE_7__NewCategories__["a" /* default */]
  }
});

/***/ }),

/***/ "QECK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrowseAppToolbar_vue__ = __webpack_require__("MAht");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1907e1e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrowseAppToolbar_vue__ = __webpack_require__("qd9B");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrowseAppToolbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1907e1e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrowseAppToolbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("vqcF")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QnEy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero"},[_c('div',{staticClass:"hero-body"},[(_vm.shoppingList)?_c('div',{staticClass:"container"},[(_vm.error)?_c('div',{staticClass:"notification is-danger"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"title"},[(!_vm.editTitleMode)?_c('span',{on:{"mouseover":function($event){_vm.showEditTitleButton = true},"mouseout":function($event){_vm.showEditTitleButton = false}}},[_vm._v("\n          "+_vm._s(_vm.name)+"\n          "),(_vm.isMobile() || _vm.showEditTitleButton)?_c('button',{staticClass:"button is-white disable-hover",on:{"click":_vm.editTitleEnabled}},[_c('b-icon',{attrs:{"pack":"fas","icon":"pencil-alt","size":"is-small"}})],1):_vm._e()]):_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newTitle),expression:"newTitle"}],ref:"titleInput",staticClass:"input title-input",attrs:{"type":"text","placeholder":_vm.name},domProps:{"value":(_vm.newTitle)},on:{"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.editTitleOk($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }return _vm.editTitleCancel($event)}],"input":function($event){if($event.target.composing){ return; }_vm.newTitle=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"button is-white",on:{"click":_vm.editTitleOk}},[_c('b-icon',{attrs:{"pack":"fas","icon":"check","size":"is-small"}})],1),_vm._v(" "),_c('button',{staticClass:"button is-white",on:{"click":_vm.editTitleCancel}},[_c('b-icon',{attrs:{"pack":"fas","icon":"times","size":"is-small"}})],1)])]),_vm._v(" "),(_vm.shoppingList.modifiedAt)?[_c('h2',{staticClass:"subtitle modified-at",style:(_vm.modifiedAtStyle)},[_vm._v("\n          "+_vm._s(_vm.$t('lastModified'))+" "+_vm._s(_vm.lastModified)+"  \n          "),(_vm.synching)?_c('b-icon',{attrs:{"pack":"fas","icon":"spinner","size":"is-small","custom-class":"fa-pulse"}}):_vm._e()],1),_vm._v(" "),_c('p',[_c('b-tooltip',{attrs:{"label":_vm.$t('clearAll'),"active":_vm.showTooltips,"position":"is-bottom"}},[_c('button',{staticClass:"button",on:{"click":_vm.clearAll}},[_c('b-icon',{attrs:{"pack":"fas","icon":"trash-alt","size":"is-small"}})],1)]),_vm._v(" "),_c('b-tooltip',{attrs:{"label":_vm.undoTooltip,"active":_vm.showTooltips,"position":"is-bottom"}},[_c('button',{staticClass:"button",attrs:{"disabled":_vm.undoStack.length === 0},on:{"click":_vm.undoLastAction}},[_c('b-icon',{attrs:{"pack":"fas","icon":"undo-alt","size":"is-small"}})],1)]),_vm._v(" "),_c('b-tooltip',{attrs:{"label":_vm.redoTooltip,"active":_vm.showTooltips,"position":"is-bottom"}},[_c('button',{staticClass:"button",attrs:{"disabled":_vm.redoStack.length === 0},on:{"click":_vm.redoLastAction}},[_c('b-icon',{attrs:{"pack":"fas","icon":"redo-alt","size":"is-small"}})],1)])],1)]:(_vm.synching)?_c('b-icon',{attrs:{"pack":"fas","icon":"spinner","size":"is-small","custom-class":"fa-pulse"}}):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.shoppingList && _vm.foodItems)?_c('div',{staticClass:"content"},[_c('div',{staticClass:"columns is-variable is-8"},[_c('div',{staticClass:"column is-narrow shopping-list-column"},[_c('shopping-list-item-list',{attrs:{"name":_vm.$t('items'),"checked":false},on:{"drag-start":function($event){_vm.drag.active = 'unchecked'},"drag-end":function($event){_vm.drag.active = null},"drag-move":function (evt) { return _vm.drag.evt = evt; },"checkbox":function (args) { return _vm.triggerAction(_vm.Actions.CheckItemAction, args); },"change":_vm.changeUncheckedItem,"delete":function (index) { return _vm.triggerAction(_vm.Actions.DeleteItemAction, { index: index, itemListName: 'unchecked' }); }},model:{value:(_vm.uncheckedItemList),callback:function ($$v) {_vm.uncheckedItemList=$$v},expression:"uncheckedItemList"}}),_vm._v(" "),_c('p'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.addNewItem()}}},[_c('div',{staticClass:"field has-addons"},[_c('p',{staticClass:"control is-expanded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newItemDescription),expression:"newItemDescription"}],ref:"newItemDescription",staticClass:"input is-expanded",attrs:{"type":"text","placeholder":_vm.$t('newItem')},domProps:{"value":(_vm.newItemDescription)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newItemDescription=$event.target.value}}})]),_vm._v(" "),_vm._m(0)])])],1),_vm._v(" "),_c('div',{staticClass:"column is-narrow shopping-list-column"},[_c('shopping-list-item-list',{attrs:{"name":_vm.$t('purchased'),"checked":true},on:{"drag-start":function($event){_vm.drag.active = 'checked'},"drag-end":function($event){_vm.drag.active = null},"drag-move":function (evt) { return _vm.drag.evt = evt; },"checkbox":function (args) { return _vm.triggerAction(_vm.Actions.UncheckItemAction, args); },"change":_vm.changeCheckedItem,"delete":function (index) { return _vm.triggerAction(_vm.Actions.DeleteItemAction, { index: index, itemListName: 'checked' }); }},model:{value:(_vm.checkedItemList),callback:function ($$v) {_vm.checkedItemList=$$v},expression:"checkedItemList"}})],1)])]):_vm._e()],2):(_vm.error)?_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v("Invalid shopping list")])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"control"},[_c('button',{staticClass:"button is-primary",attrs:{"role":"button"}},[_vm._v("Add")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T2Z4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingListItemList_vue__ = __webpack_require__("/9As");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06627c96_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingListItemList_vue__ = __webpack_require__("1Z1v");
function injectStyle (ssrContext) {
  __webpack_require__("d5Qh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06627c96"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingListItemList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06627c96_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingListItemList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TIfe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return register; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return userInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAuthToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAuthHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkAuthenticated; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_fetch__ = __webpack_require__("Vo7i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__errors__ = __webpack_require__("pvCZ");






var AUTH_PATH = '/api/auth';
var LOGIN_URL = AUTH_PATH + '/login';
var REGISTER_URL = AUTH_PATH + '/register';
var USER_INFO_URL = AUTH_PATH + '/user-info';
var TOKEN_KEY = 'id_token';

function toUser(obj) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(obj, ['id', 'username', 'firstName', 'lastName']);
}

function login(credentials) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_fetch__["b" /* http */].post(LOGIN_URL, credentials).then(function (response) {
    localStorage.setItem(TOKEN_KEY, response.data.token);
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('authenticated', true);
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('user', toUser(response.data));
    return true;
  }).catch(function (error) {
    localStorage.removeItem(TOKEN_KEY);
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('authenticated', null);
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('user', null);

    if (error.response) {
      throw new __WEBPACK_IMPORTED_MODULE_4__errors__["a" /* BadResponse */](error.response.data);
    }

    throw error;
  });
}

function logout() {
  // TODO close up the websocket
  // TODO
  // wsClient.unsubscribeAll();
  // wsClient.close();
  __WEBPACK_IMPORTED_MODULE_3__utils_fetch__["a" /* graphql */].resetStore();
  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('authenticated', false);
  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('user', null);
  localStorage.removeItem(TOKEN_KEY);
}

function register(credentials) {
  logout();

  return __WEBPACK_IMPORTED_MODULE_3__utils_fetch__["b" /* http */].post(REGISTER_URL, credentials).then(function (response) {
    localStorage.setItem(TOKEN_KEY, response.data.token);
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('authenticated', true);
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('user', toUser(response.data));
    return true;
  }).catch(function (error) {
    if (error.response) {
      throw new __WEBPACK_IMPORTED_MODULE_4__errors__["a" /* BadResponse */](error.response.data);
    }

    throw error;
  });
}

function getAuthToken() {
  // TODO
  // TODO
  // TODO
  // TODO
  // 2018-07-31 for some reason TOKEN_KEY is not working, but 'id_token' is???
  // return localStorage.getItem(TOKEN_KEY);
  return localStorage.getItem('id_token');
}

function getAuthHeader() {
  var header = {
    Authorization: ''
  };

  var token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    header.Authorization = 'Bearer ' + token;
  }

  return header;
}

function userInfo() {
  return __WEBPACK_IMPORTED_MODULE_3__utils_fetch__["b" /* http */].get(USER_INFO_URL, { headers: getAuthHeader() }).then(function (response) {
    return response.data;
  }).catch(function (error) {
    if (error instanceof __WEBPACK_IMPORTED_MODULE_4__errors__["b" /* IgnoreError */]) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });
}

function checkAuthenticated() {
  if (localStorage.getItem(TOKEN_KEY)) {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('authenticated', true);
  } else {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('authenticated', false);
  }

  return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.authenticated;
}



/***/ }),

/***/ "TT2Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Action__ = __webpack_require__("kG4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__graphql_shopping_list__ = __webpack_require__("C1JH");








/* eslint-disable no-underscore-dangle */

// TODO Which shopping list are items being added to?

var AddItemsAction = function (_Action) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AddItemsAction, _Action);

  function AddItemsAction(options) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AddItemsAction);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AddItemsAction.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AddItemsAction)).call(this, options));

    _this.items = options.list;
    _this.refetchShoppingList = _this.component.name !== 'shoppingList';
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AddItemsAction, [{
    key: '_executeImpl',
    value: function _executeImpl() {
      var _this2 = this;

      var mutateOptions = {
        mutation: __WEBPACK_IMPORTED_MODULE_6__graphql_shopping_list__["b" /* ADD_ITEMS */],
        variables: {
          items: this.items
        }
      };

      if (this.refetchShoppingList) {
        mutateOptions.refetchQueries = [{
          query: __WEBPACK_IMPORTED_MODULE_6__graphql_shopping_list__["j" /* LIST_QUERY */],
          variables: { id: null }
        }];
      } else {
        mutateOptions.update = function (store, _ref) {
          var shoppingListAddItems = _ref.data.shoppingListAddItems;

          _this2._updateCache(store, shoppingListAddItems);
        };
      }

      return this.component.$apollo.mutate(mutateOptions);
    }

    /* eslint-disable class-methods-use-this */

  }, {
    key: 'updateQuery',
    value: function updateQuery(cachedShoppingList, shoppingListAddItemsResult) {
      cachedShoppingList.items.unchecked = shoppingListAddItemsResult.list;
      return cachedShoppingList;
    }
  }], [{
    key: 'name',
    get: function get() {
      return 'AddItemsAction';
    }
  }]);

  return AddItemsAction;
}(__WEBPACK_IMPORTED_MODULE_5__Action__["a" /* Action */]);

/* harmony default export */ __webpack_exports__["a"] = (AddItemsAction);

/***/ }),

/***/ "TVss":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecipeForm_vue__ = __webpack_require__("IuM5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08d8fe03_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecipeForm_vue__ = __webpack_require__("znCk");
function injectStyle (ssrContext) {
  __webpack_require__("XIuU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08d8fe03"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecipeForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08d8fe03_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecipeForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("XTbL")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TrFT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo1.b7a1dbc.png";

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  initDataLoaded: function initDataLoaded(s) {
    return s.categoryNames !== null;
  },
  categoryNames: function categoryNames(s) {
    return s.categoryNames;
  },
  typeaheadResults: function typeaheadResults(s) {
    return s.typeaheadResults;
  },
  authenticated: function authenticated(s) {
    return s.authenticated;
  },
  user: function user(s) {
    return s.user;
  },
  locale: function locale(s) {
    return s.locale;
  },
  notify: function notify(s) {
    return s.notify;
  }
});

/***/ }),

/***/ "Uz8Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VBwL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VUIP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__("2R8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__("tlQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_fetch__ = __webpack_require__("Vo7i");


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['query Recipe($id: ID!) {\n        recipeById(id: $id) {\n          ...recipeFields\n        }\n      }\n      ', ''], ['query Recipe($id: ID!) {\n        recipeById(id: $id) {\n          ...recipeFields\n        }\n      }\n      ', '']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['mutation Recipe($recipe: RecipeInput!) {\n        createRecipe(recipe: $recipe) {\n          id\n        }\n      }'], ['mutation Recipe($recipe: RecipeInput!) {\n        createRecipe(recipe: $recipe) {\n          id\n        }\n      }']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['mutation Recipe($id: ID!, $recipe: RecipeInput!) {\n        updateRecipe(id: $id, recipe: $recipe) {\n          ...recipeFields\n        }\n      }\n      ', ''], ['mutation Recipe($id: ID!, $recipe: RecipeInput!) {\n        updateRecipe(id: $id, recipe: $recipe) {\n          ...recipeFields\n        }\n      }\n      ', '']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['mutation Recipe($id: ID!) {\n        deleteRecipe(id: $id) {\n          ...recipeFields\n        }\n      }\n      ', ''], ['mutation Recipe($id: ID!) {\n        deleteRecipe(id: $id) {\n          ...recipeFields\n        }\n      }\n      ', '']);

// Recipe view state



var RECIPE_FRAGMENT = ' fragment recipeFields on Recipe {\n      id\n      name\n      access\n      categories\n      link\n      description\n      ingredients\n      directions\n      prepTimeMin\n      servings\n    }\n  ';

var state = {
  // The recipe to view
  recipe: null
};

var getters = {
  recipe: function recipe(s) {
    return s.recipe;
  }
};

var mutations = {
  recipe: function recipe(s, r) {
    s.recipe = r;
  }
};

var actions = {
  fetchRecipe: function fetchRecipe(_ref, id) {
    var commit = _ref.commit;

    return __WEBPACK_IMPORTED_MODULE_2__utils_fetch__["a" /* graphql */].query({
      query: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject, RECIPE_FRAGMENT),
      variables: {
        id: id
      }
    }).then(function (response) {
      if (!response.data.recipeById) {
        commit('recipe', null);
        throw new Error('Unknown recipe');
      }
      commit('recipe', response.data.recipeById);
      return response.data.recipeById;
    }).catch(function (err) {
      commit('recipe', null);
      throw err;
    });
  },
  saveRecipe: function saveRecipe(_ref2, recipe) {
    var commit = _ref2.commit;

    return __WEBPACK_IMPORTED_MODULE_2__utils_fetch__["a" /* graphql */].mutate({
      mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject2),
      variables: {
        recipe: recipe
      }
    }).then(function (response) {
      commit('notify', {
        message: 'Recipe created',
        type: 'is-success'
      }, { root: true });

      // TODO knowledge of 'foodItems' query should not be here
      __WEBPACK_IMPORTED_MODULE_2__utils_fetch__["a" /* graphql */].localExtensions.invalidateStoreQuery('foodItems');
      return response.data.createRecipe.id;
    });
  },
  updateRecipe: function updateRecipe(_ref3, _ref4) {
    var commit = _ref3.commit;
    var id = _ref4.id,
        recipe = _ref4.recipe;

    return __WEBPACK_IMPORTED_MODULE_2__utils_fetch__["a" /* graphql */].mutate({
      mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject3, RECIPE_FRAGMENT),
      variables: {
        id: id,
        recipe: recipe
      }
    }).then(function (response) {
      if (!response.data.updateRecipe) {
        commit('recipe', null);
        throw new Error('Unknown recipe');
      }

      commit('notify', {
        message: 'Recipe updated',
        type: 'is-success'
      }, { root: true });

      // TODO knowledge of 'foodItems' query should not be here
      __WEBPACK_IMPORTED_MODULE_2__utils_fetch__["a" /* graphql */].localExtensions.invalidateStoreQuery('foodItems');
      return response.data.updateRecipe;
    }).catch(function (err) {
      commit('recipe', null);
      throw err;
    });
  },
  deleteRecipe: function deleteRecipe(_ref5, id) {
    var commit = _ref5.commit;

    return __WEBPACK_IMPORTED_MODULE_2__utils_fetch__["a" /* graphql */].mutate({
      mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject4, RECIPE_FRAGMENT),
      variables: {
        id: id
      }
    }).then(function (response) {
      if (!response.data.deleteRecipe) {
        throw new Error('Unknown recipe');
      }

      commit('recipe', null);

      commit('notify', {
        message: 'Recipe deleted',
        type: 'is-success'
      }, { root: true });

      // TODO knowledge of 'foodItems' query should not be here
      __WEBPACK_IMPORTED_MODULE_2__utils_fetch__["a" /* graphql */].localExtensions.invalidateStoreQuery('foodItems');
    }).catch(function (err) {
      throw err;
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ "Vo7i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return graphql; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return http; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apollo_client__ = __webpack_require__("u1/p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apollo_link__ = __webpack_require__("uekS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_apollo_link_http__ = __webpack_require__("rp1p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_apollo_link_context__ = __webpack_require__("SR+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_apollo_link_error__ = __webpack_require__("rRT0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_apollo_cache_inmemory__ = __webpack_require__("+dIz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_apollo_link_ws__ = __webpack_require__("Z6Fn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_apollo_utilities__ = __webpack_require__("+zi7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__auth__ = __webpack_require__("TIfe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__errors__ = __webpack_require__("pvCZ");

















var sessionId = __WEBPACK_IMPORTED_MODULE_12_uuid_v4___default()();

function handleUnauthorized(message) {
  Object(__WEBPACK_IMPORTED_MODULE_13__auth__["e" /* logout */])();
  __WEBPACK_IMPORTED_MODULE_14__router__["a" /* default */].push({
    name: 'login',
    params: { message: message }
  });
}

// TODO
// https://www.apollographql.com/docs/react/recipes/fragment-matching.html
// Make this part of a build step - can probably get info from makeExecutableSchema
var fragmentMatcher = new __WEBPACK_IMPORTED_MODULE_9_apollo_cache_inmemory__["b" /* IntrospectionFragmentMatcher */]({
  introspectionQueryResultData: {
    __schema: {
      types: [{
        kind: 'INTERFACE',
        name: 'FoodItem',
        possibleTypes: [{ name: 'Recipe' }, { name: 'Restaurant' }]
      }]
    }
  }
});

var errorLink = Object(__WEBPACK_IMPORTED_MODULE_8_apollo_link_error__["a" /* onError */])(function (_ref) {
  var networkError = _ref.networkError,
      graphQLErrors = _ref.graphQLErrors;

  if (networkError && networkError.statusCode === 401) {
    handleUnauthorized(networkError.result);
  }

  if (graphQLErrors) {
    graphQLErrors.map(function (_ref2) {
      var message = _ref2.message,
          location = _ref2.location,
          path = _ref2.path;
      return (
        /* eslint-disable no-console */
        console.error('Graphql error: ' + message + ', ' + location + ', ' + path)
      );
    });
  }
});

var httpLink = new __WEBPACK_IMPORTED_MODULE_6_apollo_link_http__["a" /* HttpLink */]({
  uri: window.location.protocol + '//' + window.location.host + '/api/graphql/exec'
});

var wsProtocol = /^https/.test(window.location.protocol) ? 'wss' : 'ws';
var wsLink = new __WEBPACK_IMPORTED_MODULE_10_apollo_link_ws__["a" /* WebSocketLink */]({
  uri: wsProtocol + '://' + window.location.host + '/api/graphql/subscriptions',
  options: {
    reconnect: true,
    lazy: true,
    connectionParams: {
      authToken: Object(__WEBPACK_IMPORTED_MODULE_13__auth__["c" /* getAuthToken */])(),
      sessionId: sessionId
    }
  }
});

var authLink = Object(__WEBPACK_IMPORTED_MODULE_7_apollo_link_context__["a" /* setContext */])(function (_, _ref3) {
  var headers = _ref3.headers;

  var authHeader = Object(__WEBPACK_IMPORTED_MODULE_13__auth__["b" /* getAuthHeader */])();
  var sessionIdHeader = {
    'X-Session-Id': sessionId
  };

  return {
    headers: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, headers, authHeader, sessionIdHeader)
  };
});

var fullHttpLink = __WEBPACK_IMPORTED_MODULE_5_apollo_link__["a" /* ApolloLink */].from([authLink, errorLink, httpLink]);

var wsAuthLink = new __WEBPACK_IMPORTED_MODULE_5_apollo_link__["a" /* ApolloLink */](function (operation, forward) {
  var authHeader = Object(__WEBPACK_IMPORTED_MODULE_13__auth__["b" /* getAuthHeader */])();
  var sessionIdHeader = {
    'X-Session-Id': sessionId
  };
  operation.setContext({
    headers: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, authHeader, sessionIdHeader)
  });

  operation.authToken = Object(__WEBPACK_IMPORTED_MODULE_13__auth__["c" /* getAuthToken */])();
  operation.sessionId = sessionId;
  return forward(operation);
});

var fullWsLink = __WEBPACK_IMPORTED_MODULE_5_apollo_link__["a" /* ApolloLink */].from([wsAuthLink, wsLink]);

var link = Object(__WEBPACK_IMPORTED_MODULE_5_apollo_link__["e" /* split */])(function (_ref4) {
  var query = _ref4.query;

  var _getMainDefinition = Object(__WEBPACK_IMPORTED_MODULE_11_apollo_utilities__["i" /* getMainDefinition */])(query),
      kind = _getMainDefinition.kind,
      operation = _getMainDefinition.operation;

  return kind === 'OperationDefinition' && operation === 'subscription';
}, fullWsLink, fullHttpLink);

var graphql = new __WEBPACK_IMPORTED_MODULE_4_apollo_client__["a" /* ApolloClient */]({
  link: link,
  cache: new __WEBPACK_IMPORTED_MODULE_9_apollo_cache_inmemory__["a" /* InMemoryCache */]({ fragmentMatcher: fragmentMatcher }),
  connectToDevTools: true
});

graphql.localExtensions = {
  invalidateStoreQuery: function invalidateStoreQuery(queryName) {
    // TODO this is not documented API
    var rootQuery = graphql.store.cache.data.data.ROOT_QUERY;
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(rootQuery).filter(function (query) {
      return query.indexOf(queryName) === 0;
    }).forEach(function (query) {
      delete rootQuery[query];
    });
  }
};

__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.status === 401 && __WEBPACK_IMPORTED_MODULE_14__router__["a" /* default */].currentRoute.name !== 'login') {
    handleUnauthorized(error.response.data);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new __WEBPACK_IMPORTED_MODULE_15__errors__["b" /* IgnoreError */]('Interceptor handled 401'));
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

var http = __WEBPACK_IMPORTED_MODULE_3_axios___default.a;



/***/ }),

/***/ "Vq1x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrowseToolbar_vue__ = __webpack_require__("dGtv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03803930_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrowseToolbar_vue__ = __webpack_require__("zcgU");
function injectStyle (ssrContext) {
  __webpack_require__("Uz8Q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrowseToolbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03803930_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrowseToolbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("9qcu")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XDap":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__("U0v6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_routing__ = __webpack_require__("5m/v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_links__ = __webpack_require__("FzK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__foodItem_types__ = __webpack_require__("rt35");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__access__ = __webpack_require__("cHxH");

// Common component pieces for Browse views







var constMaxDescChars = 50;

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_routing__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_links__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])('browse', {
    toggleSort: 'toggleSort'
  }), {
    descClicked: function descClicked(fi) {
      this.$emit('descClicked', fi);
    },
    truncateDesc: function truncateDesc(desc) {
      if (desc.length > constMaxDescChars) {
        return desc.substring(0, constMaxDescChars) + '...';
      }
      return desc;
    },
    typeIcon: function typeIcon(id) {
      return this.types.getType(id).icon;
    },
    accessIcon: function accessIcon(accessId) {
      return __WEBPACK_IMPORTED_MODULE_6__access__["a" /* default */][accessId].icon;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    foodItems: 'browse/foodItems',
    sort: 'browse/sort'
  }), {
    sortField: function sortField() {
      return this.sort.field;
    },
    maxDescChars: function maxDescChars() {
      return constMaxDescChars;
    },
    types: function types() {
      return __WEBPACK_IMPORTED_MODULE_5__foodItem_types__["a" /* default */];
    },
    sortIcon: function sortIcon() {
      return this.sort.order === 'asc' ? 'sort-up' : 'sort-down';
    }
  }),
  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default.a
  }
});

/***/ }),

/***/ "XIuU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XTbL":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"public":"Public","private":"Private","shared":"Shared"},"es":{"public":"Publico","private":"Privado","shared":"NT-Shared-NT"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "Y2Nu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_browse_Browse__ = __webpack_require__("HzJv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shopping_list_ShoppingList__ = __webpack_require__("rpuk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_New__ = __webpack_require__("dSLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_recipe_Recipe__ = __webpack_require__("Aruq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_recipe_RecipeForm__ = __webpack_require__("TVss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_recipe_EditRecipe__ = __webpack_require__("duJS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_restaurant_Restaurant__ = __webpack_require__("3iax");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_restaurant_RestaurantForm__ = __webpack_require__("ZIli");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_restaurant_EditRestaurant__ = __webpack_require__("vRQs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Login__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Register__ = __webpack_require__("dIqY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_auth__ = __webpack_require__("TIfe");
















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    redirect: '/browse',
    meta: { requiresLogin: true }
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Login__["a" /* default */],
    props: true
  }, {
    path: '/register',
    name: 'register',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Register__["a" /* default */]
  }, {
    path: '/browse',
    name: 'browse',
    component: __WEBPACK_IMPORTED_MODULE_2__components_browse_Browse__["a" /* default */],
    meta: { requiresLogin: true }
  }, {
    path: '/shoppingList/:id',
    name: 'shoppingList',
    component: __WEBPACK_IMPORTED_MODULE_3__components_shopping_list_ShoppingList__["a" /* default */],
    props: true,
    meta: { requiresLogin: true }
  }, {
    path: '/new',
    name: 'new',
    component: __WEBPACK_IMPORTED_MODULE_4__components_New__["a" /* default */],
    meta: { requiresLogin: true, noBackRoute: true },
    children: [{
      path: 'recipe',
      name: 'new-recipe',
      component: __WEBPACK_IMPORTED_MODULE_6__components_recipe_RecipeForm__["a" /* default */]
    }, {
      path: 'restaurant',
      name: 'new-restaurant',
      component: __WEBPACK_IMPORTED_MODULE_9__components_restaurant_RestaurantForm__["a" /* default */]
    }]
  }, {
    path: '/edit/recipe/:id',
    name: 'edit-Recipe',
    component: __WEBPACK_IMPORTED_MODULE_7__components_recipe_EditRecipe__["a" /* default */],
    props: true,
    meta: { requiresLogin: true }
  }, {
    path: '/restaurant/:id',
    name: 'Restaurant',
    component: __WEBPACK_IMPORTED_MODULE_8__components_restaurant_Restaurant__["a" /* default */],
    props: true,
    meta: { requiresLogin: true }
  }, {
    path: '/recipe/:id',
    name: 'Recipe',
    component: __WEBPACK_IMPORTED_MODULE_5__components_recipe_Recipe__["a" /* default */],
    props: true,
    meta: { requiresLogin: true }
  }, {
    path: '/edit/restaurant/:id',
    name: 'edit-Restaurant',
    component: __WEBPACK_IMPORTED_MODULE_10__components_restaurant_EditRestaurant__["a" /* default */],
    props: true,
    meta: { requiresLogin: true }
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    return { x: 0, y: 0 };
  }
});

// TODO
// TODO
// refactor this to use this.$app.store instead of importing store
router.beforeEach(function (to, from, next) {
  if (from.name && !from.meta.noBackRoute) {
    __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].state.routed = true;
  }

  var checkFetchInitialData = function checkFetchInitialData(innerNext) {
    if (!__WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].getters.initDataLoaded) {
      __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].dispatch('fetchInitialData').then(function () {
        return innerNext();
      });
    } else {
      innerNext();
    }
  };

  if (to.matched.some(function (route) {
    return route.meta.requiresLogin;
  })) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_14__utils_auth__["a" /* checkAuthenticated */])()) {
      next('/login');
    } else if (!__WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].getters.user) {
      __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].dispatch('fetchUserInfo').then(function () {
        return checkFetchInitialData(next);
      }).catch(function () {
        // Some kind of error to user?
        Object(__WEBPACK_IMPORTED_MODULE_14__utils_auth__["e" /* logout */])();
        next('/login');
      });
    } else {
      checkFetchInitialData(next);
    }
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Yten":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"box"},[_c('restaurant-form',{attrs:{"id":_vm.id}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZAIw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZIli":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RestaurantForm_vue__ = __webpack_require__("PkDk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_159dce2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RestaurantForm_vue__ = __webpack_require__("12wK");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RestaurantForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_159dce2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RestaurantForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("XTbL")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aSPJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__graphql_shopping_list__ = __webpack_require__("C1JH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Action__ = __webpack_require__("kG4H");









/* eslint-disable no-underscore-dangle */

var MoveItemAction = function (_UndoAction) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MoveItemAction, _UndoAction);

  function MoveItemAction(options) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MoveItemAction);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MoveItemAction.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MoveItemAction)).call(this, options));

    if (options.drag) {
      if (options.drag.active !== options.itemListName) {
        throw new Error('Why is this being called, drag is not set');
      }

      var draggedContext = options.drag.evt.draggedContext;
      _this.itemId = draggedContext.element.id;
      _this.index = draggedContext.index;
      _this.newIndex = draggedContext.futureIndex;
    }

    _this.itemListName = options.itemListName;
    _this.value = options.value;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MoveItemAction, [{
    key: '_executeImpl',
    value: function _executeImpl() {
      var self = this;

      return this.component.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_6__graphql_shopping_list__["k" /* MOVE_ITEM */],
        variables: {
          id: this.component.shoppingList.id,
          itemId: this.itemId,
          newIndex: this.newIndex,
          itemListName: this.itemListName
        },
        update: function update(store, _ref) {
          var shoppingListMoveItem = _ref.data.shoppingListMoveItem;

          self._updateCache(store, shoppingListMoveItem);
        },

        optimisticResult: {
          shoppingListMoveItem: {
            /* eslint-disable no-underscore-dangle */
            __typename: 'ShoppingListMoveItemResult',
            list: self.value,
            modifiedAt: null
          }
        }
      });
    }
  }, {
    key: 'updateQuery',
    value: function updateQuery(cachedShoppingList, shoppingListMoveItemResult) {
      cachedShoppingList.items[this.itemListName] = shoppingListMoveItemResult.list;
      return cachedShoppingList;
    }
  }, {
    key: 'undo',
    value: function undo() {
      var _this2 = this;

      var currentList = this.component.shoppingList.items[this.itemListName];
      var index = Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["findIndex"])(currentList, { id: this.itemId });
      if (index < 0) {
        throw new Error('Undo move item failed, item not found.');
      }

      if (index !== this.newIndex) {
        /* eslint-disable no-console */
        console.error('Not good, item found at index ' + index + ', expected ' + this.newIndex);
      }

      // Create item list with items in the order prior to the move
      var priorItemList = [];
      currentList.forEach(function (item, itrIndex) {
        if (itrIndex === _this2.index) {
          priorItemList.push(Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["clone"])(currentList[_this2.newIndex]));
        } else if (itrIndex !== _this2.newIndex) {
          priorItemList.push(Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["clone"])(item));
        }
      });

      // Create new drag context to resuse logic expecting drag-and-drop
      var drag = {
        active: this.itemListName,
        evt: {
          draggedContext: {
            element: {
              id: this.itemId
            },
            futureIndex: this.index,
            index: this.newIndex
          }
        }
      };

      return this.component.triggerAction(MoveItemAction, {
        itemListName: this.itemListName,
        value: priorItemList,
        drag: drag,
        undoAction: this
      });
    }
  }, {
    key: 'updateItem',
    value: function updateItem(oldItem, newItem) {
      if (this.itemId === oldItem.id) {
        this.itemId = newItem.id;
      }
    }

    // eslint-disable-next-line

  }, {
    key: 'undoTooltip',
    value: function undoTooltip() {
      return 'Undo move item';
    }

    // eslint-disable-next-line

  }, {
    key: 'redoTooltip',
    value: function redoTooltip() {
      return 'Redo move item';
    }
  }], [{
    key: 'name',
    get: function get() {
      return 'MoveItemAction';
    }
  }]);

  return MoveItemAction;
}(__WEBPACK_IMPORTED_MODULE_7__Action__["b" /* UndoAction */]);

/* harmony default export */ __webpack_exports__["a"] = (MoveItemAction);

/***/ }),

/***/ "anyH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cHxH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ACCESS = {
  public: {
    icon: 'lock-open'
  },
  private: {
    icon: 'lock'
  },
  shared: {
    icon: 'share-alt'
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ACCESS);

/***/ }),

/***/ "cKKu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero"},[_c('div',{staticClass:"hero-body"},[(_vm.recipe)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-narrow"},[_c('h1',{staticClass:"title"},[_vm._v("\n            "+_vm._s(_vm.recipe.name)+"\n            "),(_vm.recipe.link)?_c('a',{staticClass:"mwf-link",attrs:{"href":_vm.recipe.link,"target":"_blank"}},[_c('span',{staticClass:"icon"},[(_vm.youTubeLink(_vm.recipe.link))?_c('font-awesome-icon',{attrs:{"icon":['fab', 'youtube']}}):_c('font-awesome-icon',{attrs:{"icon":"external-link-alt"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"button-group"},[_c('button',{staticClass:"button is-white",on:{"click":function($event){_vm.routeEditFoodItem({ type: 'Recipe', id: _vm.id })}}},[_c('b-icon',{attrs:{"pack":"fas","icon":"pencil-alt","size":"is-small"}})],1),_vm._v(" "),_c('button',{staticClass:"button is-white",on:{"click":_vm.deleteRecipe}},[_c('b-icon',{attrs:{"pack":"fas","icon":"trash-alt","size":"is-small"}})],1)])]),_vm._v(" "),(_vm.prepTime || _vm.servings)?_c('h2',{staticClass:"subtitle"},[(_vm.prepTime)?[_c('span',{staticClass:"icon"},[_c('font-awesome-icon',{attrs:{"size":"xs","icon":"stopwatch"}})],1),_vm._v("\n              "+_vm._s(_vm.prepTime)+"\n            ")]:_vm._e(),_vm._v(" "),(_vm.servings)?[_c('span',{staticClass:"icon"},[_c('font-awesome-icon',{attrs:{"size":"xs","icon":"utensils"}})],1),_vm._v("\n              "+_vm._s(_vm.servings)+"\n            ")]:_vm._e()],2):_c('h2',[_vm._v("Recipe")]),_vm._v(" "),_c('div',{staticClass:"tags"},_vm._l((_vm.recipe.categories),function(cat){return _c('span',{key:cat,staticClass:"tag is-info"},[_vm._v("\n              "+_vm._s(cat)+"\n            ")])}))]),_vm._v(" "),(_vm.youTubeLink(_vm.recipe.link))?_c('div',{staticClass:"column is-offset-1"},[_c('div',{staticClass:"video-responsive"},[_c('iframe',{attrs:{"width":"560","height":"315","src":_vm.youTubeLink(_vm.recipe.link),"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"mwf-desc"},[_vm._v("\n        "+_vm._s(_vm.recipe.description)+"\n      ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-narrow"},[_c('h4',{staticClass:"title is-4"},[_vm._v("Ingredients")]),_vm._v(" "),_c('h6',{staticClass:"subtitle is-6"},[_c('a',{attrs:{"role":"button"},on:{"click":_vm.sendToShoppingListClicked}},[_vm._v("Send to Shopping List")])]),_vm._v(" "),_c('ul',{staticClass:"ingredient-list"},_vm._l((_vm.recipe.ingredients),function(ingredient,index){return _c('li',{key:index},[_vm._v("\n                "+_vm._s(ingredient)+"\n              ")])}))]),_vm._v(" "),(_vm.recipe.directions && _vm.recipe.directions.length)?_c('div',{staticClass:"column is-offset-1"},[_c('h4',{staticClass:"title is-4"},[_vm._v("Directions")]),_vm._v(" "),_c('h6',{staticClass:"subtitle is-6"},[_c('a',{attrs:{"role":"button"},on:{"click":_vm.clearDirectionChecks}},[_vm._v("Clear")])]),_vm._v(" "),_vm._l((_vm.recipe.directions),function(direction,index){return _c('p',{key:index},[_c('large-checkbox',{attrs:{"val":index,"checkbox-side":"left"},model:{value:(_vm.directionChecks),callback:function ($$v) {_vm.directionChecks=$$v},expression:"directionChecks"}},[_vm._v(_vm._s(direction))])],1)})],2):_vm._e()])])]):(_vm.error)?_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v("Invalid recipe id")])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cZRz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RestaurantForm__ = __webpack_require__("ZIli");
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'edit-Restaurant',
  props: ['id'],
  components: {
    RestaurantForm: __WEBPACK_IMPORTED_MODULE_0__RestaurantForm__["a" /* default */]
  }
});

/***/ }),

/***/ "cZxk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__("U0v6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__foodItem_types__ = __webpack_require__("rt35");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'search-bar',
  props: {
    matchesFound: {
      type: Object,
      required: true
    },
    limit: {
      type: Number,
      default: 5,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    async: {
      type: Boolean,
      default: true,
      required: false
    },
    placeholder: {
      type: String,
      default: function _default() {
        return '';
      },

      required: false
    }
  },
  data: function data() {
    return {
      query: '',
      foodItemMatches: [],
      categoryMatches: [],
      firstTouch: true,
      preselected: 0
    };
  },

  watch: {
    query: function query(value) {
      if (this.async) {
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(this.getMatches, 150)(value);
      } else {
        this.getMatches(value);
      }

      this.$emit('change', value);
    },
    matchesFound: function matchesFound(values) {
      var _this = this;

      this.foodItemMatches = [];
      this.categoryMatches = [];

      if (!this.query || values.query !== this.query || values.foodItems.length === 0 && values.categories.length === 0) {
        return;
      }

      var foodItemMatches = [];
      var categoryMatches = [];
      values.foodItems.forEach(function (value) {
        // TODO attempting to duplicate backend regix logic, have backend
        // return index?
        var index = value.name.search(new RegExp('\\b' + _this.query, 'i'));
        // TODO assert index !== -1
        var substr1 = value.name.substring(0, index);
        var substr2 = '<strong>' + value.name.slice(index, index + _this.query.length) + '</strong>';
        var substr3 = value.name.substring(index + _this.query.length);

        var match = substr1 + substr2 + substr3;

        if (index === 0) {
          foodItemMatches.unshift(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ match: match }, value));
        } else {
          foodItemMatches.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ match: match }, value));
        }
      }, this);

      values.categories.forEach(function (value, index) {
        // Categories can match from the start for now
        var substr1 = '<strong>' + value.slice(0, _this.query.length) + '</strong>';
        var substr2 = value.substring(_this.query.length);
        var match = substr1 + substr2;
        categoryMatches.push({ match: match, filter: value, id: index }); // dummy id for v-for key
      }, this);

      this.foodItemMatches = foodItemMatches;
      this.categoryMatches = categoryMatches;
      this.preselected = 0;
    }
  },
  methods: {
    handleDelete: function handleDelete() {
      this.preselected = 0;
      this.firstTouch = true;
    },
    handleKeyUp: function handleKeyUp() {
      if ((this.foodItemMatches.length || this.categoryMatches.length) && this.preselected !== 0) {
        var currselected = this.preselected;
        this.preselected = this.preselected - 1;

        var el = document.getElementsByClassName('vbta-suggestion')[this.preselected];
        el.style['background-color'] = '#00d1b2';

        var prev = document.getElementsByClassName('vbta-suggestion')[currselected];
        prev.style['background-color'] = '';
      }
    },
    handleKeyDown: function handleKeyDown() {
      if ((this.foodItemMatches.length || this.categoryMatches.length) && this.preselected !== this.foodItemMatches.length + this.categoryMatches.length - 1) {
        var currselected = this.preselected;
        if (!this.firstTouch) {
          this.preselected = this.preselected + 1;
        } else {
          this.firstTouch = false;
        }

        var el = document.getElementsByClassName('vbta-suggestion')[this.preselected];
        el.style['background-color'] = '#00d1b2';

        if (this.preselected !== 0) {
          var prev = document.getElementsByClassName('vbta-suggestion')[currselected];
          prev.style['background-color'] = '';
        }
      }
    },
    handleMouseOver: function handleMouseOver() {
      if (!this.firstTouch) {
        var elKeyboardSelected = document.getElementsByClassName('vbta-suggestion')[this.preselected];
        elKeyboardSelected.style['background-color'] = '';
        this.preselected = 0;
        this.firstTouch = true;
      }
    },
    handleBlur: function handleBlur() {
      this.clear();
    },
    handleEsc: function handleEsc() {
      this.clear();
    },
    clear: function clear() {
      this.query = '';
      this.preselected = 0;
      this.foodItemMatches = [];
      this.categoryMatches = [];
      this.firstTouch = true;
    },
    onMatch: function onMatch(val) {
      var value = val;
      if (!value) {
        if (this.preselected < this.foodItemMatches.length) {
          value = this.foodItemMatches[this.preselected];
        } else if (this.preselected < this.foodItemMatches.length + this.categoryMatches.length) {
          value = this.categoryMatches[this.preselected - this.foodItemMatches.length];
        }
      }

      if (value) {
        this.clear();

        // Take away focus so mobile will close the keyboard
        this.$refs.inputBox.blur();

        this.$emit('match', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, value));
      }
    },
    getMatches: function getMatches(query) {
      if (!query) {
        this.foodItemMatches = [];
        this.categoryMatches = [];
      }

      this.$emit('getMatches', query);
    },

    // TODO make this a mixin, it's in browse too
    typeIcon: function typeIcon(id) {
      return __WEBPACK_IMPORTED_MODULE_3__foodItem_types__["a" /* default */].getType(id).icon;
    }
  },
  components: {
    'font-awesome-icon': __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default.a
  }
});

/***/ }),

/***/ "d1qY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d5Qh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dA8h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dChq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dGtv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FilterSelector__ = __webpack_require__("2CA7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_i18n__ = __webpack_require__("i94f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__foodItem_types__ = __webpack_require__("rt35");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'browse-toolbar',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_i18n__["a" /* default */]],
  data: function data() {
    return {};
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])('browse', {
    setSelectedCategories: 'categories',
    setSelectedTypes: 'types',
    setBrowseMode: 'mode'
  }), {
    setSelectedFilters: function setSelectedFilters(types, categories) {
      this.setSelectedCategories(categories);
      this.setSelectedTypes(types);
    },
    removeTypeFilter: function removeTypeFilter(typeIndex) {
      this.setSelectedTypes(this.selectedTypes.filter(function (type, index) {
        return index !== typeIndex;
      }));
    },
    removeCategoryFilter: function removeCategoryFilter(catIndex) {
      this.setSelectedCategories(this.selectedCategories.filter(function (cat, index) {
        return index !== catIndex;
      }));
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('browse', {
    selectedTypes: 'types',
    selectedCategories: 'categories',
    browseMode: 'mode'
  }), {
    types: function types() {
      return __WEBPACK_IMPORTED_MODULE_4__foodItem_types__["a" /* default */];
    },

    mode: {
      get: function get() {
        return this.browseMode;
      },
      set: function set(val) {
        this.setBrowseMode(val);
      }
    }
  }),
  components: {
    FilterSelector: __WEBPACK_IMPORTED_MODULE_2__components_FilterSelector__["a" /* default */]
  }
});

/***/ }),

/***/ "dIqY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__("JJT7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08528744_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__("g5gV");
function injectStyle (ssrContext) {
  __webpack_require__("dLyE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08528744"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08528744_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dLyE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dSLU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_New_vue__ = __webpack_require__("Gfls");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a19a7e9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_New_vue__ = __webpack_require__("j2zm");
function injectStyle (ssrContext) {
  __webpack_require__("ss8m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_New_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a19a7e9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_New_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("9qcu")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("lraf")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dqd9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__graphql_shopping_list__ = __webpack_require__("C1JH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Action__ = __webpack_require__("kG4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__UncheckItemAction__ = __webpack_require__("w54v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DeleteItemAction__ = __webpack_require__("Ibu+");












/* eslint-disable no-underscore-dangle */

var CheckItemAction = function (_UndoAction) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CheckItemAction, _UndoAction);

  function CheckItemAction(options) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CheckItemAction);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CheckItemAction.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(CheckItemAction)).call(this, options));

    _this.item = options.item;
    _this.index = options.index;
    _this.newIndex = Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["get"])(_this.undoAction, 'index');
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CheckItemAction, [{
    key: '_executeImpl',
    value: function _executeImpl() {
      var shoppingList = this.component.shoppingList;

      // If item already exists on checked list, just delete it
      if (Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["findIndex"])(shoppingList.items.checked, { externalId: this.item.externalId }) >= 0) {
        return this.component.triggerAction(__WEBPACK_IMPORTED_MODULE_10__DeleteItemAction__["a" /* default */], {
          index: this.index,
          itemListName: 'unchecked'
        });
      }

      var self = this;
      return this.component.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_7__graphql_shopping_list__["e" /* CHECK_ITEM */],
        variables: {
          id: shoppingList.id,
          itemId: this.item.id,
          newIndex: this.newIndex
        },
        update: function update(store, _ref) {
          var shoppingListCheckItem = _ref.data.shoppingListCheckItem;

          self._updateCache(store, shoppingListCheckItem);
        },

        optimisticResponse: {
          shoppingListCheckItem: {
            __typename: 'ShoppingListCheckItemResult',
            item: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, self.item),
            modifiedAt: null
          }
        }
      });
    }
  }, {
    key: 'updateQuery',
    value: function updateQuery(cachedShoppingList, shoppingListCheckItemResult) {
      cachedShoppingList.items.unchecked.splice(this.index, 1);
      if (Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["isNumber"])(this.newIndex)) {
        cachedShoppingList.items.checked.splice(this.newIndex, 0, shoppingListCheckItemResult.item);
      } else {
        cachedShoppingList.items.checked.push(shoppingListCheckItemResult.item);
      }

      return cachedShoppingList;
    }
  }, {
    key: 'undo',
    value: function undo() {
      var index = Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["findIndex"])(this.component.shoppingList.items.checked, { id: this.item.id });
      if (index < 0) {
        throw new Error('Check item undo failed, item not found.');
      }

      return this.component.triggerAction(__WEBPACK_IMPORTED_MODULE_9__UncheckItemAction__["a" /* default */], {
        index: index,
        item: this.component.shoppingList.items.checked[index],
        undoAction: this
      });
    }
  }, {
    key: 'updateItem',
    value: function updateItem(oldItem, newItem) {
      if (this.item.id === oldItem.id) {
        this.item = newItem;
      }
    }

    // eslint-disable-next-line

  }, {
    key: 'undoTooltip',
    value: function undoTooltip() {
      return 'Undo check item';
    }

    // eslint-disable-next-line

  }, {
    key: 'redoTooltip',
    value: function redoTooltip() {
      return 'Redo check item';
    }
  }], [{
    key: 'name',
    get: function get() {
      return 'CheckItemAction';
    }
  }]);

  return CheckItemAction;
}(__WEBPACK_IMPORTED_MODULE_8__Action__["b" /* UndoAction */]);

/* harmony default export */ __webpack_exports__["a"] = (CheckItemAction);

/***/ }),

/***/ "duJS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditRecipe_vue__ = __webpack_require__("Kc5y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_911d62da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditRecipe_vue__ = __webpack_require__("OEby");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditRecipe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_911d62da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditRecipe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g5gV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-4 is-offset-4"},[_c('div',{staticClass:"box"},[_c('img',{staticClass:"image logo",attrs:{"src":__webpack_require__("TrFT"),"alt":"Me Want Food"}}),_vm._v(" "),(_vm.flash)?_c('div',{staticClass:"notification is-danger"},[_vm._v(_vm._s(_vm.flash))]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("First Name")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.firstName),expression:"form.firstName"}],ref:"firstName",staticClass:"input",attrs:{"type":"text","placeholder":"First Name"},domProps:{"value":(_vm.form.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "firstName", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Last Name")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.lastName),expression:"form.lastName"}],staticClass:"input",attrs:{"type":"text","placeholder":"Last Name"},domProps:{"value":(_vm.form.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "lastName", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],ref:"email",staticClass:"input",attrs:{"type":"email","placeholder":"Email"},domProps:{"value":(_vm.form.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}}),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Password")]),_vm._v(" "),_c('div',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password),expression:"form.password"}],staticClass:"input",attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.form.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password", $event.target.value)}}}),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"field is-grouped"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-text",attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v("\n                Cancel\n              ")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fas fa-envelope"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fas fa-lock"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-success",attrs:{"type":"submit"}},[_vm._v("\n                Register\n              ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h8ij":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CheckItemAction__ = __webpack_require__("dqd9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UncheckItemAction__ = __webpack_require__("w54v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AddItemAction__ = __webpack_require__("/paj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddItemsAction__ = __webpack_require__("TT2Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DeleteItemAction__ = __webpack_require__("Ibu+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MoveItemAction__ = __webpack_require__("aSPJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ClearAllAction__ = __webpack_require__("jPIi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ChangeItemAction__ = __webpack_require__("OK+/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UpdateNameAction__ = __webpack_require__("+PnG");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CheckItemAction", function() { return __WEBPACK_IMPORTED_MODULE_0__CheckItemAction__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UncheckItemAction", function() { return __WEBPACK_IMPORTED_MODULE_1__UncheckItemAction__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AddItemAction", function() { return __WEBPACK_IMPORTED_MODULE_2__AddItemAction__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AddItemsAction", function() { return __WEBPACK_IMPORTED_MODULE_3__AddItemsAction__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DeleteItemAction", function() { return __WEBPACK_IMPORTED_MODULE_4__DeleteItemAction__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MoveItemAction", function() { return __WEBPACK_IMPORTED_MODULE_5__MoveItemAction__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClearAllAction", function() { return __WEBPACK_IMPORTED_MODULE_6__ClearAllAction__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ChangeItemAction", function() { return __WEBPACK_IMPORTED_MODULE_7__ChangeItemAction__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UpdateNameAction", function() { return __WEBPACK_IMPORTED_MODULE_8__UpdateNameAction__["a"]; });












/***/ }),

/***/ "hKkv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_i18n__ = __webpack_require__("i94f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_routing__ = __webpack_require__("5m/v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ShoppingListUndoRedo__ = __webpack_require__("POZE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_ShoppingListItem__ = __webpack_require__("AIPu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_ShoppingListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__shared_ShoppingListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ShoppingListItemList__ = __webpack_require__("T2Z4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__graphql_shopping_list__ = __webpack_require__("C1JH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__("h8ij");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'shoppingList',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_i18n__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__ShoppingListUndoRedo__["a" /* mixin */], __WEBPACK_IMPORTED_MODULE_4__mixins_routing__["a" /* default */]],
  props: ['id'],
  data: function data() {
    return {
      error: null,
      shoppingList: null,
      synching: true,
      shoppingListSub: null,
      showTooltips: !this.isMobile(),

      showEditTitleButton: false,
      editTitleMode: false,
      newTitle: null,
      newItemDescription: null,

      idToQuery: this.id,

      drag: {
        active: null,
        evt: null
      },

      modifiedAtStyle: {
        color: null
      }
    };
  },

  watch: {
    $route: function $route() {
      var _this = this;

      this.idToQuery = this.id;

      // Not sure why this is necessary. If I don't do it,
      // the variables function in the query is called, but
      // the actual fetch is not made with the new id.

      // https://github.com/Akryum/vue-apollo/issues/262
      this.$apollo.queries.shoppingList.refetch(function () {
        return { id: _this.id };
      });
    }
  },
  apollo: {
    shoppingList: {
      query: __WEBPACK_IMPORTED_MODULE_10__graphql_shopping_list__["j" /* LIST_QUERY */],
      variables: function variables() {
        return {
          id: this.idToQuery
        };
      },
      result: function result(apolloQueryResult) {
        var _this2 = this;

        if (apolloQueryResult.loading || apolloQueryResult.networkStatus !== 7) {
          return;
        }

        var id = Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["get"])(apolloQueryResult.data, 'shoppingList.id');
        if (!id) {
          this.error = 'Invalid id';
          return;
        }

        this.routeShoppingList({
          id: id,
          noBack: true
        });

        this.error = '';
        this.defaultShoppingListId(id);
        this.currentShoppingList(apolloQueryResult.data.shoppingList);

        this.fetchFoodItems().then(function () {
          return _this2.subscribeToChanges();
        });
      },
      error: function error(_error) {
        this.handleError(_error);
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('shoppingList', ['defaultShoppingListId', 'currentShoppingList']), {
    fetchFoodItems: function fetchFoodItems() {
      var _this3 = this;

      var dupCheck = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();
      var ids = [];
      var pullIds = function pullIds(item) {
        if (item.foodItemId && !dupCheck.has(item.foodItemId)) {
          ids.push(item.foodItemId);
          dupCheck.add(item.foodItemId);
        }
      };

      Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["map"])(this.shoppingList.items.checked, pullIds);
      Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["map"])(this.shoppingList.items.unchecked, pullIds);

      return this.$store.dispatch('shoppingList/fetchFoodItems', ids).then(function () {
        _this3.synching = false;
      }).catch(function (err) {
        _this3.error = err.message;
        throw err;
      });
    },
    subscribeToChanges: function subscribeToChanges() {
      var _this4 = this;

      if (this.shoppingListSub) {
        this.shoppingListSub.unsubscribe();
      }

      var self = this;

      // Subscribe to shopping list updates
      this.shoppingListSub = this.$apollo.queries.shoppingList.subscribeToMore({
        document: __WEBPACK_IMPORTED_MODULE_10__graphql_shopping_list__["c" /* CHANGED */],
        variables: {
          id: this.shoppingList.id
        },
        updateQuery: function updateQuery(previousResult, _ref) {
          var subscriptionData = _ref.subscriptionData;

          /* eslint-disable no-underscore-dangle */
          var actionName = void 0;
          var index = void 0;
          var postAction = void 0;

          // TODO check subscriptionData.errors first

          var updateResult = Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["get"])(subscriptionData, 'data.shoppingListChanged');
          switch (updateResult.__typename) {
            case 'ShoppingListCheckItemResult':
              {
                index = Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["findIndex"])(self.shoppingList.items.unchecked, { id: updateResult.item.id });
                if (index < 0) {
                  throw new Error('Received update for missing unchecked item');
                }

                actionName = 'CheckItemAction';
                break;
              }

            case 'ShoppingListUncheckItemResult':
              {
                index = Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["findIndex"])(self.shoppingList.items.checked, { id: updateResult.item.id });
                if (index < 0) {
                  throw new Error('Received update for missing checked item');
                }

                actionName = 'UncheckItemAction';
                break;
              }

            case 'ShoppingListAddItemsResult':
              {
                postAction = function postAction() {
                  return self.fetchFoodItems();
                };
                actionName = 'AddItemsAction';
                break;
              }

            case 'ShoppingListAddItemResult':
              {
                index = Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["findIndex"])(self.shoppingList.items.unchecked, { id: updateResult.item.id });
                if (index >= 0) {
                  throw new Error('Received update to add already existing item');
                }

                index = updateResult.index;
                actionName = 'AddItemAction';
                break;
              }

            case 'ShoppingListDeleteItemResult':
              {
                index = Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["findIndex"])(self.shoppingList.items[updateResult.itemListName], { id: updateResult.itemId });
                if (index < 0) {
                  throw new Error('Received update to delete missing item');
                }

                actionName = 'DeleteItemAction';
                break;
              }

            case 'ShoppingListChangeItemResult':
              {
                index = Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["findIndex"])(self.shoppingList.items[updateResult.itemListName], { id: updateResult.item.id });
                if (index < 0) {
                  throw new Error('Received update to change missing item');
                }

                actionName = 'ChangeItemAction';
                break;
              }

            case 'ShoppingListClearAllResult':
              {
                actionName = 'ClearAllAction';
                break;
              }

            case 'ShoppingListMoveItemResult':
              {
                actionName = 'MoveItemAction';
                break;
              }

            case 'ShoppingListUpdateNameResult':
              {
                actionName = 'UpdateNameAction';
                break;
              }

            default:
              actionName = null;
          }

          if (actionName) {
            var cloneResult = Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["cloneDeep"])(previousResult);
            var action = new __WEBPACK_IMPORTED_MODULE_11__actions__[actionName](__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
              component: self
            }, updateResult, {
              index: index
            }));

            action.updateQuery(cloneResult.shoppingList, updateResult);
            if (postAction) {
              _this4.$nextTick(postAction);
            }

            self.modifiedAtStyle.color = 'green';
            setTimeout(function () {
              self.modifiedAtStyle.color = null;
            }, 500);

            self.$toast.open({
              message: self.$t('receivedUpdate'),
              type: 'is-info'
            });

            self.clearUndoRedo();
            return cloneResult;
          }

          return previousResult;
        },
        onError: function onError(err) {
          /* eslint-disable no-console */
          console.error(err);
          _this4.error = err.message;
        }
      });
    },
    editTitleEnabled: function editTitleEnabled() {
      var _this5 = this;

      this.newTitle = this.shoppingList.name;
      this.editTitleMode = true;
      this.$nextTick(function () {
        var input = _this5.$refs.titleInput;
        input.focus();
        input.setSelectionRange(_this5.newTitle.length, _this5.newTitle.length);
      });
    },
    editTitleOk: function editTitleOk() {
      var _this6 = this;

      if (this.newTitle !== this.shoppingList.name) {
        this.triggerAction(__WEBPACK_IMPORTED_MODULE_11__actions__["UpdateNameAction"], {
          value: this.newTitle
        }, { throwOnError: true }).then(function () {
          _this6.newTitle = '';
          _this6.editTitleMode = false;
        }).catch(function () {
          _this6.$nextTick(function () {
            var input = _this6.$refs.titleInput;
            input.focus();
            input.setSelectionRange(0, _this6.newTitle.length);
          });
        });
      } else {
        this.editTitleMode = false;
      }

      this.showEditTitleButton = false;
    },
    editTitleCancel: function editTitleCancel() {
      this.showEditTitleButton = false;
      this.editTitleMode = false;
      this.error = '';
    },
    changeUncheckedItem: function changeUncheckedItem(index, item, value) {
      return this.triggerAction(__WEBPACK_IMPORTED_MODULE_11__actions__["ChangeItemAction"], {
        itemListName: 'unchecked',
        index: index,
        item: item,
        value: value
      });
    },
    changeCheckedItem: function changeCheckedItem(index, item, value) {
      return this.triggerAction(__WEBPACK_IMPORTED_MODULE_11__actions__["ChangeItemAction"], {
        itemListName: 'checked',
        index: index,
        item: item,
        value: value
      });
    },
    addNewItem: function addNewItem() {
      var _this7 = this;

      if (!this.newItemDescription) {
        return;
      }

      var newItem = new __WEBPACK_IMPORTED_MODULE_8__shared_ShoppingListItem___default.a({
        description: this.newItemDescription
      });

      if (Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["findIndex"])(this.shoppingList.items.unchecked, { externalId: newItem.externalId }) >= 0) {
        this.$toast.open({
          message: 'Already exists',
          type: 'is-warning'
        });

        this.$nextTick(function () {
          var input = _this7.$refs.newItemDescription;
          input.focus();
          input.setSelectionRange(0, _this7.newItemDescription.length);
        });

        return;
      }

      this.triggerAction(__WEBPACK_IMPORTED_MODULE_11__actions__["AddItemAction"], { item: newItem }).then(function () {
        _this7.newItemDescription = '';
      });
    },
    clearAll: function clearAll() {
      var _this8 = this;

      this.$dialog.confirm({
        title: this.$t('clearShoppingList'),
        message: this.$t('confirmClearAll'),
        confirmText: this.$t('clearButton'),
        cancelText: this.$t('cancelButton'),
        type: 'is-danger',
        hasIcon: true,

        onConfirm: function onConfirm() {
          _this8.triggerAction(__WEBPACK_IMPORTED_MODULE_11__actions__["ClearAllAction"]);
        }
      });
    },
    triggerAction: function triggerAction(ActionType, actionArgs, options) {
      var _this9 = this;

      var action = new ActionType(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        component: this
      }, actionArgs));

      return action.execute().then(function (result) {
        if (actionArgs && actionArgs.undoAction) {
          _this9.pushRedo(actionArgs.undoAction);
        } else if (typeof action.undo === 'function') {
          _this9.pushUndo({ undoAction: action });
        } else {
          _this9.clearUndoRedo();
        }

        _this9.error = null;
        return result;
      }).catch(function (err) {
        _this9.handleError(err);
        if (options && options.throwOnError) {
          throw err;
        }
      });
    },
    undoLastAction: function undoLastAction() {
      var _this10 = this;

      return this.$store.dispatch('shoppingList/popUndo').then(function (action) {
        return action.undo();
      }).then(function () {
        _this10.error = null;
      }).catch(function (err) {
        _this10.error = err.message;
      });
    },
    redoLastAction: function redoLastAction() {
      var _this11 = this;

      return this.$store.dispatch('shoppingList/popRedo').then(function (action) {
        return action.execute().then(function () {
          _this11.pushUndo({ undoAction: action, isRedoAction: true });
          _this11.error = null;
        });
      }).catch(function (err) {
        _this11.error = err.message;
      });
    },
    handleError: function handleError(error) {
      var innerError = error.graphQLErrors[0] || error.networkError || error;
      this.error = innerError.message;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["e" /* mapState */])('shoppingList', ['foodItems']), {
    name: function name() {
      return this.shoppingList.name === 'default' ? this.$i18n.t('shoppingList') : this.shoppingList.name;
    },
    lastModified: function lastModified() {
      if (!this.shoppingList.modifiedAt) {
        return null;
      }

      var lm = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(this.shoppingList.modifiedAt);
      var lmDate = lm.clone().startOf('day');
      var format = '';
      if (lmDate.isSame(__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()().startOf('day'))) {
        format = 'LT';
      } else if (this.isMobile()) {
        format = 'l';
      } else {
        format = 'l LT';
      }

      return lm.format(format);
    },

    uncheckedItemList: {
      get: function get() {
        return this.shoppingList.items.unchecked;
      },
      set: function set(value) {
        this.triggerAction(__WEBPACK_IMPORTED_MODULE_11__actions__["MoveItemAction"], {
          drag: this.drag,
          itemListName: 'unchecked',
          value: value
        });
      }
    },
    checkedItemList: {
      get: function get() {
        return this.shoppingList.items.checked;
      },
      set: function set(value) {
        this.triggerAction(__WEBPACK_IMPORTED_MODULE_11__actions__["MoveItemAction"], {
          drag: this.drag,
          itemListName: 'checked',
          value: value
        });
      }
    },
    Actions: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_11__actions__;
      }
    }
  }),
  components: {
    ShoppingListItemList: __WEBPACK_IMPORTED_MODULE_9__ShoppingListItemList__["a" /* default */]
  }
});

/***/ }),

/***/ "hM8s":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"logout":"Logout","welcome":"Welcome","search":"Search"},"es":{"logout":"Cerrar sesión","welcome":"Bienvenido","search":"Buscar"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "i94f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    if (this.locale !== this.$i18n.locale) {
      this.$i18n.locale = this.locale;
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['locale'])),
  watch: {
    locale: function locale(val) {
      this.$i18n.locale = val;
    }
  }
});

/***/ }),

/***/ "j+ab":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowseMixin__ = __webpack_require__("XDap");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'browse-table',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__BrowseMixin__["a" /* default */]]
});

/***/ }),

/***/ "j0As":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'file-upload',
  props: ['value'],
  computed: {
    dropFiles: {
      get: function get() {
        return this.value;
      },
      set: function set(file) {
        this.dropFiles.push(file);
        this.$emit('input', this.dropFiles);
      }
    }
  },
  methods: {
    done: function done() {
      this.$emit('done');
    }
  }
});

/***/ }),

/***/ "j2zm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"box"},[(_vm.flash)?_c('div',{staticClass:"notification is-danger"},[_vm._v(_vm._s(_vm.flash))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Type")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('b-dropdown',{model:{value:(_vm.typeSelected),callback:function ($$v) {_vm.typeSelected=$$v},expression:"typeSelected"}},[_c('button',{ref:"new",staticClass:"button",attrs:{"slot":"trigger"},slot:"trigger"},[(_vm.typeSelected)?[_c('b-icon',{attrs:{"icon":_vm.typeSelected.icon}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(_vm.typeSelected.id)))])]:[_c('span',[_vm._v(_vm._s(_vm.$t('chooseType')))])],_vm._v(" "),_c('b-icon',{attrs:{"icon":"caret-down"}})],2),_vm._v(" "),_vm._l((_vm.types),function(type){return _c('b-dropdown-item',{key:type.id,attrs:{"value":type.name,"has-link":""}},[_c('router-link',{attrs:{"to":{ name: type.newRoute },"replace":""}},[_c('b-icon',{attrs:{"icon":type.icon}}),_vm._v("\n              "+_vm._s(_vm.$t(type.id))+"\n            ")],1)],1)})],2)],1)]),_vm._v(" "),_c('router-view',{on:{"flash":_vm.onFlash}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jKf8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jPIi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Action__ = __webpack_require__("kG4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__graphql_shopping_list__ = __webpack_require__("C1JH");








/* eslint-disable no-underscore-dangle */

var ClearAllAction = function (_Action) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ClearAllAction, _Action);

  function ClearAllAction() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ClearAllAction);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ClearAllAction.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ClearAllAction)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ClearAllAction, [{
    key: '_executeImpl',
    value: function _executeImpl() {
      var self = this;

      return this.component.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_6__graphql_shopping_list__["f" /* CLEAR_ALL */],
        variables: {
          id: this.component.shoppingList.id
        },
        update: function update(store, _ref) {
          var shoppingListClearAll = _ref.data.shoppingListClearAll;

          self._updateCache(store, shoppingListClearAll);
        },

        optimisticResponse: {
          shoppingListClearAll: {
            __typename: 'ShoppingListClearAllResult',
            id: self.component.shoppingList.id,
            modifiedAt: null
          }
        }
      });
    }

    /* eslint-disable class-methods-use-this */

  }, {
    key: 'updateQuery',
    value: function updateQuery(cachedShoppingList) {
      cachedShoppingList.items.checked = [];
      cachedShoppingList.items.unchecked = [];

      return cachedShoppingList;
    }
  }], [{
    key: 'name',
    get: function get() {
      return 'ClearAllAction';
    }
  }]);

  return ClearAllAction;
}(__WEBPACK_IMPORTED_MODULE_5__Action__["a" /* Action */]);

/* harmony default export */ __webpack_exports__["a"] = (ClearAllAction);

/***/ }),

/***/ "kG4H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Action; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UndoAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__graphql_shopping_list__ = __webpack_require__("C1JH");







/* eslint-disable class-methods-use-this */
/* eslint-disable no-underscore-dangle */

var Action = function () {
  function Action(_ref) {
    var component = _ref.component;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Action);

    this.component = component;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Action, [{
    key: 'execute',
    value: function execute() {
      var _this = this;

      this.component.synching = true;
      return this._executeImpl().finally(function () {
        _this.component.synching = false;
      });
    }

    // Optimistic UI or subscription change

  }, {
    key: 'updateQuery',
    value: function updateQuery() /* cachedShoppingList, change */{
      throw new Error('Execute Not Implemented');
    }
  }, {
    key: '_executeImpl',
    value: function _executeImpl() {
      throw new Error('Execute Not Implemented');
    }
  }, {
    key: '_updateCache',
    value: function _updateCache(store, changeResult, args) {
      var id = this.component.shoppingList.id;
      var data = store.readQuery({ query: __WEBPACK_IMPORTED_MODULE_5__graphql_shopping_list__["j" /* LIST_QUERY */], variables: { id: id } });
      this.updateQuery(data.shoppingList, changeResult, args);
      if (changeResult.modifiedAt) {
        data.shoppingList.modifiedAt = changeResult.modifiedAt;
      }

      store.writeQuery({ query: __WEBPACK_IMPORTED_MODULE_5__graphql_shopping_list__["j" /* LIST_QUERY */], variables: { id: id }, data: data });
    }
  }], [{
    key: 'name',
    get: function get() {
      return 'Action';
    }
  }]);

  return Action;
}();

var UndoAction = function (_Action) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(UndoAction, _Action);

  function UndoAction(_ref2) {
    var component = _ref2.component,
        undoAction = _ref2.undoAction;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, UndoAction);

    var _this2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UndoAction.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(UndoAction)).call(this, { component: component }));

    _this2.undoAction = undoAction;
    return _this2;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(UndoAction, [{
    key: 'undo',


    // eslint-disable-next-line
    value: function undo() {
      throw new Error('Undo Not Implemented');
    }

    // eslint-disable-next-line

  }, {
    key: 'updateItem',
    value: function updateItem() {
      throw new Error('Update Item Not Implemented');
    }

    // eslint-disable-next-line

  }, {
    key: 'undoTooltip',
    value: function undoTooltip() {
      throw new Error('Undo Tooltip Not Implemented');
    }

    // eslint-disable-next-line

  }, {
    key: 'redoTooltip',
    value: function redoTooltip() {
      throw new Error('Redo Tooltip Not Implemented');
    }
  }], [{
    key: 'name',
    get: function get() {
      return 'UndoAction';
    }
  }]);

  return UndoAction;
}(Action);



/***/ }),

/***/ "l3V0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"field is-grouped is-grouped-centered"},[_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-success",on:{"click":function($event){$event.preventDefault();return _vm.done($event)}}},[_vm._v("\n        Done\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"level"},[_c('div',{staticClass:"level-item"},[_c('b-upload',{attrs:{"multiple":"","drag-drop":"","position":"is-centered"},model:{value:(_vm.dropFiles),callback:function ($$v) {_vm.dropFiles=$$v},expression:"dropFiles"}},[_c('section',{staticClass:"section"},[_c('div',{staticClass:"content has-text-centered"},[_c('p',[_c('b-icon',{attrs:{"icon":"cloud-upload-alt","size":"is-large"}})],1),_vm._v(" "),_c('p',[_vm._v("Drop files here or click to upload")])])])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lraf":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"chooseType":"Choose"},"es":{"chooseType":"Seleccione"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "lwq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  // User authenticated
  authenticated: false,
  user: null,

  // Everything shows tags
  categoryNames: null,

  // Keep track if an internal route has been followed
  // so Back buttons know if they should really go 'back'
  routed: false,

  // Typeahead results
  typeaheadCurrentQuery: null,
  typeaheadResults: { foodItems: [], categories: [], query: '' },

  // i18n locale
  locale: localStorage.locale || 'es',

  // Notification message to show on next route change
  notify: {
    message: '',
    type: '' // bulma type, e.g. is-success
  }
});

/***/ }),

/***/ "mFDX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mROJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__("U0v6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_LargeCheckbox__ = __webpack_require__("6Ezy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_links__ = __webpack_require__("FzK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_routing__ = __webpack_require__("5m/v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_notify__ = __webpack_require__("0fFW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_time__ = __webpack_require__("2hfY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_ShoppingListItem__ = __webpack_require__("AIPu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_ShoppingListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__shared_ShoppingListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shopping_list_actions__ = __webpack_require__("h8ij");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'recipe',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_links__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_routing__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_notify__["a" /* default */]],
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      error: null,
      directionChecks: []
    };
  },

  watch: {
    $route: function $route() {
      this.fetchRecipe();
    }
  },
  mounted: function mounted() {
    this.fetchRecipe();
  },

  methods: {
    sendToShoppingListClicked: function sendToShoppingListClicked() {
      var self = this;
      this.$dialog.confirm({
        title: 'Recipe Ingredients',
        message: 'Send to <b>default</b> shopping list?',
        confirmText: 'Send',
        type: 'is-info',
        hasIcon: true,
        onConfirm: function onConfirm() {
          self.sendToShoppingList();
        }
      });
    },
    sendToShoppingList: function sendToShoppingList() {
      var _this = this;

      var items = this.recipe.ingredients.map(function (i) {
        return new __WEBPACK_IMPORTED_MODULE_8__shared_ShoppingListItem___default.a({
          foodItemId: _this.recipe.id,
          description: i
        });
      });

      var action = new __WEBPACK_IMPORTED_MODULE_9__shopping_list_actions__["AddItemsAction"]({
        component: this,
        list: items
      });

      action.execute().then(function () {
        return _this.$toast.open({
          message: 'Successfully added to shopping list',
          type: 'is-success'
        });
      }).then(function () {
        _this.error = null;
      }).catch(function (err) {
        var message = err.graphQLErrors && err.graphQLErrors.length ? err.graphQLErrors[0].message : err.message;

        _this.$toast.open({
          message: message,
          type: 'is-warning'
        });
      });
    },
    clearDirectionChecks: function clearDirectionChecks() {
      this.directionChecks = [];
    },
    fetchRecipe: function fetchRecipe() {
      var _this2 = this;

      return this.$store.dispatch('recipe/fetchRecipe', this.id).catch(function (err) {
        _this2.error = err.message;
      });
    },
    deleteRecipe: function deleteRecipe() {
      var _this3 = this;

      this.$dialog.confirm({
        title: 'Delete Recipe',
        message: 'Are you sure?',
        confirmText: 'Delete',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: function onConfirm() {
          _this3.$store.dispatch('recipe/deleteRecipe', _this3.id).then(function () {
            return _this3.routeBrowse({ noBack: true });
          }).catch(function (err) {
            _this3.error = err.message;
          });
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('recipe', ['recipe']), {
    prepTime: function prepTime() {
      return Object(__WEBPACK_IMPORTED_MODULE_7__utils_time__["b" /* minsToString */])(this.recipe.prepTimeMin);
    },
    servings: function servings() {
      if (this.recipe.servings > 1) {
        return this.recipe.servings + ' servings';
      } else if (this.recipe.servings === 1) {
        return this.recipe.servings + ' serving';
      }

      return '';
    }
  }),
  components: {
    'large-checkbox': __WEBPACK_IMPORTED_MODULE_3__components_LargeCheckbox__["a" /* default */],
    'font-awesome-icon': __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default.a
  }
});

/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__("2R8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__("tlQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_fetch__ = __webpack_require__("Vo7i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_auth__ = __webpack_require__("TIfe");




var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['{\n          initialData {\n            categories\n            ', '\n          }\n        }'], ['{\n          initialData {\n            categories\n            ', '\n          }\n        }']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['query FoodItems($text: String) {\n        typeaheadFoodItems(text: $text) {\n          id\n          name\n          type\n        }\n      }'], ['query FoodItems($text: String) {\n        typeaheadFoodItems(text: $text) {\n          id\n          name\n          type\n        }\n      }']);





/* harmony default export */ __webpack_exports__["a"] = ({
  getNotifyMessage: function getNotifyMessage(_ref) {
    var getters = _ref.getters,
        commit = _ref.commit;

    var rval = null;
    if (getters.notify.message) {
      rval = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, getters.notify);
      if (!rval.type) {
        rval.type = 'is-success';
      }

      commit('notify', { message: null, type: null });
    }

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(rval);
  },
  fetchInitialData: function fetchInitialData(_ref2) {
    var getters = _ref2.getters,
        commit = _ref2.commit,
        rootGetters = _ref2.rootGetters;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (getters.initDataLoaded) {
        return resolve();
      }

      // Only fetch the default id if we don't already have one
      var queryField = '';
      if (!rootGetters['shoppingList/defaultShoppingListId']) {
        queryField = 'defaultShoppingListId';
      }

      return __WEBPACK_IMPORTED_MODULE_4__utils_fetch__["a" /* graphql */].query({
        query: __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject, queryField)
      }).then(function (_ref3) {
        var initialData = _ref3.data.initialData;

        commit('categoryNames', initialData.categories);
        if (queryField) {
          commit('shoppingList/defaultShoppingListId', initialData.defaultShoppingListId);
        }

        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  fetchUserInfo: function fetchUserInfo(_ref4) {
    var getters = _ref4.getters,
        commit = _ref4.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      var u = getters.user;
      if (u) {
        resolve(u);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_5__utils_auth__["g" /* userInfo */])().then(function (user) {
          commit('user', user);
          resolve(user);
        });
      }
    });
  },
  typeaheadQuery: function typeaheadQuery(_ref5, text) {
    var commit = _ref5.commit,
        state = _ref5.state;

    state.typeaheadCurrentQuery = text;
    if (!text) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({});
    }

    return __WEBPACK_IMPORTED_MODULE_4__utils_fetch__["a" /* graphql */].query({
      query: __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject2),
      variables: {
        text: text
      }
    }).then(function (results) {
      if (state.typeaheadCurrentQuery === text) {
        var catRegex = new RegExp('^' + text, 'i');
        var data = {
          foodItems: results.data.typeaheadFoodItems,
          categories: state.categoryNames.filter(function (cat) {
            return cat.match(catRegex);
          }),
          query: text
        };

        commit('typeaheadResults', data);
        return data;
      }

      return {};
    });
  }
});

/***/ }),

/***/ "mf2w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_auth__ = __webpack_require__("TIfe");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  props: {
    message: Object
  },
  data: function data() {
    return {
      form: {
        email: null,
        password: null
      },
      flash: null
    };
  },
  created: function created() {
    if (this.message) {
      this.flash = this.message.message;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      return _this.focus('username');
    });
  },

  methods: {
    submit: function submit() {
      var _this2 = this;

      var form = {
        username: this.form.email.slice(0),
        password: this.form.password.slice(0)
      };

      this.form.password = null;
      this.flash = null;

      // TODO show loading message
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_auth__["d" /* login */])(form).then(function () {
        return _this2.$router.push({ name: 'browse' });
      }).catch(function (error) {
        _this2.flash = error.message;
        _this2.focus(error.field);
      });
    },
    onRegister: function onRegister() {
      this.$router.push({ name: 'register' });
    },
    focus: function focus(field) {
      var el = this.$refs[field];
      if (el) {
        el.focus();
        el.select();
      }
    }
  }
});

/***/ }),

/***/ "nvz7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_i18n__ = __webpack_require__("i94f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_routing__ = __webpack_require__("5m/v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graphql_shopping_list__ = __webpack_require__("C1JH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ShoppingListModalNew__ = __webpack_require__("At/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ShoppingListModalOpen__ = __webpack_require__("pTol");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'shoppingListAppToolbar',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_i18n__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_routing__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('shoppingList', ['currentShoppingList'])),
  methods: {
    showNewDialog: function showNewDialog() {
      var _this = this;

      this.$modal.open({
        parent: this,
        component: __WEBPACK_IMPORTED_MODULE_5__ShoppingListModalNew__["a" /* default */],
        hasModalCard: true,
        events: {
          ok: function ok(shoppingList) {
            return _this.routeShoppingList(shoppingList);
          }
        }
      });
    },
    showOpenDialog: function showOpenDialog() {
      var _this2 = this;

      this.$modal.open({
        parent: this,
        component: __WEBPACK_IMPORTED_MODULE_6__ShoppingListModalOpen__["a" /* default */],
        hasModalCard: true,
        events: {
          ok: function ok(shoppingList) {
            return _this2.routeShoppingList(shoppingList);
          }
        }
      });
    },
    showConfirmDelete: function showConfirmDelete() {
      var _this3 = this;

      this.$dialog.confirm({
        title: 'Delete "' + this.currentShoppingList.name + '"',
        message: 'Are you sure? This cannot be undone.',
        confirmText: 'Delete',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: function onConfirm() {
          _this3.$apollo.mutate({
            mutation: __WEBPACK_IMPORTED_MODULE_4__graphql_shopping_list__["h" /* DELETE_LIST */],
            variables: {
              id: _this3.currentShoppingList.id
            }
          }).then(function (_ref) {
            var shoppingListDelete = _ref.data.shoppingListDelete;

            _this3.routeShoppingList(shoppingListDelete.defaultList);

            _this3.$toast.open({
              message: 'Deleted ' + shoppingListDelete.deletedList.name,
              type: 'is-success'
            });
          });
          // TODO handleError
        }
      });
    }
  }
});

/***/ }),

/***/ "o8QF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pQxd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DescriptionModal__ = __webpack_require__("vS2m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_browse_BrowseToolbar__ = __webpack_require__("Vq1x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_browse_BrowseTable__ = __webpack_require__("E5xn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_browse_BrowseTiles__ = __webpack_require__("H/Kn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_notify__ = __webpack_require__("0fFW");

//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'browse',
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_notify__["a" /* default */]],
  data: function data() {
    return {
      error: null,
      descModalActive: false,
      clickedItem: {
        name: '',
        description: ''
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.fetchFoodItems().catch(function (error) {
      _this.error = error;
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    descClicked: function descClicked(fi) {
      this.clickedItem = fi;
      this.descModalActive = true;
    },
    closeDesc: function closeDesc() {
      this.descModalActive = false;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('browse', ['fetchFoodItems'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('browse', {
    sort: 'sort',
    selectedTypes: 'types',
    selectedCategories: 'categories',
    mode: 'mode'
  }), {
    sortField: function sortField() {
      return this.sort.field;
    },
    sortOrder: function sortOrder() {
      return this.sort.order;
    }
  }),
  watch: {
    sortField: function sortField() {
      var _this2 = this;

      this.fetchFoodItems().catch(function (error) {
        _this2.error = error;
      });
    },
    sortOrder: function sortOrder() {
      var _this3 = this;

      this.fetchFoodItems().catch(function (error) {
        _this3.error = error;
      });
    },
    selectedTypes: function selectedTypes() {
      var _this4 = this;

      this.fetchFoodItems().catch(function (error) {
        _this4.error = error;
      });
    },
    selectedCategories: function selectedCategories() {
      var _this5 = this;

      this.fetchFoodItems().catch(function (error) {
        _this5.error = error;
      });
    }
  },
  components: {
    DescriptionModal: __WEBPACK_IMPORTED_MODULE_2__components_DescriptionModal__["a" /* default */],
    BrowseToolbar: __WEBPACK_IMPORTED_MODULE_3__components_browse_BrowseToolbar__["a" /* default */],
    BrowseTable: __WEBPACK_IMPORTED_MODULE_4__components_browse_BrowseTable__["a" /* default */],
    BrowseTiles: __WEBPACK_IMPORTED_MODULE_5__components_browse_BrowseTiles__["a" /* default */]
  }
});

/***/ }),

/***/ "pTol":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingListModalOpen_vue__ = __webpack_require__("rlKT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c9f6370_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingListModalOpen_vue__ = __webpack_require__("JSS4");
function injectStyle (ssrContext) {
  __webpack_require__("VBwL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c9f6370"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingListModalOpen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c9f6370_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingListModalOpen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("2zmm")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "peQO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageCapture_vue__ = __webpack_require__("EFs7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38bff720_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageCapture_vue__ = __webpack_require__("J5OW");
function injectStyle (ssrContext) {
  __webpack_require__("mf2w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-38bff720"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageCapture_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38bff720_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageCapture_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pvCZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BadResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IgnoreError; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getErrorMessage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);





var BadResponse = function (_Error) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(BadResponse, _Error);

  function BadResponse(_ref) {
    var _ref2;

    var message = _ref.message,
        field = _ref.field;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, BadResponse);

    for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref2 = BadResponse.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(BadResponse)).call.apply(_ref2, [this].concat(params)));

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, BadResponse);
    }

    _this.message = message;
    _this.field = field;
    return _this;
  }

  return BadResponse;
}(Error);

var IgnoreError = function (_Error2) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(IgnoreError, _Error2);

  function IgnoreError(params) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, IgnoreError);

    var _this2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (IgnoreError.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(IgnoreError)).call(this, params));

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this2, IgnoreError);
    }
    return _this2;
  }

  return IgnoreError;
}(Error);

function getErrorMessage(error) {
  if (error) {
    var innerError = error.graphQLErrors[0] || error.networkError || error;
    return innerError.message;
  }

  return 'Unknown Error';
}

/***/ }),

/***/ "qEt2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewCategories_vue__ = __webpack_require__("3+IJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed637cc2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewCategories_vue__ = __webpack_require__("xqlh");
function injectStyle (ssrContext) {
  __webpack_require__("5p5t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ed637cc2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewCategories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed637cc2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewCategories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qd9B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inherit"}},[_c('router-link',{staticClass:"navbar-item",attrs:{"to":{ name: 'new' }}},[_c('b-icon',{staticClass:"is-hidden-desktop menu-icon",attrs:{"icon":"plus"}}),_vm._v("\n    "+_vm._s(_vm.$t('new'))+"\n  ")],1),_vm._v(" "),_c('router-link',{staticClass:"navbar-item",attrs:{"to":{ name: 'shoppingList', params: { id: _vm.defaultShoppingListId } }}},[_c('b-icon',{staticClass:"is-hidden-desktop menu-icon",attrs:{"icon":"shopping-cart"}}),_vm._v("\n    "+_vm._s(_vm.$t('shoppingList'))+"\n  ")],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qsKw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table is-hoverable"},[_c('thead',[_c('tr',[_c('th',{staticClass:"type",attrs:{"nowrap":""}},[_c('a',{attrs:{"role":"button"},on:{"click":function($event){_vm.toggleSort('type')}}},[_vm._v("Type\n          "),(_vm.sortField === 'type')?_c('span',[_c('font-awesome-icon',{attrs:{"icon":_vm.sortIcon}})],1):_vm._e()])]),_vm._v(" "),_c('th',{staticClass:"is-hidden-mobile",attrs:{"nowrap":""}},[_c('a',{attrs:{"role":"button"},on:{"click":function($event){_vm.toggleSort('access')}}},[_vm._v("Access\n          "),(_vm.sortField === 'access')?_c('span',[_c('font-awesome-icon',{attrs:{"icon":_vm.sortIcon}})],1):_vm._e()])]),_vm._v(" "),_c('th',{attrs:{"nowrap":""}},[_c('a',{attrs:{"role":"button"},on:{"click":function($event){_vm.toggleSort('name')}}},[_vm._v("Name\n          "),(_vm.sortField === 'name')?_c('span',[_c('font-awesome-icon',{attrs:{"icon":_vm.sortIcon}})],1):_vm._e()])]),_vm._v(" "),_c('th',{staticClass:"is-hidden-mobile"},[_vm._v("\n        Description\n      ")]),_vm._v(" "),_c('th',{staticClass:"is-hidden-mobile"},[_vm._v("\n        Categories\n      ")]),_vm._v(" "),_c('th',{staticClass:"is-hidden-mobile",attrs:{"nowrap":""}},[_c('a',{attrs:{"role":"button"},on:{"click":function($event){_vm.toggleSort('addrSortValue')}}},[_vm._v("Address\n          "),(_vm.sortField === 'addrSortValue')?_c('span',[_c('font-awesome-icon',{attrs:{"icon":_vm.sortIcon}})],1):_vm._e()])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.foodItems),function(fi){return _c('tr',{key:fi.id},[_c('td',[_c('span',{staticClass:"icon is-size-4-mobile"},[_c('b-icon',{attrs:{"size":"is-small","icon":_vm.typeIcon(fi.type)}})],1),_vm._v(" "),_c('div',{staticClass:"is-hidden-tablet"},[_c('span',{staticClass:"icon"},[_c('b-icon',{attrs:{"size":"is-small","icon":_vm.accessIcon(fi.access)}})],1)])]),_vm._v(" "),_c('td',{staticClass:"is-hidden-mobile",attrs:{"nowrap":""}},[_c('span',{staticClass:"icon"},[_c('b-icon',{attrs:{"icon":_vm.accessIcon(fi.access)}})],1)]),_vm._v(" "),_c('td',[_c('a',{staticClass:"is-inverted is-size-4-mobile",attrs:{"role":"button"},on:{"click":function($event){_vm.routeFoodItem(fi)}}},[_vm._v(_vm._s(fi.name))]),_vm._v(" "),(fi.link)?_c('a',{attrs:{"href":fi.link,"target":"_blank"}},[_c('span',{staticClass:"icon"},[(_vm.youTubeLink(fi.link))?_c('font-awesome-icon',{attrs:{"icon":['fab', 'youtube']}}):_c('font-awesome-icon',{attrs:{"icon":"external-link-alt"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"is-inline-block-mobile is-hidden-tablet is-size-4-mobile"},[(fi.description)?_c('a',{on:{"click":function($event){_vm.descClicked(fi)}}},[_c('span',{staticClass:"icon"},[_c('font-awesome-icon',{attrs:{"icon":"info-circle"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"is-block-mobile is-hidden-tablet"},[_c('div',{staticClass:"mobile-name-sub-line"},[(fi.categories)?_c('div',{staticClass:"tags is-small"},_vm._l((fi.categories),function(c){return _c('span',{key:c,staticClass:"tag is-info"},[_vm._v(_vm._s(c))])})):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"mobile-name-sub-line"},[(fi.address && fi.address.city)?_c('a',{attrs:{"href":_vm.addrHref(fi),"target":"_blank"}},[_vm._v(_vm._s(fi.address.city))]):[_vm._v(_vm._s(_vm.addrString(fi.address)))]],2)])]),_vm._v(" "),_c('td',{staticClass:"is-hidden-mobile"},[(fi.description && fi.description.length > _vm.maxDescChars)?_c('a',{on:{"click":function($event){_vm.descClicked(fi)}}},[_vm._v(_vm._s(_vm.truncateDesc(fi.description)))]):[_vm._v(_vm._s(fi.description))]],2),_vm._v(" "),_c('td',{staticClass:"is-hidden-mobile"},[(fi.categories)?_c('div',{staticClass:"tags"},_vm._l((fi.categories),function(c){return _c('span',{key:c,staticClass:"tag is-light"},[_vm._v(_vm._s(c))])})):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"is-hidden-mobile"},[(fi.address && fi.address.city)?_c('a',{attrs:{"href":_vm.addrHref(fi),"target":"_blank"}},[_vm._v(_vm._s(fi.address.city))]):[_vm._v(_vm._s(_vm.addrString(fi.address)))]],2)])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rlKT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_i18n__ = __webpack_require__("i94f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_routing__ = __webpack_require__("5m/v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphql_shopping_list__ = __webpack_require__("C1JH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_errors__ = __webpack_require__("pvCZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'shoppingListModalOpen',
  data: function data() {
    return {
      shoppingLists: null,

      selectedIndex: null,
      makeDefault: false
    };
  },

  apollo: {
    shoppingLists: {
      query: __WEBPACK_IMPORTED_MODULE_3__graphql_shopping_list__["i" /* LISTS_QUERY */],
      error: function error(err) {
        this.$toast.open({
          message: Object(__WEBPACK_IMPORTED_MODULE_4__utils_errors__["c" /* getErrorMessage */])(err),
          type: 'is-danger'
        });

        this.$parent.close();
      }
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_i18n__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_routing__["a" /* default */]],
  mounted: function mounted() {
    document.addEventListener('keydown', this.handleKeyDown);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);
  },

  methods: {
    select: function select(index) {
      this.selectedIndex = index;
    },
    formatDate: function formatDate(modifiedAt) {
      return new Date(modifiedAt).toLocaleString();
    },
    handleKeyDown: function handleKeyDown(event) {
      var index = null;

      if (event.code === 'ArrowDown') {
        if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isNumber"])(this.selectedIndex)) {
          if (this.selectedIndex < this.shoppingLists.length - 1) {
            index = this.selectedIndex + 1;
          }
        } else {
          index = 0;
        }
      } else if (event.code === 'ArrowUp') {
        if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isNumber"])(this.selectedIndex)) {
          if (this.selectedIndex > 0) {
            index = this.selectedIndex - 1;
          }
        } else {
          index = 0;
        }
      } else if (event.code === 'Enter') {
        if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isNumber"])(this.selectedIndex)) {
          this.openList();
        }
      }

      if (index !== null) {
        this.select(index);

        // Decide if we need to scroll
        var listBoxEl = document.getElementsByClassName('list-box')[0];
        var listBoxRect = listBoxEl.getBoundingClientRect();
        var listItemRect = document.getElementsByClassName('list-item-' + index)[0].getBoundingClientRect();
        if (listItemRect.bottom > listBoxRect.bottom) {
          var numItemsFit = Math.floor(listBoxRect.height / listItemRect.height);
          var extra = listBoxRect.height % listItemRect.height - 1;
          listBoxEl.scrollTop = (index - numItemsFit) * listItemRect.height + extra;
        } else if (listItemRect.top < listBoxRect.top) {
          listBoxEl.scrollTop -= listBoxRect.top - listItemRect.top;
        }

        event.preventDefault();
      }
    },
    openList: function openList() {
      this.$emit('ok', this.shoppingLists[this.selectedIndex]);
    }
  }
});

/***/ }),

/***/ "rpuk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingList_vue__ = __webpack_require__("hKkv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20d294c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingList_vue__ = __webpack_require__("QnEy");
function injectStyle (ssrContext) {
  __webpack_require__("ZAIw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20d294c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20d294c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("2zmm")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rt35":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


var TYPES = [{
  id: 'Recipe',
  name: 'Recipe',
  icon: 'list-alt',
  newRoute: 'new-recipe'
}, {
  id: 'Restaurant',
  name: 'Restaurant',
  icon: 'utensils',
  newRoute: 'new-restaurant'
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  types: TYPES,

  getTypeName: function getTypeName(id) {
    // throw if not found
    return this.getType(id).name;
  },
  getType: function getType(id) {
    return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(TYPES, ['id', id]);
  },
  getTypeIds: function getTypeIds() {
    return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(this.types, 'id');
  },
  getTypeFromRoute: function getTypeFromRoute(to) {
    var parts = to.path.split('/');
    if (parts.length > 1) {
      var regex = new RegExp(parts[1], 'i');
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(TYPES, function (t) {
        return regex.test(t.id);
      });
    }

    return null;
  }
});

/***/ }),

/***/ "sLiY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__ = __webpack_require__("U0v6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_links__ = __webpack_require__("FzK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_routing__ = __webpack_require__("5m/v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_notify__ = __webpack_require__("0fFW");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'restaurant',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_links__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_routing__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_notify__["a" /* default */]],
  data: function data() {
    return {
      error: null
    };
  },

  props: {
    id: {
      type: String,
      required: true
    }
  },
  watch: {
    $route: function $route() {
      this.fetchRestaurant();
    }
  },
  mounted: function mounted() {
    this.fetchRestaurant();
  },

  methods: {
    fetchRestaurant: function fetchRestaurant() {
      var _this = this;

      return this.$store.dispatch('restaurant/fetchRestaurant', this.id).catch(function (err) {
        _this.error = err.message;
      });
    },
    deleteRestaurant: function deleteRestaurant() {
      var _this2 = this;

      this.$dialog.confirm({
        title: 'Delete Restaurant',
        message: 'Are you sure?',
        confirmText: 'Delete',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: function onConfirm() {
          _this2.$store.dispatch('restaurant/deleteRestaurant', _this2.id).then(function () {
            return _this2.routeBrowse({ noBack: true });
          }).catch(function (err) {
            _this2.error = err.message;
          });
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('restaurant', ['restaurant'])),
  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_2__fortawesome_vue_fontawesome___default.a
  }
});

/***/ }),

/***/ "ss8m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t5qc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__("2R8v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__("tlQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_fetch__ = __webpack_require__("Vo7i");


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['query Restaurant($id: ID!) {\n        restaurantById(id: $id) {\n          ...restaurantFields\n        }\n      }\n      ', ''], ['query Restaurant($id: ID!) {\n        restaurantById(id: $id) {\n          ...restaurantFields\n        }\n      }\n      ', '']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['mutation Restaurant($restaurant: RestaurantInput!) {\n        createRestaurant(restaurant: $restaurant) {\n          id\n        },\n      }'], ['mutation Restaurant($restaurant: RestaurantInput!) {\n        createRestaurant(restaurant: $restaurant) {\n          id\n        },\n      }']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['mutation Restaurant($id: ID!, $restaurant: RestaurantInput!) {\n        updateRestaurant(id: $id, restaurant: $restaurant) {\n          ...restaurantFields\n        }\n      }\n      ', ''], ['mutation Restaurant($id: ID!, $restaurant: RestaurantInput!) {\n        updateRestaurant(id: $id, restaurant: $restaurant) {\n          ...restaurantFields\n        }\n      }\n      ', '']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['mutation Restaurant($id: ID!) {\n        deleteRestaurant(id: $id) {\n          ...restaurantFields\n        }\n      }\n      ', ''], ['mutation Restaurant($id: ID!) {\n        deleteRestaurant(id: $id) {\n          ...restaurantFields\n        }\n      }\n      ', '']);

// Restaurant view state



var RESTAURANT_FRAGMENT = ' fragment restaurantFields on Restaurant {\n      id\n      name\n      access\n      categories\n      link\n      description\n      address {\n        street\n        city\n        state\n        country\n      }\n    }\n  ';

var state = {
  // The restaurant to view
  restaurant: null
};

var getters = {
  restaurant: function restaurant(s) {
    return s.restaurant;
  }
};

var mutations = {
  restaurant: function restaurant(s, r) {
    s.restaurant = r;
  }
};

var actions = {
  fetchRestaurant: function fetchRestaurant(_ref, id) {
    var commit = _ref.commit;

    return __WEBPACK_IMPORTED_MODULE_2__utils_fetch__["a" /* graphql */].query({
      query: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject, RESTAURANT_FRAGMENT),
      variables: {
        id: id
      }
    }).then(function (response) {
      if (!response.data.restaurantById) {
        commit('restaurant', null);
        throw new Error('Unknown restaurant');
      }
      commit('restaurant', response.data.restaurantById);
      return response.data.restaurantById;
    }).catch(function (err) {
      commit('restaurant', null);
      throw err;
    });
  },
  saveRestaurant: function saveRestaurant(_ref2, restaurant) {
    var commit = _ref2.commit;

    return __WEBPACK_IMPORTED_MODULE_2__utils_fetch__["a" /* graphql */].mutate({
      mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject2),
      variables: {
        restaurant: restaurant
      }
    }).then(function (response) {
      commit('notify', {
        message: 'Restaurant created',
        type: 'is-success'
      }, { root: true });

      // TODO knowledge of 'foodItems' query should not be here
      __WEBPACK_IMPORTED_MODULE_2__utils_fetch__["a" /* graphql */].localExtensions.invalidateStoreQuery('foodItems');
      return response.data.createRestaurant.id;
    });
  },
  updateRestaurant: function updateRestaurant(_ref3, _ref4) {
    var commit = _ref3.commit;
    var id = _ref4.id,
        restaurant = _ref4.restaurant;

    return __WEBPACK_IMPORTED_MODULE_2__utils_fetch__["a" /* graphql */].mutate({
      mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject3, RESTAURANT_FRAGMENT),
      variables: {
        id: id,
        restaurant: restaurant
      }
    }).then(function (response) {
      if (!response.data.updateRestaurant) {
        commit('restaurant', null);
        throw new Error('Unknown restaurant');
      }

      commit('notify', {
        message: 'Restaurant updated',
        type: 'is-success'
      }, { root: true });

      // TODO knowledge of 'foodItems' query should not be here
      __WEBPACK_IMPORTED_MODULE_2__utils_fetch__["a" /* graphql */].localExtensions.invalidateStoreQuery('foodItems');
      return response.data.updateRestaurant;
    }).catch(function (err) {
      commit('restaurant', null);
      throw err;
    });
  },
  deleteRestaurant: function deleteRestaurant(_ref5, id) {
    var commit = _ref5.commit;

    return __WEBPACK_IMPORTED_MODULE_2__utils_fetch__["a" /* graphql */].mutate({
      mutation: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject4, RESTAURANT_FRAGMENT),
      variables: {
        id: id
      }
    }).then(function (response) {
      if (!response.data.deleteRestaurant) {
        throw new Error('Unknown restaurant');
      }

      commit('restaurant', null);

      commit('notify', {
        message: 'Restaurant deleted',
        type: 'is-success'
      }, { root: true });

      // TODO knowledge of 'foodItems' query should not be here
      __WEBPACK_IMPORTED_MODULE_2__utils_fetch__["a" /* graphql */].localExtensions.invalidateStoreQuery('foodItems');
    }).catch(function (err) {
      throw err;
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ "toOT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_i18n__ = __webpack_require__("i94f");
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'browseAppToolbar',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_i18n__["a" /* default */]]
});

/***/ }),

/***/ "ts75":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u7lY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  categoryNames: function categoryNames(s, names) {
    s.categoryNames = names.slice();
  },
  typeaheadResults: function typeaheadResults(s, value) {
    s.typeaheadResults = value;
  },
  authenticated: function authenticated(s, value) {
    s.authenticated = value;
  },
  user: function user(s, value) {
    s.user = value;
  },
  locale: function locale(s, value) {
    localStorage.locale = value;
    s.locale = value;
  },
  notify: function notify(s, value) {
    s.notify = value;
  }
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v7eb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-4 is-offset-4"},[_c('div',{staticClass:"box"},[_c('img',{staticClass:"image logo",attrs:{"src":__webpack_require__("TrFT"),"alt":"Me Want Food"}}),_vm._v(" "),(_vm.flash)?_c('div',{staticClass:"notification is-danger"},[_vm._v(_vm._s(_vm.flash))]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"field"},[_c('p',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],ref:"username",staticClass:"input",attrs:{"type":"email","placeholder":"Email"},domProps:{"value":(_vm.form.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}}),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('p',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password),expression:"form.password"}],ref:"password",staticClass:"input",attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.form.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password", $event.target.value)}}}),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"field is-grouped"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-text",attrs:{"type":"button"},on:{"click":_vm.onRegister}},[_vm._v("\n                Sign Up\n              ")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fas fa-envelope"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fas fa-lock"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-success",attrs:{"type":"submit"}},[_vm._v("\n                Login\n              ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vHpf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_routing__ = __webpack_require__("5m/v");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'shoppingListItem',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_routing__["a" /* default */]],
  props: ['item', 'checked', 'dragHandleClass'],
  data: function data() {
    return {
      // Used to cause the check/uncheck to actually display before the item
      // transitions to the other list when user clicks the description
      checkedOverride: null,
      grabbing: false,
      editMode: false,
      newDescription: ''
    };
  },

  computed: {
    foodItemName: function foodItemName() {
      return this.$store.getters['shoppingList/foodItemName'](this.item.foodItemId);
    },

    checkedProxy: {
      get: function get() {
        return this.checkedOverride !== null ? this.checkedOverride : this.checked;
      },
      set: function set(value) {
        var _this = this;

        // Allow for the checkbox to render the check/uncheck if the description was clicked
        this.$nextTick(function () {
          return _this.$emit('checkbox', value);
        });
      }
    }
  },
  methods: {
    descriptionClicked: function descriptionClicked() {
      this.checkedOverride = !this.checked;
    },
    enterEdit: function enterEdit() {
      var _this2 = this;

      this.newDescription = this.item.description;
      this.editMode = true;
      this.$nextTick(function () {
        var input = _this2.$refs.input;
        input.focus();
        input.setSelectionRange(_this2.newDescription.length, _this2.newDescription.length);
      });
    },
    completeEdit: function completeEdit() {
      if (this.newDescription !== this.item.description) {
        this.$emit('change', this.newDescription);
      }

      this.editMode = false;
    },
    cancelEdit: function cancelEdit() {
      this.editMode = false;
    }
  }
});

/***/ }),

/***/ "vRQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditRestaurant_vue__ = __webpack_require__("cZRz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13ca5794_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditRestaurant_vue__ = __webpack_require__("Yten");
function injectStyle (ssrContext) {
  __webpack_require__("mFDX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditRestaurant_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13ca5794_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditRestaurant_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vS2m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DescriptionModal_vue__ = __webpack_require__("JK6E");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cbe7f27_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DescriptionModal_vue__ = __webpack_require__("1VKL");
function injectStyle (ssrContext) {
  __webpack_require__("PSA9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5cbe7f27"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DescriptionModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cbe7f27_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DescriptionModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vpeh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vqcF":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"new":"New","areYouSure":"Are you sure?","clearButton":"Clear","cancelButton":"Cancel","saveButton":"Save","createButton":"Create","openButton":"Open","undo":"Undo","redo":"Redo","browse":"Browse","delete":"Delete","shoppingList":"Shopping List"},"es":{"new":"Nuevo","areYouSure":"¿Está seguro?","clearButton":"Borrar","cancelButton":"Cancelar","saveButton":"Salvar","createButton":"Crear","openButton":"Abrir","undo":"Deshacer","redo":"Rehacer","browse":"Inicio","delete":"Borrar","shoppingList":"Lista de compras"}}')
  delete Component.options._Ctor
}


/***/ }),

/***/ "w32Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUpload_vue__ = __webpack_require__("j0As");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_455bcce5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUpload_vue__ = __webpack_require__("l3V0");
function injectStyle (ssrContext) {
  __webpack_require__("anyH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_455bcce5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w54v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__graphql_shopping_list__ = __webpack_require__("C1JH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Action__ = __webpack_require__("kG4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CheckItemAction__ = __webpack_require__("dqd9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DeleteItemAction__ = __webpack_require__("Ibu+");












/* eslint-disable no-underscore-dangle */

var UncheckItemAction = function (_UndoAction) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(UncheckItemAction, _UndoAction);

  function UncheckItemAction(options) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, UncheckItemAction);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UncheckItemAction.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(UncheckItemAction)).call(this, options));

    _this.item = options.item;
    _this.index = options.index;
    _this.newIndex = Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["get"])(_this.undoAction, 'index');
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(UncheckItemAction, [{
    key: '_executeImpl',
    value: function _executeImpl() {
      var shoppingList = this.component.shoppingList;

      // If item already exists on unchecked list, just delete it
      if (Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["findIndex"])(shoppingList.items.unchecked, { externalId: this.item.externalId }) >= 0) {
        return this.component.triggerAction(__WEBPACK_IMPORTED_MODULE_10__DeleteItemAction__["a" /* default */], {
          index: this.index,
          itemListName: 'checked'
        });
      }

      var self = this;
      return this.component.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_7__graphql_shopping_list__["m" /* UNCHECK_ITEM */],
        variables: {
          id: shoppingList.id,
          itemId: this.item.id,
          newIndex: this.newIndex
        },
        update: function update(store, _ref) {
          var shoppingListUncheckItem = _ref.data.shoppingListUncheckItem;

          self._updateCache(store, shoppingListUncheckItem);
        },

        optimisticResponse: {
          shoppingListUncheckItem: {
            __typename: 'ShoppingListUncheckItemResult',
            item: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.item),
            modifiedAt: null
          }
        }
      });
    }
  }, {
    key: 'updateQuery',
    value: function updateQuery(cachedShoppingList, shoppingListUncheckItemResult) {
      cachedShoppingList.items.checked.splice(this.index, 1);
      if (Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["isNumber"])(this.newIndex)) {
        cachedShoppingList.items.unchecked.splice(this.newIndex, 0, shoppingListUncheckItemResult.item);
      } else {
        cachedShoppingList.items.unchecked.push(shoppingListUncheckItemResult.item);
      }
    }
  }, {
    key: 'undo',
    value: function undo() {
      var index = Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["findIndex"])(this.component.shoppingList.items.unchecked, { id: this.item.id });
      if (index < 0) {
        throw new Error('Uncheck item undo failed, item not found.');
      }

      return this.component.triggerAction(__WEBPACK_IMPORTED_MODULE_9__CheckItemAction__["a" /* default */], {
        index: index,
        item: this.component.shoppingList.items.unchecked[index],
        undoAction: this
      });
    }
  }, {
    key: 'updateItem',
    value: function updateItem(oldItem, newItem) {
      if (this.item.id === oldItem.id) {
        this.item = newItem;
      }
    }

    // eslint-disable-next-line

  }, {
    key: 'undoTooltip',
    value: function undoTooltip() {
      return 'Undo uncheck item';
    }

    // eslint-disable-next-line

  }, {
    key: 'redoTooltip',
    value: function redoTooltip() {
      return 'Redo uncheck item';
    }
  }], [{
    key: 'name',
    get: function get() {
      return 'UncheckItemAction';
    }
  }]);

  return UncheckItemAction;
}(__WEBPACK_IMPORTED_MODULE_8__Action__["b" /* UndoAction */]);

/* harmony default export */ __webpack_exports__["a"] = (UncheckItemAction);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_routing__ = __webpack_require__("5m/v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_i18n__ = __webpack_require__("i94f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SearchBar__ = __webpack_require__("/Uby");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shopping_list_ShoppingListAppToolbar__ = __webpack_require__("DEnp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_browse_BrowseAppToolbar__ = __webpack_require__("QECK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_NewAppToolbar__ = __webpack_require__("PbhX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_auth__ = __webpack_require__("TIfe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__foodItem_types__ = __webpack_require__("rt35");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin({
  methods: {
    isMobile: function isMobile() {
      return window.getComputedStyle(window.mwf.isMobileEl, null).getPropertyValue('display') !== 'none';
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_i18n__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_routing__["a" /* default */]],
  data: function data() {
    return {
      burgerIsActive: false,
      loadingMessage: 'Loading...',
      transitionName: 'slide-left'
    };
  },
  mounted: function mounted() {
    window.mwf = { isMobileEl: document.getElementById('mwfIsMobile') };
  },

  watch: {
    user: function user() {
      if (this.user) {
        this.burgerIsActive = false;
      }
    },
    $route: function $route(to, from) {
      this.burgerIsActive = false;

      if (__WEBPACK_IMPORTED_MODULE_11__foodItem_types__["a" /* default */].getTypeFromRoute(to)) {
        this.transitionName = 'slide-left';
      } else if (__WEBPACK_IMPORTED_MODULE_11__foodItem_types__["a" /* default */].getTypeFromRoute(from)) {
        this.transitionName = 'slide-right';
      } else {
        this.transitionName = null;
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapMutations */])({ setLocale: 'locale' }), {
    toggleNav: function toggleNav() {
      this.burgerIsActive = !this.burgerIsActive;
    },
    onGetMatches: function onGetMatches(text) {
      this.burgerIsActive = false;
      this.$store.dispatch('typeaheadQuery', text)
      /* eslint-disable no-console */
      .catch(function (err) {
        return console.error(err);
      });
    },
    onSearchMatch: function onSearchMatch(value) {
      if (value.filter) {
        this.routeBrowse({ categories: value.filter, component: this });
      } else if (value.id) {
        this.routeFoodItem(value);
      }
    },
    onLogout: function onLogout() {
      Object(__WEBPACK_IMPORTED_MODULE_10__utils_auth__["e" /* logout */])();
      this.$router.push({ name: 'login' });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['user', 'initDataLoaded', 'typeaheadResults', 'locale'])),
  components: {
    'loading-modal': __WEBPACK_IMPORTED_MODULE_5__components_Loading__["a" /* default */],
    'search-bar': __WEBPACK_IMPORTED_MODULE_6__components_SearchBar__["a" /* default */],
    ShoppingListAppToolbar: __WEBPACK_IMPORTED_MODULE_7__components_shopping_list_ShoppingListAppToolbar__["a" /* default */],
    BrowseAppToolbar: __WEBPACK_IMPORTED_MODULE_8__components_browse_BrowseAppToolbar__["a" /* default */],
    NewAppToolbar: __WEBPACK_IMPORTED_MODULE_9__components_NewAppToolbar__["a" /* default */]
  }
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1051a2ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("v7eb");
function injectStyle (ssrContext) {
  __webpack_require__("OGRp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1051a2ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1051a2ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xqlh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Categories")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('div',{staticClass:"tile is-ancestor"},[_c('div',{staticClass:"tile is-parent is-6"},[_c('div',{staticClass:"tile is-child"},[_c('b-field',[_c('b-input',{ref:"newTags",attrs:{"expanded":"","placeholder":"New categories separated by space","type":"text"},model:{value:(_vm.newTags),callback:function ($$v) {_vm.newTags=$$v},expression:"newTags"}}),_vm._v(" "),_c('p',{staticClass:"control"},[_c('button',{staticClass:"button is-info",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onNewTags($event)}}},[_vm._v("Add")])])],1)],1)])])])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"tile is-ancestor"},[_c('div',{staticClass:"tile is-parent"},[_c('div',{staticClass:"tile is-child box"},[_c('p',{staticClass:"is-size-7 tags-label has-text-weight-bold"},[_vm._v("Available")]),_vm._v(" "),_c('div',{staticClass:"tags"},_vm._l((_vm.availTags),function(t,index){return _c('span',{key:index,staticClass:"tag is-link",attrs:{"role":"button"},on:{"click":function($event){_vm.selectTag(index)}}},[_vm._v("\n                "+_vm._s(t)+"\n              ")])}))])]),_vm._v(" "),_c('div',{staticClass:"tile is-parent"},[_c('div',{staticClass:"tile is-child box"},[_c('p',{staticClass:"is-size-7 tags-label has-text-weight-bold"},[_vm._v("Selected")]),_vm._v(" "),_c('div',{staticClass:"tags"},_vm._l((_vm.selectedTags),function(t,index){return _c('span',{key:index,class:[ _vm.tagsMeta[t].flash ? 'is-danger' : (_vm.tagsMeta[t].orig ? 'is-link' : 'is-primary'), 'tag' ],attrs:{"role":"button"},on:{"click":function($event){_vm.unselectTag(index)}}},[_vm._v("\n                "+_vm._s(t)+"\n              ")])}))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zcgU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns is-mobile"},[_c('div',{staticClass:"column is-narrow-tablet v-center-column"},[_c('filter-selector',{attrs:{"selectedTypes":_vm.selectedTypes,"selectedCategories":_vm.selectedCategories},on:{"ok":_vm.setSelectedFilters}})],1),_vm._v(" "),_c('div',{staticClass:"column is-hidden-mobile v-center-column"},[_c('div',{staticClass:"tags"},[_vm._l((_vm.selectedTypes),function(typeId,index){return _c('span',{key:typeId,staticClass:"tag is-info"},[_vm._v("\n        "+_vm._s(_vm.$t(typeId))+"\n        "),_c('button',{staticClass:"delete is-small",on:{"click":function($event){_vm.removeTypeFilter(index)}}})])}),_vm._v(" "),_vm._l((_vm.selectedCategories),function(cat,index){return _c('span',{key:cat,staticClass:"tag is-info"},[_vm._v("\n        "+_vm._s(cat)+"\n        "),_c('button',{staticClass:"delete is-small",on:{"click":function($event){_vm.removeCategoryFilter(index)}}})])})],2)]),_vm._v(" "),_c('div',{staticClass:"column is-narrow v-center-column"},[_c('div',{staticClass:"field"},[_c('b-switch',{attrs:{"true-value":"tiles","false-value":"table","type":"is-info"},model:{value:(_vm.mode),callback:function ($$v) {_vm.mode=$$v},expression:"mode"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "znCk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[(_vm.id)?_c('h1',{staticClass:"title"},[_vm._v("Edit Recipe")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.access),expression:"form.access"}],attrs:{"type":"radio","value":"private"},domProps:{"checked":_vm._q(_vm.form.access,"private")},on:{"change":function($event){_vm.$set(_vm.form, "access", "private")}}}),_vm._v("\n      "+_vm._s(_vm.$t('private'))+"\n    ")]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.access),expression:"form.access"}],attrs:{"type":"radio","value":"public"},domProps:{"checked":_vm._q(_vm.form.access,"public")},on:{"change":function($event){_vm.$set(_vm.form, "access", "public")}}}),_vm._v("\n      "+_vm._s(_vm.$t('public'))+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],ref:"name",staticClass:"input",attrs:{"type":"text"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}})])]),_vm._v(" "),(_vm.images.length)?_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Images")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('div',{ref:"imagesBox",staticClass:"box"},_vm._l((_vm.images),function(img){return _c('div',{key:img.id,staticClass:"image-grid"},[_c('figure',{staticClass:"image my-image",style:(img.style)},[_c('img',{attrs:{"src":img.data}})]),_vm._v(" "),_c('div',{staticClass:"image-overlay",style:(img.style)},[_c('span',{staticClass:"icon delete-image",on:{"click":function($event){$event.preventDefault();_vm.deleteImage(img)}}},[_c('i',{staticClass:"far fa-trash-alt"})])])])}))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Link")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.link),expression:"form.link"}],ref:"link",staticClass:"input",attrs:{"type":"url"},domProps:{"value":(_vm.form.link)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "link", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Description")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.description),expression:"form.description"}],ref:"description",staticClass:"textarea",domProps:{"value":(_vm.form.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "description", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_vm._m(0),_vm._v(" "),(!_vm.captureMode && !_vm.uploadMode)?_c('b-field',{attrs:{"grouped":"","position":"is-centered"}},[_c('p',{staticClass:"control"},[_c('button',{staticClass:"button",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.captureMode = true}}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fas fa-camera"})]),_vm._v(" "),_c('span',[_vm._v("Take Pic")])])]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('button',{staticClass:"button",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.uploadMode = true}}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fas fa-cloud-upload-alt "})]),_vm._v(" "),_c('span',[_vm._v("Upload Pics")])])])]):_vm._e(),_vm._v(" "),(_vm.captureMode)?_c('div',[_c('image-capture',{on:{"save":_vm.saveCapturedImage,"cancel":function($event){_vm.captureMode = false}}})],1):_vm._e(),_vm._v(" "),(_vm.uploadMode)?_c('div',[_c('file-upload',{on:{"done":function($event){_vm.uploadMode = false}}})],1):_vm._e()],1)]),_vm._v(" "),_c('new-categories',{attrs:{"available":_vm.categoryNames},model:{value:(_vm.form.categories),callback:function ($$v) {_vm.$set(_vm.form, "categories", $$v)},expression:"form.categories"}}),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Ingredients")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.ingredientsString),expression:"ingredientsString"}],ref:"ingredients",staticClass:"textarea",attrs:{"placeholder":"One per line"},domProps:{"value":(_vm.ingredientsString)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ingredientsString=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Directions")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.directionsString),expression:"directionsString"}],ref:"directions",staticClass:"textarea",attrs:{"placeholder":"One per line"},domProps:{"value":(_vm.directionsString)},on:{"input":function($event){if($event.target.composing){ return; }_vm.directionsString=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('label',{staticClass:"label"},[_vm._v("Prep Time")]),_vm._v(" "),_c('div',{staticClass:"field is-horizontal"},[_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prepTime.days),expression:"prepTime.days"}],staticClass:"input",attrs:{"type":"number","placeholder":"days","min":"0","max":"99"},domProps:{"value":(_vm.prepTime.days)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.prepTime, "days", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prepTime.hours),expression:"prepTime.hours"}],staticClass:"input",attrs:{"type":"number","placeholder":"hours","min":"0","max":"23"},domProps:{"value":(_vm.prepTime.hours)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.prepTime, "hours", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prepTime.mins),expression:"prepTime.mins"}],staticClass:"input",attrs:{"type":"number","placeholder":"mins","min":"0","max":"59"},domProps:{"value":(_vm.prepTime.mins)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.prepTime, "mins", $event.target.value)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Servings")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.servings),expression:"form.servings"}],staticClass:"input",attrs:{"type":"number","placeholder":"#"},domProps:{"value":(_vm.form.servings)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "servings", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"field is-grouped is-grouped-centered"},[_vm._m(1),_vm._v(" "),_c('p',{staticClass:"control"},[_c('a',{staticClass:"button is-warning",on:{"click":_vm.confirmReset}},[_vm._v("\n        Reset\n      ")])]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('a',{staticClass:"button is-light",on:{"click":_vm.goBack}},[_vm._v("\n        Back\n      ")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('label',[_vm._v(" ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"control"},[_c('button',{staticClass:"button is-primary",attrs:{"type":"submit"}},[_vm._v("\n        Submit\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.b26408301512af3367b4.js